const getData = require("../../components/getData/getData");
const Vue = require("vue");
const DataTime = () => {
    Date.prototype.Format = function (fmt) {
        var o = {
            "M+": this.getMonth() + 1,                 //月份
            "d+": this.getDate(),                    //日
            "H+": this.getHours(),                   //小时
            "m+": this.getMinutes(),                 //分
            "s+": this.getSeconds(),                 //秒
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度
            "S": this.getMilliseconds()             //毫秒
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            }
        }
        return fmt;
    }
}

var S = {
    request: null,
    intervalTime: null,
    intervalOpenTime: null,
    initialization: null,
    scrollinterval: null,
    stop: true,
    lineStop: true,
    loadingWrap: true,
    backList: [],
    action: "/totaldata/action.ashx",
    loginDefautl: "/login/?e=" + +new Date()
};

var _INI_ = {

    //弹出对话框容器
    alertHtm: "<div id='myWarpr_alert'>"
        + "<table class='myLayer' cellspacing='0' cellpadding='0' border='0'>"
        + "<tbody>"
        + "<tr>"
        + "<td>"
        + "<div class='myLayerOn'></div>"
        + "<div class='myLayerTitle'><h3></h3><a href='javascript:;' class='myLayerClose' title='關閉'></a></div>"
        + "<div class='myLayerContent' style='width:auto;height:auto;'></div>"
        + "<div class='myLayerFooter'><a href='javascript:;' class='btn grayBtn myLayerCancel' title='取消'>取消</a><a href='javascript:;' class='btn hotBtn myLayerOk' title='确认'>确认</a></div><div class='myLayerLoading'></div>"
        + "</td></tr></tbody></table></div>"

};

var G = {
    alert: function (msg) {

        $("#myWarpr_alert").remove();
        $("body").append(_INI_.alertHtm);
        var myobj = $("#myWarpr_alert");
        var title = msg.title || "提示";
        var content = msg.content || "";
        var width = msg.width || "auto";
        var height = msg.height || "auto";
        var initialize = msg.initialize || false;
        var cancel = msg.cancel || false;
        var ok = msg.ok || false;
        var close = msg.close || false;
        var okVal = msg.okVal || "确认";
        var cancelVal = msg.cancelVal || "取消";
        var lock = true;
        var type = msg.type;
        myobj.find(".myLayerTitle h3").html(title);
        myobj.find(".myLayerContent").html(content);
        myobj.find(".myLayerFooter").hide();
        myobj.find(".myLayerFooter a.myLayerCancel").html(cancelVal).attr("title", cancelVal).hide();
        myobj.find(".myLayerFooter a.myLayerOk").html(okVal).attr("title", okVal).hide();

        if (lock) { //遮罩层
            $("#mymask").remove();
            $("body").append("<div class='myLayerLoading' id='mymask'></div>");
            $("#mymask").show();
        }
        if (msg.obj) {
            var obj = msg.obj;
            var elmOffset = obj.offset();
            top = "unset"; //控件top坐標
            left = "unset"; //控件left坐標
        } else {/*
            myobj.find(".myLayerOn").hide();
            myobj.find(".myLayerContent").css({ "width": width, "height": height, "overflow-y": "auto" });
            var myWidth = myobj.find(".myLayerContent").width();
            var myHieht = myobj.find(".myLayerContent").height();
            top = "unset"; //控件top坐標
            left = "unset"; //控件left坐標
            $(window).resize(function () {
                myobj.find(".myLayer").css({ "left": "unset", "top": "unset" });
                //$("#mymask").css("height", $(window).height());
            });
            */
        }
        if (type) {
            // myobj.find(".myLayer").css({ "top": "20%", "left": "40%" });
        } else {
            // myobj.find(".myLayer").css({ "top": "-32vh", "left": "0" });
        }
        window.scrollTo(0, 0);

        if (ok) {
            myobj.find(".myLayerFooter").show();
            myobj.find(".myLayerFooter a.myLayerOk").show().focus();
        }
        if (cancel) {
            myobj.find(".myLayerFooter").show();
            myobj.find(".myLayerFooter a.myLayerCancel").show();
        }
        if (initialize) {
            initialize(myobj);
        }
        myobj.find(".myLayerClose").unbind("click").click(function () {
            if (close) { close(); }
            G.alertClose();
        });
        myobj.find(".myLayerCancel").unbind("click").click(function () {
            if (close) { close(); }
            if (!cancel()) {
                G.alertClose();
            }
        });
        myobj.find(".myLayerOk").unbind("click").click(function () {
            if (ok()) { G.alertClose(); }
            if (close) { close(); }
        });
    },
    alertClose: function () {
        $("#myWarpr_alert").remove();
        $("#mymask").remove();
    },

    mask: function () {
        $("#mask-eah").remove();
        $("#myLayerImg").remove();
        $("body").append("<div class='myLayerLoading' id='mask-eah'></div>");
        $("body").append("<div class='myLayerImg' id='myLayerImg'></div>");
        $("#mask-eah").show();
    },
    maskClose: function () {
        $("#mask-eah").remove();
        $("#myLayerImg").remove();
    },
    myLayerImg: function () {
        $("#myLayerImg").remove();
        $("body").append("<div class='myLayerImg' id='myLayerImg'></div>");
    },
    myLayerImgClose: function () {
        $("#myLayerImg").remove();
    },

    isAction: function (msg) {
        for (var i = 0; i < msg.ary.length; i++) {
            if (msg.key === msg.ary[i]) {
                return true;
                break;
            }
        }
    },
    strToObj: function (str) {
        var mystr = str.split("&"), s;
        var data = ["\"__\":\"" + mystr[0] + "\""];
        for (var i = 1; i < mystr.length; i++) {
            if (mystr[i]) {
                s = mystr[i].split("=");
                data.push("\"" + s[0] + "\":\"" + s[1] + "\"");
            }
        }
        return eval("({" + data.join(",") + "})");
    },

    myTips: function (msg) {
        var content = msg.content;
        var elmOffset = msg.obj.offset();
        var _top = msg.top || 3;
        var _left = msg.left || 10;
        var top = msg.top || elmOffset.top - _top; //控件top坐標
        var left = msg.left || elmOffset.left + msg.obj.width() + _left; //控件left坐標
        var myDiv = "<div id='myxTips' style='left:" + left + "px; top:" + top + "px;'><div id='myxTipsLeft'></div><div id=''>" + content + "</div></div>";
        $("#myxTips").remove();
        $("body").append(myDiv);
        if (msg.myclick) {
            var count = 0;
            $("body").unbind("click").click(function () {
                count++;
                if (count > 1) {
                    $("#myxTips").remove();
                    $("body").unbind("click");
                }
            });
        } else {
            setTimeout(function(){
                $('#myxTips').remove()
            }, 2000);
        }
    },
    removeTips: function () {
        $("#myxTips").remove();
    },

    ajax: function (data_action, callBack, errorBack) {
        return $.ajax({
            type: "post",
            url: data_action.split("&")[0],
            cache: false,
            timeout: 1000 * 30,
            dataType: 'json',
            data: G.strToObj(data_action + "&t=" + __sysinfo.autoTid),
            success: function (msg) {
                try {
                    if (msg.error) {
                        if (msg.error == "SystemMaintenance") {
                            location.href = S.loginDefautl;
                        } else {
                            if (errorBack) errorBack();
                            G.alert({ content: msg.error, ok: function () { return true; } });
                        }
                    } else {
                        if (callBack) {
                            callBack(msg);
                        }
                    }
                } catch (e) { if (errorBack) errorBack(); }
            }, error: function () {
                if (errorBack) errorBack();
                //G.alert({ content: "Error：the options for this ajax request", ok: function () { return true; } });
            }
        });
    },

    //鼠标经过方法
    mouseover: function (str, hover) {
        var obj = $(str);
        $(obj).mouseover(function () {
            var _hover = hover || "myqhs";
            $(this).addClass(_hover).mouseout(function () {
                $(this).removeClass(_hover);
            });
        });
    },

    //Url参数替换
    urlReplace: function (msg) {
        var oUrl = msg.url || "";
        var paramName = msg.paramName || "page";
        var val = msg.val || "";
        var pad = msg.pad;
        var re = new RegExp("(/\?|&)" + paramName + "=([^&]+$)|" + paramName + "=[^&]+&", "i");
        var nUrl = oUrl.replace(re, '');
        if (pad == true) { //替换原有参数
            var _a = nUrl.indexOf("?") === -1 ? "?" : "&";
            return nUrl + _a + paramName + "=" + val;
        } else { //删除原有参数并返回
            return nUrl;
        }
    },
    //解析Url参数
    query: function (name, referrer) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var _referrer = referrer || location.href;
        var r = decodeURI(_referrer).split("?")[1].match(reg);
        if (r != null)
            return unescape(r[2]);
        return null;
    },

    //Dight 格式化浮点数 How 保留位数
    forDight: function (Dight, How) {
        Dight = Math.round(Dight * Math.pow(10, How)) / Math.pow(10, How);
        return parseFloat(Dight);
    },

    //强制保留小数 How保留位数
    toDecimal: function (Dight, How) {
        if (isNaN(parseFloat(Dight))) {
            return false;
        }
        var f = Math.round(Dight * 100) / 100;
        var s = f.toString();
        var rs = s.indexOf('.');
        if (rs < 0) {
            rs = s.length;
            s += '.';
        }
        while (s.length <= rs + How) {
            s += '0';
        }
        return s;
    },

    //写cookies
    setCookie: function (name, value) {
        var Days = 10;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    },

    //读cookies
    getCookie: function (name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return unescape(arr[2]);
        else
            return null;
    },

    //删cookies
    delCookie: function (name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = comm.getCookie(name);
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    },

    //浮点数或正整数
    DecimalSign: function (str) {
        return /^[0-9]+(\.[0-9]+)?$/.test(str);
    },

    //正整数
    NumberSign: function (str) {
        return /^[0-9]+$/.test(str);
    },

    clearNoNum: function (obj) {
        obj.val(obj.val().replace(/[^\d.]/g, "")); //清除“数字”和“.”以外的字符
        obj.val(obj.val().replace(/^\./g, "")); //验证第一个字符是数字而不是.
        obj.val(obj.val().replace(/\.{2,}/g, ".")); //只保留第一个. 清除多余的.
        obj.val(obj.val().replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')); //只能输入两个小数
        obj.val(obj.val().replace(".", "$#$").replace(/\./g, "").replace("$#$", "."));
    },

    //可带正负号的正整数
    NumberSignt: function (str) {
        return /^[+-]?[0-9]+$/.test(str);
    },

    //中文或字符串或数字
    ChznSign: function (str) {
        return /^[a-zA-Z0-9-\u4e00-\u9fa5]+$/.test(str);
    },

    //是否是英文字母或数字或_的字符串{0,50}（不允许下划线开始）
    StringSign: function (str) {
        return /^[a-z0-9A-Z][a-z0-9A-Z_]{0,50}$/.test(str);
    },

    //移除數組中的重複值
    AryMethod: function (ary) {
        var h = {};    //定义一个hash表
        var arr = [];  //定义一个临时数组
        for (var i = 0; i < ary.length; i++) {    //循环遍历当前数组
            //对元素进行判断，看是否已经存在表中，如果存在则跳过，否则存入临时数组
            if (!h[ary[i]]) {
                //存入hash表
                h[ary[i]] = true;
                //把当前数组元素存入到临时数组中
                arr.push(ary[i]);
            }
        }
        return arr;
    },

    //滾動軸DIV
    overflowDiv: function (msg) {
        var id = msg.id || +new Date();
        var height = msg.height || 280;
        var content = msg.content || "加载中...";
        return "<div id='" + id + "' style='max-height:" + height + "px; overflow-y:auto;'>" + content + "</div>";
    },

    //分页查询
    searchPage: function ($this, currentPage, totalPage) {
        var pageIndex = false;
        var id = $this.attr("id");
        var current_page = currentPage || parseInt($("#shell_pageControl .pager #currentPage").html()); //当前第几页
        var total_page = totalPage || parseInt($("#shell_pageControl .pager #totalPage").html()); //总页数
        if (id == "first" && current_page > 1) { //第一页
            pageIndex = 1;
        } else if (id == "previous" && current_page > 1) { //上一页
            pageIndex = current_page - 1;
        } else if (id == "next" && total_page > current_page) { //下一页
            pageIndex = current_page + 1;
        } else if (id == "last" && total_page > current_page) { //最后一页
            pageIndex = total_page;
        }
        return pageIndex;
    },

    //时间戳转换HH:mm:ss
    settimes: function (time) {
        if (time > 0 && G.NumberSign(time)) {
            time = parseInt(time);
            var MinutesRound = Math.floor(time / 60);
            var SecondsRound = Math.floor(time - (60 * MinutesRound));
            var Minutes = MinutesRound.toString().length <= 1 ? "0" + MinutesRound : MinutesRound;
            var Seconds = SecondsRound.toString().length <= 1 ? "0" + SecondsRound : SecondsRound;
            var strtime = Minutes + ":" + Seconds;
            return strtime;
        } else {
            return "00:00";
        }
    },
    settimer: function (time) {
        if (time > 0 && G.NumberSign(time)) {
            var days = Math.floor(time / 1440 / 60);
            var hours = Math.floor((time - days * 1440 * 60) / 3600);
            var minutes = Math.floor((time - days * 1440 * 60 - hours * 3600) / 60);
            var seconds = (time - days * 1440 * 60 - hours * 3600 - minutes * 60);
            hours = hours.toString().length == 1 ? "0" + hours : hours;
            minutes = minutes.toString().length == 1 ? "0" + minutes : minutes;
            seconds = seconds.toString().length == 1 ? "0" + seconds : seconds;
            return hours + ":" + minutes + ":" + seconds;
        } else {
            return "00:00:00";
        }
    },

    //加载条
    scrollLoad: function (msg) {
        var defaults = {
            top: msg.top || "98px",
            left: msg.left || "0",
            backColor: msg.backColor || "blue",
            width: msg.width || "0px",
            height: msg.height || "5px",
            display: msg.display || "block",
            scrollStart: msg.scrollStart || 0,
            scrollLneght: msg.scrollLneght || $(window).width() - 10,
            second: msg.second || 1,
            increase: msg.increase || 0.7,
            addDiv: msg.addDiv || "Yes"
        };
        if (defaults.addDiv == "Yes") {
            (function () {
                var newDiv = "<div class='loadScroll' id='LoadScroll'";
                newDiv += "style='";
                newDiv += "position:absolute;";
                newDiv += "top:" + defaults.top + ";";
                newDiv += "left:" + defaults.left + ";";
                newDiv += "width:" + defaults.width + ";";
                newDiv += "max-width:" + (defaults.scrollLneght - 20) + "px;";
                newDiv += "height:" + defaults.height + ";";
                newDiv += "'></div>";
                $("body").append(newDiv);
            })();
        }
        var scrollStart = defaults.scrollStart;
        var scrollLneght = defaults.scrollLneght;
        var resize;
        clearInterval(S.scrollinterval);
        S.scrollinterval = setInterval(function () {
            scrollStart = scrollStart + defaults.increase;
            scrollLneght = scrollLneght - defaults.increase;
            if (!msg.back) //递增
                $("#LoadScroll").css("width", scrollStart + "px");
            else //递减
                $("#LoadScroll").css("width", scrollLneght + "px");

            if ((!msg.back && scrollStart > defaults.scrollLneght) || (msg.back && scrollLneght < 0)) {
                clearInterval(S.scrollinterval);
                if (msg.remove) {
                    setTimeout(function () { $("#LoadScroll").remove(); }, 300);
                }
            }
        }, defaults.second);
    },
    //加载数据异常，数据回滚
    rollBack: function () {
        var scrollLneght = $("#LoadScroll").width();
        var increase = 50;
        var second = 10;
        setTimeout(function () {
            G.scrollLoad({ scrollLneght: scrollLneght, increase: increase, second: second, addDiv: "No", back: true, remove: true });
        }, 500);
    },

    //加载完成
    loadEnd: function () {
        var scrollStart = $("#LoadScroll").width();
        var increase = 90;
        G.scrollLoad({ scrollStart: scrollStart, increase: increase, addDiv: "No", remove: true });
    },

    //驗證密碼
    safety: function (pwd) {
        //判斷密碼是是否合法（合法返回True）
        var Num1 = '123456789';
        var Num2 = '987654321';
        var rex1 = /[0-9]+/g;
        var rex2 = /[a-z]+/g;
        var t_PWD = pwd;
        var PWD_Legality = true;
        var t_PWD_str = t_PWD.toLowerCase();

        var resx1 = /^[0-9]+$/g;
        if (resx1.test(t_PWD_str)) PWD_Legality = false;
        resx1 = /^[a-z]+$/g;
        if (resx1.test(t_PWD_str)) PWD_Legality = false;

        // var strs1 = t_PWD_str.match(rex1);
        // if (strs1 != null) {
        //     for (var i = 0; i < strs1.length; i++) {
        //         if (strs1[i].length > 3) {
        //             if (Num1.indexOf(strs1[i]) != -1)
        //                 PWD_Legality = false; //数字顺序
        //             if (Num2.indexOf(strs1[i]) != -1)
        //                 PWD_Legality = false; //数字倒序
        //         }
        //     }
        // }
        // strs1 = t_PWD_str.match(rex2);
        // if (strs1 != null) {
        //     if (strs1.length == 1) {
        //         if (strs1[0].length == 1)
        //             PWD_Legality = false;
        //     } //只有一个字母
        // }
        //
        // for (var i = 0; i < t_PWD_str.length - 2; i++) {
        //     if (t_PWD_str.charAt(i) == t_PWD_str.charAt(i + 1)) {
        //         if (t_PWD_str.charAt(i) == t_PWD_str.charAt(i + 2)) {
        //             PWD_Legality = false;
        //         }
        //     }
        // }



        return PWD_Legality;
    },

    //RMB显示中文
    toRmb: function (value) {
        var whole = value || $("#Credits").val(), num, dig;
        if (!/^[0-9]*[1-9][0-9]+$/.test(whole) && whole != "") return;
        if (whole.indexOf(".") == -1) {
            num = whole;
            dig = "";
        }
        else {
            num = whole.substr(0, whole.indexOf("."));
            dig = whole.substr(whole.indexOf(".") + 1, whole.length);
        }

        var i = 1;
        var len = num.length;
        var dw2 = new Array("", "萬", "億");
        var dw1 = new Array("十", "百", "千");
        var dw = new Array("", "一", "二", "三", "四", "五", "六", "七", "八", "九");
        var k1 = k2 = 0, str = "";

        for (i = 1; i <= len; i++) {
            var n = num.charAt(len - i);
            if (n == "0") {
                if (k1 != 0)
                    str = str.substr(1, str.length - 1);
            }

            str = dw[Number(n)].concat(str);

            if (len - i - 1 >= 0) {
                if (k1 != 3) {
                    str = dw1[k1].concat(str);
                    k1++;
                }
                else {
                    k1 = 0;
                    var temp = str.charAt(0);
                    if (temp == "萬" || temp == "億")
                        str = str.substr(1, str.length - 1);
                    str = dw2[k2].concat(str);
                }
            }
            if (k1 == 3)
                k2++;
        }
        if (str.length >= 2)
            if (str.substr(0, 2) == "一十") str = str.substr(1, str.length - 1);
        //document.getElementById(sName).innerHTML = str;
        return str;
    },

    //HK 3色球
    contains: function (num) {
        var red = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46];
        var blue = [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48];
        var green = [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49];
        for (var i = 0; i < red.length; i++) {
            if (red[i] == num) {
                return "red";
            }
        }
        for (var i = 0; i < blue.length; i++) {
            if (blue[i] == num) {
                return "bluer";
            }
        }
        for (var i = 0; i < green.length; i++) {
            if (green[i] == num) {
                return "green";
            }
        }
    },

    //GX 3色球
    contains_gx: function (num) {
        var red = [1, 4, 7, 10, 13, 16, 19];
        var blue = [2, 5, 8, 11, 14, 17, 20];
        var green = [3, 6, 9, 12, 15, 18, 21];
        for (var i = 0; i < red.length; i++) {
            if (red[i] == num) {
                return "red";
            }
        }
        for (var i = 0; i < blue.length; i++) {
            if (blue[i] == num) {
                return "bluer";
            }
        }
        for (var i = 0; i < green.length; i++) {
            if (green[i] == num) {
                return "green";
            }
        }
    },

    /// <summary>
    /// 复式计算，0返回总列表List、1总组数
    /// </summary>
    /// <param name="cycle">循环次数</param>
    /// <param name="ary">循环数组</param>
    /// <returns>{list:数组,count:总组数}</returns>
    DuplexSum: function (cycle, ary) {
        var list = [];
        var len = ary.length, _count = 0;
        for (var a = 0; a < len; a++) {
            var _a = a + 1;
            for (var b = _a; b < len; b++) {
                if (cycle == 2) {
                    _count++;
                    list.push(ary[a] + "," + ary[b]);
                    continue;
                }
                var _b = b + 1;
                for (var c = _b; c < len; c++) {
                    if (cycle == 3) {
                        _count++;
                        list.push(ary[a] + "," + ary[b] + "," + ary[c]);
                        continue;
                    }
                    var _c = c + 1;
                    for (var d = _c; d < len; d++) {
                        if (cycle == 4) {
                            _count++;
                            list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d]);
                            continue;
                        }
                        var _d = d + 1;
                        for (var e = _d; e < len; e++) {
                            if (cycle == 5) {
                                _count++;
                                list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e]);
                                continue;
                            }
                            var _e = e + 1;
                            for (var f = _e; f < len; f++) {
                                if (cycle == 6) {
                                    _count++;
                                    list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e] + "," + ary[f]);
                                    continue;
                                }
                                var _f = f + 1;
                                for (var g = _f; g < len; g++) {
                                    if (cycle == 7) {
                                        _count++;
                                        list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e] + "," + ary[f] + "," + ary[g]);
                                        continue;
                                    }
                                    var _g = g + 1;
                                    for (var h = _g; h < len; h++) {
                                        if (cycle == 8) {
                                            _count++;
                                            list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e] + "," + ary[f] + "," + ary[g] + "," + ary[h]);
                                            continue;
                                        }
                                        var _h = h + 1;
                                        for (var y = _h; y < len; y++) {
                                            if (cycle == 9) {
                                                _count++;
                                                list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e] + "," + ary[f] + "," + ary[g] + "," + ary[h] + "," + ary[y]);
                                                continue;
                                            }
                                            var _y = y + 1;
                                            for (var z = _y; z < len; z++) {
                                                if (cycle == 10) {
                                                    _count++;
                                                    list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e] + "," + ary[f] + "," + ary[g] + "," + ary[h] + "," + ary[y] + "," + ary[z]);
                                                    continue;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return { list: list, count: _count };
    }
};

function forceMiddle(msg) {
    var id = msg.id || +new Date();
    var title = msg.title || "";
    var title_nav = msg.titleNav || "";
    var theadAry = msg.thead || [];
    var tbodyAry = msg.tbody || [];

    if (title) {
        $("#shell_title").html(title);
    }

    if (title_nav && title_nav != "") {
        $("#shell_top").append("<div id='title-nav'>" + title_nav + "</div>");
    }

    var mythead = ["<tr>"];
    for (var i = 0; i < theadAry.length; i++) {
        mythead.push("<th>" + theadAry[i] + "</th>");
    }
    mythead.push("</tr>");
    if (msg.eachThead) {
        mythead = [msg.eachThead];
    }

    var fonDiv = "";
    if (msg.fonDiv) {
        fonDiv = "<div id='fondiv' style='text-align:center;padding:5px 0;margin-top:2px;' class='bc'><a href='javascript:void(0);'>點擊獲取更多...</a><span id='nodataTitle' class='hiden'>無數據加載！</span></div>";
    }
    return "<div id='" + id + "'><table class='middle-table'><thead>" + mythead.join("") + "</thead><tbody>" + tbodyAry.join("") + "</tbody></table>" + fonDiv + "</div>";
}

function pageMiddle(msg, callBack) {
    var currentPage = msg.currentPage || 0;
    var totalPage = msg.totalPage || 0;
    var middle = "<div id='shell_pageControl'><div class='pager' id='data-page'>"
        + "<span class='first cursor' id='first'>首页</span>"
        + "<span class='previous cursor' id='previous'>上一页</span>"
        + "<span class='current_page'>第<b id='currentPage'>" + currentPage + "</b>页</span>"
        + "<span class='total_page'>共<b class='total' id='totalPage'>" + totalPage + "</b>页</span>"
        + "<span class='next cursor' id='next'>下一页</span>"
        + "<span class='last cursor' id='last'>尾页</span>"
        + "</div></div>";
    if (msg.obj) {
        if ($("#data-page").length == 0) {
            msg.obj.html(middle);
        }
        msg.obj.html(middle);
        //绑定分页事件
        $("#data-page span.cursor").unbind("click").click(function () {
            var page = G.searchPage($(this));
            if (page && callBack) {
                if (callBack) {
                    callBack(G.urlReplace({ url: "?" + msg.referrer, paramName: "page", val: page, pad: true }).replace("?", ""));
                }
            }
        });
    }
}
//模拟测速
function SelectBoxSet(n) {

    var data = __sysinfo.ipJoin || __sysinfo.data.ipJson;;
    for (var k = 0; k < data.length; k++) {
        ping({
            url: data[k], beforePing: function (index) {
                $("#lineching input[type='text']").eq(index).val("测速中");
            }, afterPing: function (index, time) {
                var t = "";
                if (time < 200) {
                    t = "超好";
                } else if (time < 500) {
                    t = "较好";
                } else if (time >= 2000) {
                    t = "超时";
                } else {
                    t = time + "毫秒";
                }
                $("#lineching input[type='text']").eq(index).val(t);

            }, interval: 1, idx: k
        })
    }


}

function ping(option) {
    var time, requestTime, responseTime;
    var getUrl = function (url) {    //保证url带http://
        var strReg = "^((https|http)?://){1}"
        var re = new RegExp(strReg);
        return re.test(url) ? url : "http://" + url;
    }
    $.ajax({
        url: getUrl(option.url) + '/netTest/?date=' + (new Date()).getTime(),  //设置一个空的ajax请求
        type: 'GET',
        dataType: 'json',
        timeout: 3000,
        beforeSend: function () {
            if (option.beforePing) option.beforePing(option.idx);
            requestTime = new Date().getTime();
        },
        complete: function (json) {
            responseTime = new Date().getTime();
            time = Math.abs(requestTime - responseTime);
            if (option.afterPing) option.afterPing(option.idx, time);
        }
    });



}



function peishuquanzhuan(category, peiNumArr, dw5zi, qz) {

    category = parseInt(category);
    var createNumberArr = [];
    var numPosArr = getQuickNumPosArr(category, dw5zi);
    var permutations = getQuickPermutations(category);

    var buildNumber = function (depth, selectedValues, selectedIndexes) {
        if (depth == category) {
            for (var n = 0; n < numPosArr.length; n++) {
                var posArr = numPosArr[n];
                for (var p = 0; p < permutations.length; p++) {
                    var number = ['X', 'X', 'X', 'X', 'X'];
                    for (var k = 0; k < category; k++) {
                        number[posArr[k]] = selectedValues[permutations[p][k]];
                    }
                    var numberText = number.join("");
                    if (createNumberArr.indexOf(numberText) == -1) createNumberArr.push(numberText);
                }
            }
            return;
        }

        for (var i = 0; i < peiNumArr[depth].length; i++) {
            if (qz && selectedIndexes.indexOf(i) != -1) continue;
            buildNumber(depth + 1, selectedValues.concat(peiNumArr[depth][i]), selectedIndexes.concat(i));
        }
    };

    buildNumber(0, [], []);
    return createNumberArr;
}

function dwcreatenumber(category, posNumArr, numPos) {

    var createNumberArr = [];
    if (category == 2) {
        for (var i = 0; i < posNumArr[numPos[0]].length; i++) {
            for (var n = 0; n < posNumArr[numPos[1]].length; n++) {
                var number = ['X', 'X', 'X', 'X', 'X'];
                number[numPos[0]] = posNumArr[numPos[0]][i];
                number[numPos[1]] = posNumArr[numPos[1]][n];
                if (createNumberArr.indexOf(number.join("")) == -1)
                    createNumberArr.push(number.join(""));
            }
        }
    } else if (category == 3) {
        for (var i = 0; i < posNumArr[numPos[0]].length; i++) {
            for (var n = 0; n < posNumArr[numPos[1]].length; n++) {
                for (var n2 = 0; n2 < posNumArr[numPos[2]].length; n2++) {
                    var number = ['X', 'X', 'X', 'X', 'X'];
                    number[numPos[0]] = posNumArr[numPos[0]][i];
                    number[numPos[1]] = posNumArr[numPos[1]][n];
                    number[numPos[2]] = posNumArr[numPos[2]][n2];
                    if (createNumberArr.indexOf(number.join("")) == -1)
                        createNumberArr.push(number.join(""));
                }
            }
        }
    } else if (category == 4) {
        for (var i = 0; i < posNumArr[numPos[0]].length; i++) {
            for (var n = 0; n < posNumArr[numPos[1]].length; n++) {
                for (var n2 = 0; n2 < posNumArr[numPos[2]].length; n2++) {
                    for (var n3 = 0; n3 < posNumArr[numPos[3]].length; n3++) {
                        var number = ['X', 'X', 'X', 'X', 'X'];
                        number[numPos[0]] = posNumArr[numPos[0]][i];
                        number[numPos[1]] = posNumArr[numPos[1]][n];
                        number[numPos[2]] = posNumArr[numPos[2]][n2];
                        number[numPos[3]] = posNumArr[numPos[3]][n3];
                        if (createNumberArr.indexOf(number.join("")) == -1)
                            createNumberArr.push(number.join(""));
                    }
                }
            }
        }
    }
    return createNumberArr;
}

function brother(number) {

    var tmpNumber = [];
    for (var n = 0; n < number.length; n++) {
        if (number[n] != 'X') tmpNumber.push(number[n]);
    }
    tmpNumber = tmpNumber.sort();
    var quchong = [];
    for (var n2 = 0; n2 < tmpNumber.length; n2++) {
        if (quchong.indexOf(tmpNumber[n2]) == -1) quchong.push(tmpNumber[n2]);
    }

    tmpNumber = quchong;

    var count = 0;//9810 0459
    for (var n = 1; n < tmpNumber.length; n++) {
        if (tmpNumber[n] - tmpNumber[n - 1] == 1) count++;
        else if (count > 0) break;
    }

    if ((tmpNumber.length == 2 || tmpNumber.length == 3) && (tmpNumber[tmpNumber.length - 1] - tmpNumber[0] == 9)) {
        count++;
    } else if (tmpNumber.length == 4) {
        if (tmpNumber.join("") == "0189") count = 3;
        else if (count == 0 && tmpNumber[tmpNumber.length - 1] - tmpNumber[0] == 9) count = 1;
        else if (tmpNumber[tmpNumber.length - 1] - tmpNumber[0] == 9 && (tmpNumber[1] - tmpNumber[0] == 1 || tmpNumber[3] - tmpNumber[2] == 1)) count++;
    }


    return count + 1;

}

function chong(number) {

    number = number.replace(/X/g, "");
    var tmpNumber = {};
    for (var i = 0; i < number.length; i++) {
        if (tmpNumber[number[i]]) {
            tmpNumber[number[i]]++;
        } else {
            tmpNumber[number[i]] = 1;
        }
    }

    var count = 0;
    var ssc = 0;
    for (var key in tmpNumber) {
        if (tmpNumber[key] > count) count = tmpNumber[key];
        if (tmpNumber[key] == 2) ssc++;
    }

    if (ssc == 2) return 5;

    return count;


}

function getNumbersByCategory(category, dw5zi) {
    var numPosArr = getQuickNumPosArr(category, dw5zi);
    var allNumberArr = [];
    for (var i = 0; i < numPosArr.length; i++) {
        var allPeiNumArr = [];
        var posArr = numPosArr[i];
        for (var n = 0; n < posArr.length; n++) {
            allPeiNumArr[posArr[n]] = "0123456789";
        }

        allNumberArr = allNumberArr.concat(dwcreatenumber(category, allPeiNumArr, posArr));

    }
    return allNumberArr;
}


//集合去掉重复
Array.prototype.uniquelize = function () {
    var tmp = {},
        ret = [];
    for (var i = 0, j = this.length; i < j; i++) {
        if (!tmp[this[i]]) {
            tmp[this[i]] = 1;
            ret.push(this[i]);
        }
    }

    return ret;
}

///集合取交集
Array.intersect = function () {
    var result = new Array();
    var obj = {};
    for (var i = 0; i < arguments.length; i++) {
        for (var j = 0; j < arguments[i].length; j++) {
            var str = arguments[i][j];
            if (!obj[str]) {
                obj[str] = 1;
            }
            else {
                obj[str]++;
                if (obj[str] == arguments.length) {
                    result.push(str);
                }
            }//end else
        }//end for j
    }//end for i
    return result;
}

//2个集合的差集 在arr不存在
Array.prototype.minus = function (arr) {
    var result = new Array();
    var obj = {};
    for (var i = 0; i < arr.length; i++) {
        obj[arr[i]] = 1;
    }
    for (var j = 0; j < this.length; j++) {
        if (!obj[this[j]]) {
            obj[this[j]] = 1;
            result.push(this[j]);
        }
    }
    return result;
};

//并集
Array.union = function () {
    var arr = new Array();
    var obj = {};
    for (var i = 0; i < arguments.length; i++) {
        for (var j = 0; j < arguments[i].length; j++) {
            var str = arguments[i][j];
            if (!obj[str]) {
                obj[str] = 1;
                arr.push(str);
            }
        }//end for j
    }//end for i
    return arr;
}

const soundSwitch = () => {
    //开奖声音
}
//12生肖排列
const animalsSort = (animalsIndex) => {
    var index = animalsIndex - 1;
    var num = [];
    num.push("1,13,25,37,49");
    num.push("12,24,36,48");
    num.push("11,23,35,47");
    num.push("10,22,34,46");
    num.push("9,21,33,45");
    num.push("8,20,32,44");
    num.push("7,19,31,43");
    num.push("6,18,30,42");
    num.push("5,17,29,41");
    num.push("4,16,28,40");
    num.push("3,15,27,39");
    num.push("2,14,26,38");
    for (var i = 0; i < 12; i++) {
        __sysinfo.animalsAry[index + 1] = num[i];
        index++;
        index = index > 11 ? 0 : index;
    }
    __sysinfo.animalsAry[13] = "1,2,7,8,12,13,18,19,23,24,29,30,34,35,40,45,46"; //红波
    __sysinfo.animalsAry[14] = "1,7,13,19,23,29,35,45"; //红单
    __sysinfo.animalsAry[15] = "2,8,12,18,24,30,34,40,46"; //红双
    __sysinfo.animalsAry[16] = "29,30,34,35,40,45,46"; //红大
    __sysinfo.animalsAry[17] = "1,2,7,8,12,13,18,19,23,24"; //红小
    __sysinfo.animalsAry[18] = "29,35,45"; //大单
    __sysinfo.animalsAry[19] = "30,34,40,46"; //大双
    __sysinfo.animalsAry[20] = "1,7,13,19,23"; //小单
    __sysinfo.animalsAry[21] = "2,8,12,18,24"; //小双
    __sysinfo.animalsAry[22] = "3,4,9,10,14,15,20,25,26,31,36,37,41,42,47,48"; //蓝波
    __sysinfo.animalsAry[23] = "3,9,15,25,31,37,41,47"; //蓝单
    __sysinfo.animalsAry[24] = "4,10,14,20,26,36,42,48"; //蓝双
    __sysinfo.animalsAry[25] = "25,26,31,36,37,41,42,47,48"; //蓝大
    __sysinfo.animalsAry[26] = "3,4,9,10,14,15,20"; //蓝小
    __sysinfo.animalsAry[27] = "25,31,37,41,47"; //大单
    __sysinfo.animalsAry[28] = "26,36,42,48"; //大双
    __sysinfo.animalsAry[29] = "3,9,15"; //小单
    __sysinfo.animalsAry[30] = "4,10,14,20"; //小双
    __sysinfo.animalsAry[31] = "5,6,11,16,17,21,22,27,28,32,33,38,39,43,44,49"; //绿波
    __sysinfo.animalsAry[32] = "5,11,17,21,27,33,39,43,49"; //绿单
    __sysinfo.animalsAry[33] = "6,16,22,28,32,38,44"; //绿双
    __sysinfo.animalsAry[34] = "27,28,32,33,38,39,43,44,49"; //绿大
    __sysinfo.animalsAry[35] = "5,6,11,16,17,21,22"; //绿小
    __sysinfo.animalsAry[36] = "27,33,39,43,49"; //大单
    __sysinfo.animalsAry[37] = "28,32,38,44"; //大双
    __sysinfo.animalsAry[38] = "5,11,17,21"; //小单
    __sysinfo.animalsAry[39] = "6,16,22"; //小双
    __sysinfo.animalsAry[40] = "115,124,133"; //红蓝绿波
    __sysinfo.animalsAry[41] = "116,125,134"; //单
    __sysinfo.animalsAry[42] = "117,126,135"; //双
    __sysinfo.animalsAry[43] = "118,127,136"; //大
    __sysinfo.animalsAry[44] = "119,128,137"; //小
    __sysinfo.animalsAry[45] = "120,129,138"; //大单
    __sysinfo.animalsAry[46] = "121,130,139"; //大双
    __sysinfo.animalsAry[47] = "122,131,140"; //小单
    __sysinfo.animalsAry[48] = "123,132,141"; //小双
    __sysinfo.animalsAry[49] = "1,2,3,4,5,6,7,8,9"; //0头
    __sysinfo.animalsAry[50] = "10,11,12,13,14,15,16,17,18,19"; //1头
    __sysinfo.animalsAry[51] = "20,21,22,23,24,25,26,27,28,29"; //2头
    __sysinfo.animalsAry[52] = "30,31,32,33,34,35,36,37,38,39"; //3头
    __sysinfo.animalsAry[53] = "40,41,42,43,44,45,46,47,48,49"; //4头
    __sysinfo.animalsAry[54] = "10,20,30,40"; //0尾
    __sysinfo.animalsAry[55] = "1,11,21,31,41"; //1尾
    __sysinfo.animalsAry[56] = "2,12,22,32,42"; //2尾
    __sysinfo.animalsAry[57] = "3,13,23,33,43"; //3尾
    __sysinfo.animalsAry[58] = "4,14,24,34,44"; //4尾
    __sysinfo.animalsAry[59] = "5,15,25,35,45"; //5尾
    __sysinfo.animalsAry[60] = "6,16,26,36,46"; //6尾
    __sysinfo.animalsAry[61] = "7,17,27,37,47"; //7尾
    __sysinfo.animalsAry[62] = "8,18,28,38,48"; //8尾
    __sysinfo.animalsAry[63] = "9,19,29,39,49"; //9尾
}

const FormatTs = (gameIndex, SortID) => {
    var str = "";
    switch (gameIndex) {
        case 1: str = FormatTsHK(SortID); break;
        case 2: str = FormatTsKLC(SortID); break;
        case 15:
        case 3: str = FormatTsSSC(SortID); break;
        case 4:
        case 8: str = FormatTsPK(SortID); break;
        case 5: str = FormatTsKS(SortID); break;
        case 6: str = FormatTsKLB(SortID); break;
        case 7: str = FormatTsNC(SortID); break;
        case 10: str = FormatTsGX(SortID); break;
        //case 13: str = FormatTsQXC(SortID); break;
        case 13: str = FormatTsGXKS(SortID); break;
        case 14: str = FormatTsPKJS(SortID); break;
    }
    return str;
}

/// <summary>
/// 格式化彩种
/// </summary>
/// <returns></returns>
const FormatDetailsType = (DetailsType) => {
    var str = "";
    switch (DetailsType) {
        case 1: str = "香港樂透(HK)"; break;
        case 2: str = "廣東快樂十分"; break;
        case 3: str = "河内5分彩"; break;
        case 15: str = "极速時時彩"; break;
        case 4: str = "北京赛车(PK10)"; break;
        case 14: str = "极速賽車"; break;
        case 5: str = "江蘇骰寶(快3)"; break;
        case 6: str = "北京快樂8"; break;
        case 7: str = "重慶幸運農場"; break;
        case 10: str = "廣西快樂十分"; break;
        case 13: str = "體彩七星彩"; break;
    }
    return str;
}

/// <summary>
/// 格式化退水盘，索引转换字符串（六合彩）
/// </summary>
/// <param name="sortId"></param>
/// <returns></returns>
const FormatTsHK = (sortId) => {
    var str = "";
    switch (sortId) {
        case 1: str = "特碼A"; break;
        case 2: str = "特碼B"; break;
        case 3: str = "特碼單雙"; break;
        case 4: str = "特碼大小"; break;
        case 5: str = "特碼合單雙"; break;
        case 6: str = "特碼合大小"; break;
        case 7: str = "特碼尾大小"; break;
        case 8: str = "特碼大單雙"; break;
        case 9: str = "特碼小單雙"; break;
        case 10: str = "特碼家禽野獸"; break;
        case 11: str = "特碼生肖"; break;
        case 12: str = "特碼2肖"; break;
        case 13: str = "特碼3肖"; break;
        case 14: str = "特碼4肖"; break;
        case 15: str = "特碼5肖"; break;
        case 16: str = "特碼6肖"; break;
        case 17: str = "特碼色波"; break;
        case 18: str = "特碼半波"; break;
        case 19: str = "特碼半半波"; break;
        case 20: str = "特碼頭數"; break;
        case 21: str = "特碼尾數"; break;
        case 22: str = "特碼五行"; break;
        case 23: str = "正碼特1-6"; break;
        case 24: str = "正碼1-6單雙"; break;
        case 25: str = "正碼1-6大小"; break;
        case 26: str = "正碼1-6合單雙"; break;
        case 27: str = "正碼1-6色波"; break;
        case 28: str = "正碼A"; break;
        case 29: str = "正碼B"; break;
        case 30: str = "總和單雙"; break;
        case 31: str = "總和大小"; break;
        case 32: str = "平特一肖"; break;
        case 33: str = "平特尾數"; break;
        case 34: str = "正肖"; break;
        case 35: str = "七色波-色波"; break;
        case 36: str = "七色波-和局"; break;
        case 37: str = "總肖2-7"; break;
        case 38: str = "總肖單雙"; break;
        case 39: str = "二全中"; break;
        case 40: str = "三全中"; break;
        case 41: str = "三中二"; break;
        case 42: str = "二中特"; break;
        case 43: str = "特串"; break;
        case 44: str = "四全中"; break;
        case 45: str = "二連肖"; break;
        case 46: str = "三連肖"; break;
        case 47: str = "四連肖"; break;
        case 48: str = "五連肖"; break;
        case 49: str = "二連尾"; break;
        case 50: str = "三連尾"; break;
        case 51: str = "四連尾"; break;
        case 52: str = "五不中"; break;
        case 53: str = "六不中"; break;
        case 54: str = "七不中"; break;
        case 55: str = "八不中"; break;
        case 56: str = "九不中"; break;
        case 57: str = "十不中"; break;
    }
    return str;
}

/// <summary>
/// 格式化退水盘，索引转换字符串（廣東快樂十分）
/// </summary>
/// <param name="sortId"></param>
/// <returns></returns>
const FormatTsKLC = (sortId) => {
    var str = "";
    switch (sortId) {
        case 1: str = "1-8單碼"; break;
        case 2: str = "1-8兩面"; break;
        case 3: str = "1-8方位"; break;
        case 4: str = "1-8中發白"; break;
        case 5: str = "1-4龍虎"; break;
        case 6: str = "正碼"; break;
        case 7: str = "總和兩面"; break;
        case 8: str = "任選二"; break;
        case 9: str = "選二連直"; break;
        case 10: str = "選二連組"; break;
        case 11: str = "任選三"; break;
        case 12: str = "選三前組"; break;
        case 13: str = "任選四"; break;
        case 14: str = "任選五"; break;
    }
    return str;
}

/// <summary>
/// 格式化退水盘，索引转换字符串（重慶時時彩）
/// </summary>
/// <param name="sortId"></param>
/// <returns></returns>
const FormatTsSSC = (sortId) => {
    var str = "";
    switch (sortId) {
        case 1: str = "1-5單碼"; break;
        case 2: str = "兩面"; break;
        case 3: str = "龍虎"; break;
        case 4: str = "和"; break;
        case 5: str = "豹子"; break;
        case 6: str = "順子"; break;
        case 7: str = "對子"; break;
        case 8: str = "半順"; break;
        case 9: str = "雜六"; break;
        case 10: str = "牛牛1-9"; break;
        case 11: str = "無牛"; break;
        case 12: str = "牛單雙"; break;
        case 13: str = "牛大小"; break;
    }
    return str;
}

/// <summary>
/// 格式化退水盘，索引转换字符串（北京賽車PK10）
/// </summary>
/// <param name="sortId"></param>
/// <returns></returns>
const FormatTsPK = (sortId) => {
    var str = "";
    switch (sortId) {
        case 1: str = "1-10單碼"; break;
        case 2: str = "1-10兩面"; break;
        case 3: str = "1-5龍虎"; break;
        case 4: str = "冠亞和大小"; break;
        case 5: str = "冠亞和單雙"; break;
        case 6: str = "冠亞和"; break;
    }
    return str;
}


/// <summary>
/// 格式化退水盘，索引转换字符串（极速賽車）
/// </summary>
/// <param name="sortId"></param>
/// <returns></returns>
const FormatTsPKJS = (sortId) => {
    var str = "";
    switch (sortId) {
        case 1: str = "1-10单码"; break;
        case 2: str = "1-10两面"; break;
        case 3: str = "1-5龙虎"; break;
        case 4: str = "冠亚和大小"; break;
        case 5: str = "冠亚和单双"; break;
        case 6: str = "冠亚和"; break;
    }
    return str;
}


/// <summary>
/// 格式化退水盘，索引转换字符串（江蘇快3）
/// </summary>
/// <param name="sortId"></param>
/// <returns></returns>
const FormatTsKS = (sortId) => {
    var str = "";
    switch (sortId) {
        case 1: str = "大小"; break;
        case 2: str = "三軍"; break;
        case 3: str = "圍骰"; break;
        case 4: str = "全骰"; break;
        case 5: str = "點數"; break;
        case 6: str = "長牌"; break;
        case 7: str = "短牌"; break;
    }
    return str;
}

/// <summary>
/// 格式化退水盘，索引转换字符串（北京快樂8）
/// </summary>
/// <param name="sortId"></param>
/// <returns></returns>
const FormatTsKLB = (sortId) => {
    var str = "";
    switch (sortId) {
        case 1: str = "正碼"; break;
        case 2: str = "總和大小"; break;
        case 3: str = "總和單雙"; break;
        case 4: str = "總和和局"; break;
        case 5: str = "總和過關"; break;
        case 6: str = "前後和"; break;
        case 7: str = "單雙和"; break;
        case 8: str = "五行"; break;
    }
    return str;
}

/// <summary>
/// 格式化退水盘，索引转换字符串（幸運農場）
/// </summary>
/// <param name="sortId"></param>
/// <returns></returns>
const FormatTsNC = (sortId) => {
    var str = "";
    switch (sortId) {
        case 1: str = "1-8單碼"; break;
        case 2: str = "1-8兩面"; break;
        case 3: str = "1-8東南西北"; break;
        case 4: str = "1-8中發白"; break;
        case 5: str = "1-4龍虎"; break;
        case 6: str = "正碼"; break;
        case 7: str = "總和兩面"; break;
        case 8: str = "任選二"; break;
        case 9: str = "選二連直"; break;
        case 10: str = "選二連組"; break;
        case 11: str = "任選三"; break;
        case 12: str = "選三前組"; break;
        case 13: str = "任選四"; break;
        case 14: str = "任選五"; break;
    }
    return str;
}

/// <summary>
/// 格式化退水盘，索引转换字符串（广西快乐十分）
/// </summary>
/// <param name="sortId"></param>
/// <returns></returns>
const FormatTsGX = (sortId) => {
    var str = "";
    switch (sortId) {
        case 1: str = "1-5單碼"; break;
        case 2: str = "1-5兩面"; break;
        case 3: str = "1-5福祿壽喜"; break;
        case 4: str = "1-5色波"; break;
        case 5: str = "正碼"; break;
        case 6: str = "總和、龍虎"; break;
    }
    return str;
}

/// <summary>
/// 格式化退水盘，索引转换字符串（七星彩）
/// </summary>
/// <param name="sortId"></param>
/// <returns></returns>
const FormatTsQXC = (sortId) => {
    var str = "";
    switch (sortId) {
        case 1: str = "一字"; break;
        case 2: str = "二字"; break;
        case 3: str = "三字"; break;
        case 4: str = "四字"; break;
        case 5: str = "一定位"; break;
        case 6: str = "二定位"; break;
        case 7: str = "三定位"; break;
        case 8: str = "四定位"; break;
        case 9: str = "一定位單雙"; break;
        case 10: str = "一定位大小"; break;
        case 11: str = "二定位單雙"; break;
        case 12: str = "二定位大小"; break;
    }
    return str;
}

/// <summary>
/// 格式化退水盘，索引转换字符串（广西快3）
/// </summary>
/// <param name="sortId"></param>
/// <returns></returns>
const FormatTsGXKS = (sortId) => {

    var str = "";
    switch (sortId) {
        case 1: str = "大小"; break;
        case 2: str = "三軍"; break;
        case 3: str = "圍骰"; break;
        case 4: str = "全骰"; break;
        case 5: str = "點數"; break;
        case 6: str = "長牌"; break;
        case 7: str = "短牌"; break;
    }
    return str;

}

/*HK匹配*/
const _num1 = (sortId) => {
    var Details1 = "";
    if (sortId >= 50 && sortId <= 65)
        Details1 = "特碼";
    else if (sortId >= 1 && sortId <= 49)
        Details1 = "特碼A";
    else if (sortId >= 66 && sortId <= 114)
        Details1 = "特碼B";
    else if (sortId >= 115 && sortId <= 141)
        Details1 = "特碼色波";
    else if (sortId >= 142 && sortId <= 153)
        Details1 = "特碼生肖";
    else if (sortId == 154)
        Details1 = "6肖";
    else if (sortId == 676)
        Details1 = "5肖";
    else if (sortId == 677)
        Details1 = "4肖";
    else if (sortId == 678)
        Details1 = "3肖";
    else if (sortId == 679)
        Details1 = "2肖";
    else if (sortId >= 155 && sortId <= 159)
        Details1 = "特碼頭數";
    else if (sortId >= 160 && sortId <= 169)
        Details1 = "特碼尾數";
    else if (sortId >= 170 && sortId <= 218)
        Details1 = "正碼A";
    else if (sortId >= 219 && sortId <= 222)
        Details1 = "總和";
    else if (sortId >= 223 && sortId <= 271) {
        Details1 = "正一特";
    }
    else if (sortId >= 281 && sortId <= 329) {
        Details1 = "正二特";
    }
    else if (sortId >= 339 && sortId <= 387) {
        Details1 = "正三特";
    }
    else if (sortId >= 397 && sortId <= 445) {
        Details1 = "正四特";
    }
    else if (sortId >= 455 && sortId <= 503) {
        Details1 = "正五特";
    }
    else if (sortId >= 513 && sortId <= 561) {
        Details1 = "正六特";
    }
    else if (sortId >= 272 && sortId <= 280) {
        Details1 = "正一";
    }
    else if (sortId >= 330 && sortId <= 338) {
        Details1 = "正二";
    }
    else if (sortId >= 388 && sortId <= 396) {
        Details1 = "正三";
    }
    else if (sortId >= 446 && sortId <= 454) {
        Details1 = "正四";
    }
    else if (sortId >= 504 && sortId <= 512) {
        Details1 = "正五";
    }
    else if (sortId >= 562 && sortId <= 570) {
        Details1 = "正六";
    }
    else if (sortId >= 571 && sortId <= 582) {
        Details1 = "平特一肖";
    }
    else if (sortId >= 583 && sortId <= 592) {
        Details1 = "平特尾數";
    }
    else if (sortId >= 593 && sortId <= 604) {
        Details1 = "正肖";
    }
    else if (sortId >= 605 && sortId <= 608) {
        Details1 = "七色波";
    }
    else if (sortId >= 610 && sortId <= 621) {
        Details1 = "二連肖";
    }
    else if (sortId >= 622 && sortId <= 633) {
        Details1 = "三連肖";
    }
    else if (sortId >= 634 && sortId <= 645) {
        Details1 = "四連肖";
    }
    else if (sortId >= 1187 && sortId <= 1198) {
        Details1 = "五連肖";
    }
    else if (sortId >= 646 && sortId <= 655) {
        Details1 = "二連尾";
    }
    else if (sortId >= 656 && sortId <= 665) {
        Details1 = "三連尾";
    }
    else if (sortId >= 666 && sortId <= 675) {
        Details1 = "四連尾";
    }
    else if (sortId >= 1199 && sortId <= 1208) {
        Details1 = "五連尾";
    }
    else if (sortId >= 684 && sortId <= 732)
        Details1 = "五不中";
    else if (sortId >= 1199 && sortId <= 1247)
        Details1 = "六不中";
    else if (sortId >= 1248 && sortId <= 1296)
        Details1 = "七不中";
    else if (sortId >= 1297 && sortId <= 1345)
        Details1 = "八不中";
    else if (sortId >= 1346 && sortId <= 1394)
        Details1 = "九不中";
    else if (sortId >= 1395 && sortId <= 1443)
        Details1 = "十不中";
    else if (sortId >= 733 && sortId <= 740)
        Details1 = "總肖";
    else if (sortId >= 741 && sortId <= 745)
        Details1 = "五行";
    else if (sortId >= 746 && sortId <= 794)
        Details1 = "二全中";
    else if (sortId >= 795 && sortId <= 843)
        Details1 = "三全中";
    else if (sortId >= 844 && sortId <= 941)
        Details1 = "三中二";
    else if (sortId >= 942 && sortId <= 1039)
        Details1 = "二中特";
    else if (sortId >= 1040 && sortId <= 1088)
        Details1 = "特串";
    else if (sortId >= 1089 && sortId <= 1137)
        Details1 = "四全中";
    else if (sortId >= 1138 && sortId <= 1186)
        Details1 = "正碼B";
    return Details1;
}
const _num2 = (sortId) => {
    var str = "-1";
    if (sortId >= 1 && sortId <= 49)//1-49号码(特碼A)
    {
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 66 && sortId <= 114)//1-49号码(特碼B)
    {
        sortId = sortId - 65;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 170 && sortId <= 218)//正碼A
    {
        sortId = sortId - 169;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 223 && sortId <= 271)//正1特
    {
        sortId = sortId - 222;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 281 && sortId <= 329)//正2特
    {
        sortId = sortId - 280;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 339 && sortId <= 387)//正3特
    {
        sortId = sortId - 338;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 397 && sortId <= 445)//正4特
    {
        sortId = sortId - 396;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 455 && sortId <= 503)//正5特
    {
        sortId = sortId - 454;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 513 && sortId <= 561)//正6特
    {
        sortId = sortId - 512;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 684 && sortId <= 732) //5不中
    {
        sortId = sortId - 683;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 1199 && sortId <= 1247) //6不中
    {
        sortId = sortId - 1198;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 1248 && sortId <= 1296) //7不中
    {
        sortId = sortId - 1247;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 1297 && sortId <= 1345) //8不中
    {
        sortId = sortId - 1296;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 1346 && sortId <= 1394) //9不中
    {
        sortId = sortId - 1345;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 1395 && sortId <= 1443) //10不中
    {
        sortId = sortId - 1394;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 1138 && sortId <= 1186)//正碼B
    {
        sortId = sortId - 1137;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 746 && sortId <= 794)//2全中
    {
        sortId = sortId - 745;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 795 && sortId <= 843)//3全中
    {
        sortId = sortId - 794;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 844 && sortId <= 892)//3中2
    {
        sortId = sortId - 843;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 942 && sortId <= 990)//2中特
    {
        sortId = sortId - 941;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 1040 && sortId <= 1088)//特串
    {
        sortId = sortId - 1039;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 1089 && sortId <= 1137)//4全中
    {
        sortId = sortId - 1088;
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else {
        switch (sortId) {
            case 50: str = "單"; break;
            case 51: str = "雙"; break;
            case 52: str = "大"; break;
            case 53: str = "小"; break;
            case 54: str = "合單"; break;
            case 55: str = "合雙"; break;
            case 56: str = "合大"; break;
            case 57: str = "合小"; break;
            case 58: str = "尾大"; break;
            case 59: str = "尾小"; break;
            case 60: str = "大單"; break;
            case 61: str = "大雙"; break;
            case 62: str = "小單"; break;
            case 63: str = "小雙"; break;
            case 64: str = "家禽"; break;
            case 65: str = "野獸"; break;
            case 115: str = "紅波"; break;
            case 116: str = "紅單"; break;
            case 117: str = "紅雙"; break;
            case 118: str = "紅大"; break;
            case 119: str = "紅小"; break;
            case 120: str = "紅大單"; break;
            case 121: str = "紅大雙"; break;
            case 122: str = "紅小單"; break;
            case 123: str = "紅小雙"; break;
            case 124: str = "藍波"; break;
            case 125: str = "藍單"; break;
            case 126: str = "藍雙"; break;
            case 127: str = "藍大"; break;
            case 128: str = "藍小"; break;
            case 129: str = "藍大單"; break;
            case 130: str = "藍大雙"; break;
            case 131: str = "藍小單"; break;
            case 132: str = "藍小雙"; break;
            case 133: str = "綠波"; break;
            case 134: str = "綠單"; break;
            case 135: str = "綠雙"; break;
            case 136: str = "綠大"; break;
            case 137: str = "綠小"; break;
            case 138: str = "綠大單"; break;
            case 139: str = "綠大雙"; break;
            case 140: str = "綠小單"; break;
            case 141: str = "綠小雙"; break;
            case 142: str = "鼠"; break;
            case 143: str = "牛"; break;
            case 144: str = "虎"; break;
            case 145: str = "兔"; break;
            case 146: str = "龍"; break;
            case 147: str = "蛇"; break;
            case 148: str = "馬"; break;
            case 149: str = "羊"; break;
            case 150: str = "猴"; break;
            case 151: str = "雞"; break;
            case 152: str = "狗"; break;
            case 153: str = "猪"; break;
            case 155: str = "0頭"; break;
            case 156: str = "1頭"; break;
            case 157: str = "2頭"; break;
            case 158: str = "3頭"; break;
            case 159: str = "4頭"; break;
            case 160: str = "0尾"; break;
            case 161: str = "1尾"; break;
            case 162: str = "2尾"; break;
            case 163: str = "3尾"; break;
            case 164: str = "4尾"; break;
            case 165: str = "5尾"; break;
            case 166: str = "6尾"; break;
            case 167: str = "7尾"; break;
            case 168: str = "8尾"; break;
            case 169: str = "9尾"; break;
            case 219: str = "單"; break;
            case 220: str = "雙"; break;
            case 221: str = "大"; break;
            case 222: str = "小"; break;
            case 272:
            case 330:
            case 388:
            case 446:
            case 504:
            case 562: str = "單"; break;
            case 273:
            case 331:
            case 389:
            case 447:
            case 505:
            case 563: str = "雙"; break;
            case 274:
            case 332:
            case 390:
            case 448:
            case 506:
            case 564: str = "大"; break;
            case 275:
            case 333:
            case 391:
            case 449:
            case 507:
            case 565: str = "小"; break;
            case 276:
            case 334:
            case 392:
            case 450:
            case 508:
            case 566: str = "合單"; break;
            case 277:
            case 335:
            case 393:
            case 451:
            case 509:
            case 567: str = "合雙"; break;
            case 278:
            case 336:
            case 394:
            case 452:
            case 510:
            case 568: str = "紅波"; break;
            case 279:
            case 337:
            case 395:
            case 453:
            case 511:
            case 569: str = "藍波"; break;
            case 280:
            case 338:
            case 396:
            case 454:
            case 512:
            case 570: str = "綠波"; break;
            case 571: str = "鼠"; break;
            case 572: str = "牛"; break;
            case 573: str = "虎"; break;
            case 574: str = "兔"; break;
            case 575: str = "龍"; break;
            case 576: str = "蛇"; break;
            case 577: str = "馬"; break;
            case 578: str = "羊"; break;
            case 579: str = "猴"; break;
            case 580: str = "雞"; break;
            case 581: str = "狗"; break;
            case 582: str = "猪"; break;
            case 583: str = "0尾"; break;
            case 584: str = "1尾"; break;
            case 585: str = "2尾"; break;
            case 586: str = "3尾"; break;
            case 587: str = "4尾"; break;
            case 588: str = "5尾"; break;
            case 589: str = "6尾"; break;
            case 590: str = "7尾"; break;
            case 591: str = "8尾"; break;
            case 592: str = "9尾"; break;
            case 593: str = "鼠"; break;
            case 594: str = "牛"; break;
            case 595: str = "虎"; break;
            case 596: str = "兔"; break;
            case 597: str = "龍"; break;
            case 598: str = "蛇"; break;
            case 599: str = "馬"; break;
            case 600: str = "羊"; break;
            case 601: str = "猴"; break;
            case 602: str = "雞"; break;
            case 603: str = "狗"; break;
            case 604: str = "猪"; break;
            case 605: str = "紅波"; break;
            case 606: str = "藍波"; break;
            case 607: str = "綠波"; break;
            case 608: str = "和局"; break;
            case 610:
            case 622:
            case 1187:
            case 634: str = "鼠"; break;
            case 611:
            case 623:
            case 1188:
            case 635: str = "牛"; break;
            case 612:
            case 624:
            case 1189:
            case 636: str = "虎"; break;
            case 613:
            case 625:
            case 1190:
            case 637: str = "兔"; break;
            case 614:
            case 626:
            case 1191:
            case 638: str = "龍"; break;
            case 615:
            case 627:
            case 1192:
            case 639: str = "蛇"; break;
            case 616:
            case 628:
            case 1193:
            case 640: str = "馬"; break;
            case 617:
            case 629:
            case 1194:
            case 641: str = "羊"; break;
            case 618:
            case 630:
            case 1195:
            case 642: str = "猴"; break;
            case 619:
            case 631:
            case 1196:
            case 643: str = "雞"; break;
            case 620:
            case 632:
            case 1197:
            case 644: str = "狗"; break;
            case 621:
            case 633:
            case 1198:
            case 645: str = "猪"; break;
            case 646:
            case 656:
            case 666: str = "0"; break;
            case 647:
            case 657:
            case 667: str = "1"; break;
            case 648:
            case 658:
            case 668: str = "2"; break;
            case 649:
            case 659:
            case 669: str = "3"; break;
            case 650:
            case 660:
            case 670: str = "4"; break;
            case 651:
            case 661:
            case 671: str = "5"; break;
            case 652:
            case 662:
            case 672: str = "6"; break;
            case 653:
            case 663:
            case 673: str = "7"; break;
            case 654:
            case 664:
            case 674: str = "8"; break;
            case 655:
            case 665:
            case 675: str = "9"; break;
            case 733: str = "2肖"; break;
            case 734: str = "3肖"; break;
            case 735: str = "4肖"; break;
            case 736: str = "5肖"; break;
            case 737: str = "6肖"; break;
            case 738: str = "7肖"; break;
            case 739: str = "單"; break;
            case 740: str = "雙"; break;
            case 741: str = "金"; break;
            case 742: str = "木"; break;
            case 743: str = "水"; break;
            case 744: str = "火"; break;
            case 745: str = "土"; break;
        }
    }
    return str;
}

/*KLC匹配*/
const _klcnum1 = (sortId) => {
    var str = "";
    if (sortId >= 1 && sortId <= 37) {
        str = "第一球";
    }
    else if (sortId >= 38 && sortId <= 74) {
        str = "第二球";
    }
    else if (sortId >= 75 && sortId <= 111) {
        str = "第三球";
    }
    else if (sortId >= 112 && sortId <= 148) {
        str = "第四球";
    }
    else if (sortId >= 149 && sortId <= 185) {
        str = "第五球";
    }
    else if (sortId >= 186 && sortId <= 222) {
        str = "第六球";
    }
    else if (sortId >= 223 && sortId <= 259) {
        str = "第七球";
    }
    else if (sortId >= 260 && sortId <= 296) {
        str = "第八球";
    }
    else if (sortId >= 297 && sortId <= 316) {
        str = "正碼";
    }
    else if (sortId >= 317 && sortId <= 322) {
        str = "總和";
    }
    else if (sortId == 323) {
        str = "任選二";
    }
    else if (sortId == 324) {
        str = "選二連直";
    }
    else if (sortId == 325) {
        str = "選二連組";
    }
    else if (sortId == 326) {
        str = "任選三";
    }
    else if (sortId == 327) {
        str = "選三前組";
    }
    else if (sortId == 328) {
        str = "任選四";
    }
    else if (sortId == 329) {
        str = "任選五";
    }
    return str;
}
const _klcnum2 = (sortId) => {
    var str = "-1", index;
    if (sortId >= 1 && sortId <= 20) {
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 38 && sortId <= 57) {
        index = sortId - 37;
        str = index < 10 ? "0" + index : index;
    }
    else if (sortId >= 75 && sortId <= 94) {
        index = sortId - 74;
        str = index < 10 ? "0" + index : index;
    }
    else if (sortId >= 112 && sortId <= 131) {
        index = sortId - 111;
        str = index < 10 ? "0" + index : index;
    }
    else if (sortId >= 149 && sortId <= 168) {
        index = sortId - 148;
        str = index < 10 ? "0" + index : index;
    }
    else if (sortId >= 186 && sortId <= 205) {
        index = sortId - 185;
        str = index < 10 ? "0" + index : index;
    }
    else if (sortId >= 223 && sortId <= 242) {
        index = sortId - 222;
        str = index < 10 ? "0" + index : index;
    }
    else if (sortId >= 260 && sortId <= 279) {
        index = sortId - 259;
        str = index < 10 ? "0" + index : index;
    }
    else if (sortId >= 297 && sortId <= 316) //正碼
    {
        index = sortId - 296;
        str = index < 10 ? "0" + index : index;
    }
    else {
        switch (sortId) {
            case 21:
            case 58:
            case 95:
            case 132:
            case 169:
            case 206:
            case 243:
            case 280:
            case 317: str = "單"; break;
            case 22:
            case 59:
            case 96:
            case 133:
            case 170:
            case 207:
            case 244:
            case 281:
            case 318: str = "雙"; break;
            case 23:
            case 60:
            case 97:
            case 134:
            case 171:
            case 208:
            case 245:
            case 282:
            case 319: str = "大"; break;
            case 24:
            case 61:
            case 98:
            case 135:
            case 172:
            case 209:
            case 246:
            case 283:
            case 320: str = "小"; break;
            case 25:
            case 62:
            case 99:
            case 136:
            case 173:
            case 210:
            case 247:
            case 284: str = "合單"; break;
            case 26:
            case 63:
            case 100:
            case 137:
            case 174:
            case 211:
            case 248:
            case 285: str = "合雙"; break;
            case 27:
            case 64:
            case 101:
            case 138:
            case 175:
            case 212:
            case 249:
            case 286:
            case 321: str = "尾大"; break;
            case 28:
            case 65:
            case 102:
            case 139:
            case 176:
            case 213:
            case 250:
            case 287:
            case 322: str = "尾小"; break;
            case 29:
            case 66:
            case 103:
            case 140:
            case 177:
            case 214:
            case 251:
            case 288: str = "東"; break;
            case 30:
            case 67:
            case 104:
            case 141:
            case 178:
            case 215:
            case 252:
            case 289: str = "南"; break;
            case 31:
            case 68:
            case 105:
            case 142:
            case 179:
            case 216:
            case 253:
            case 290: str = "西"; break;
            case 32:
            case 69:
            case 106:
            case 143:
            case 180:
            case 217:
            case 254:
            case 291: str = "北"; break;
            case 33:
            case 70:
            case 107:
            case 144:
            case 181:
            case 218:
            case 255:
            case 292: str = "中"; break;
            case 34:
            case 71:
            case 108:
            case 145:
            case 182:
            case 219:
            case 256:
            case 293: str = "發"; break;
            case 35:
            case 72:
            case 109:
            case 146:
            case 183:
            case 220:
            case 257:
            case 294: str = "白"; break;
            case 36:
            case 73:
            case 110:
            case 147:
            case 184:
            case 221:
            case 258:
            case 295: str = "龍"; break;
            case 37:
            case 74:
            case 111:
            case 148:
            case 185:
            case 222:
            case 259:
            case 296: str = "虎"; break;
            case 323: str = "任選二"; break;
            case 324: str = "選二連直"; break;
            case 325: str = "選二連組"; break;
            case 326: str = "任選三"; break;
            case 327: str = "選三前組"; break;
            case 328: str = "任選四"; break;
            case 329: str = "任選五"; break;
        }
    }
    return str;
}

/*SSC匹配*/
const _sscnum1 = (sortId) => {
    var str;
    if (sortId >= 1 && sortId <= 14) {
        str = "第一球";
    }
    else if (sortId >= 15 && sortId <= 28) {
        str = "第二球";
    }
    else if (sortId >= 29 && sortId <= 42) {
        str = "第三球";
    }
    else if (sortId >= 43 && sortId <= 56) {
        str = "第四球";
    }
    else if (sortId >= 57 && sortId <= 70) {
        str = "第五球";
    }
    else if (sortId >= 71 && sortId <= 74) {
        str = "總和";
    }
    else if (sortId >= 75 && sortId <= 77) {
        str = "";
    }
    else if (sortId >= 78 && sortId <= 82) {
        str = "前三";
    }
    else if (sortId >= 83 && sortId <= 87) {
        str = "中三";
    }
    else if (sortId >= 88 && sortId <= 92) {
        str = "后三";
    }
    else if (sortId >= 93 && sortId <= 107) {
        str = "";
    } else if (sortId >= 108 && sortId <= 207) {
        str = "万千XXX";
    } else if (sortId >= 208 && sortId <= 307) {
        str = "万X百XX";
    } else if (sortId >= 308 && sortId <= 407) {
        str = "万XX十X";
    } else if (sortId >= 408 && sortId <= 507) {
        str = "万XXX个";
    } else if (sortId >= 508 && sortId <= 607) {
        str = "X千百XX";
    } else if (sortId >= 608 && sortId <= 707) {
        str = "X千X十X";
    } else if (sortId >= 708 && sortId <= 807) {
        str = "X千XX个";
    } else if (sortId >= 808 && sortId <= 907) {
        str = "XX百十X";
    } else if (sortId >= 908 && sortId <= 1007) {
        str = "XX百X个";
    } else if (sortId >= 1008 && sortId <= 1107) {
        str = "XXX十个";
    }

    else if (sortId >= 1108 && sortId <= 2107) {
        str = "万千百XX";
    } else if (sortId >= 2108 && sortId <= 3107) {
        str = "万千X十X";
    } else if (sortId >= 3108 && sortId <= 4107) {
        str = "万千XX个";
    } else if (sortId >= 4108 && sortId <= 5107) {
        str = "万X百十X";
    } else if (sortId >= 5108 && sortId <= 6107) {
        str = "万X百X个";
    } else if (sortId >= 6108 && sortId <= 7107) {
        str = "万XX十个";
    } else if (sortId >= 7108 && sortId <= 8107) {
        str = "X千百十X";
    } else if (sortId >= 8108 && sortId <= 9107) {
        str = "X千百X个";
    } else if (sortId >= 9108 && sortId <= 10107) {
        str = "X千X十个";
    } else if (sortId >= 10108 && sortId <= 11107) {
        str = "XX百十个";
    }

    else if (sortId >= 11108 && sortId <= 21107) {
        str = "万千百十X";
    } else if (sortId >= 21108 && sortId <= 31107) {
        str = "万千百X个";
    } else if (sortId >= 31108 && sortId <= 41107) {
        str = "万千X十个";
    } else if (sortId >= 41108 && sortId <= 51107) {
        str = "万X百十个";
    } else if (sortId >= 51108 && sortId <= 61107) {
        str = "X千百十个";
    }

    return str;
}
const _sscnum2 = (sortId) => {
    sortId = parseInt(sortId);
    var str = "-1";
    if (sortId >= 1 && sortId <= 10) {
        str = sortId - 1;
    } else if (sortId >= 15 && sortId <= 24) {
        str = sortId - 15;
    } else if (sortId >= 29 && sortId <= 38) {
        str = sortId - 29;
    } else if (sortId >= 43 && sortId <= 52) {
        str = sortId - 43;
    } else if (sortId >= 57 && sortId <= 66) {
        str = sortId - 57;
    } else {
        switch (sortId) {
            case 11:
            case 25:
            case 39:
            case 53:
            case 67:
            case 71: str = "單"; break;
            case 12:
            case 26:
            case 40:
            case 54:
            case 68:
            case 72: str = "雙"; break;
            case 13:
            case 27:
            case 41:
            case 55:
            case 69:
            case 73: str = "大"; break;
            case 14:
            case 28:
            case 42:
            case 56:
            case 70:
            case 74: str = "小"; break;
            case 75: str = "龍"; break;
            case 76: str = "虎"; break;
            case 77: str = "和"; break;
            case 78:
            case 83:
            case 88: str = "豹子"; break;
            case 79:
            case 84:
            case 89: str = "順子"; break;
            case 80:
            case 85:
            case 90: str = "對子"; break;
            case 81:
            case 86:
            case 91: str = "半順"; break;
            case 82:
            case 87:
            case 92: str = "雜六"; break;
            case 93: str = "牛一"; break;
            case 94: str = "牛二"; break;
            case 95: str = "牛三"; break;
            case 96: str = "牛四"; break;
            case 97: str = "牛五"; break;
            case 98: str = "牛六"; break;
            case 99: str = "牛七"; break;
            case 100: str = "牛八"; break;
            case 101: str = "牛九"; break;
            case 102: str = "牛牛"; break;
            case 103: str = "無牛"; break;
            case 104: str = "牛單"; break;
            case 105: str = "牛雙"; break;
            case 106: str = "牛大"; break;
            case 107: str = "牛小"; break;
        }
    }
    return str;
}



/*PK匹配*/
const _pknum1 = (sortId) => {
    var str;
    if (sortId >= 1 && sortId <= 17) {
        str = "冠亚和";
    }
    else if (sortId >= 18 && sortId <= 21) {
        str = "冠亚";
    }
    else if (sortId >= 22 && sortId <= 37) {
        str = "冠军";
    }
    else if (sortId >= 38 && sortId <= 53) {
        str = "亚军";
    }
    else if (sortId >= 54 && sortId <= 69) {
        str = "第三名";
    }
    else if (sortId >= 70 && sortId <= 85) {
        str = "第四名";
    }
    else if (sortId >= 86 && sortId <= 101) {
        str = "第五名";
    }
    else if (sortId >= 102 && sortId <= 117) {
        str = "第六名";
    }
    else if (sortId >= 118 && sortId <= 133) {
        str = "第七名";
    }
    else if (sortId >= 134 && sortId <= 149) {
        str = "第八名";
    }
    else if (sortId >= 150 && sortId <= 165) {
        str = "第九名";
    }
    else if (sortId >= 166 && sortId <= 181) {
        str = "第十名";
    }
    return str;
}
const _pknum2 = (sortId) => {
    sortId = parseInt(sortId);
    var str = "-1";
    if (sortId >= 1 && sortId <= 17) {
        str = sortId + 2;
    } else if (sortId >= 22 && sortId <= 31) {
        str = sortId - 21;
    } else if (sortId >= 38 && sortId <= 47) {
        str = sortId - 37;
    } else if (sortId >= 54 && sortId <= 63) {
        str = sortId - 53;
    } else if (sortId >= 70 && sortId <= 79) {
        str = sortId - 69;
    } else if (sortId >= 86 && sortId <= 95) {
        str = sortId - 85;
    } else if (sortId >= 102 && sortId <= 111) {
        str = sortId - 101;
    } else if (sortId >= 118 && sortId <= 127) {
        str = sortId - 117;
    } else if (sortId >= 134 && sortId <= 143) {
        str = sortId - 133;
    } else if (sortId >= 150 && sortId <= 159) {
        str = sortId - 149;
    } else if (sortId >= 166 && sortId <= 175) {
        str = sortId - 165;
    } else {
        switch (sortId) {
            case 18:
            case 32:
            case 48:
            case 64:
            case 80:
            case 96:
            case 112:
            case 128:
            case 144:
            case 160:
            case 176:
                str = "单"; break;
            case 19:
            case 33:
            case 49:
            case 65:
            case 81:
            case 97:
            case 113:
            case 129:
            case 145:
            case 161:
            case 177:
                str = "双"; break;
            case 20:
            case 34:
            case 50:
            case 66:
            case 82:
            case 98:
            case 114:
            case 130:
            case 146:
            case 162:
            case 178:
                str = "大"; break;
            case 21:
            case 35:
            case 51:
            case 67:
            case 83:
            case 99:
            case 115:
            case 131:
            case 147:
            case 163:
            case 179:
                str = "小"; break;
            case 36:
            case 52:
            case 68:
            case 84:
            case 100:
                str = "龙"; break;
            case 37:
            case 53:
            case 69:
            case 85:
            case 101:
                str = "虎"; break;
        }
    }
    return str;
}
/*KS匹配*/
const _ksnum1 = (sortId) => {
    var str;
    if (sortId >= 1 && sortId <= 2) {
        str = "大小";
    }
    else if (sortId >= 3 && sortId <= 8) {
        str = "三軍";
    }
    else if (sortId >= 9 && sortId <= 14) {
        str = "圍骰";
    }
    else if (sortId == 15) {
        str = ""; //全骰
    }
    else if (sortId >= 16 && sortId <= 29) {
        str = "點數";
    }
    else if (sortId >= 30 && sortId <= 44) {
        str = "長牌";
    }
    else if (sortId >= 45 && sortId <= 50) {
        str = "短牌";
    }
    return str;
}
const _ksnum2 = (sortId) => {
    sortId = parseInt(sortId);
    var str = "-1";
    if (sortId >= 3 && sortId <= 8) {
        str = sortId - 2;
    } else if (sortId >= 16 && sortId <= 29) {
        str = (sortId - 12) + "點";
    } else {
        switch (sortId) {
            case 1: str = "大"; break;
            case 2: str = "小"; break;
            case 9: str = "111"; break;
            case 10: str = "222"; break;
            case 11: str = "333"; break;
            case 12: str = "444"; break;
            case 13: str = "555"; break;
            case 14: str = "666"; break;
            case 15: str = "全骰"; break;
            case 30: str = "12"; break;
            case 31: str = "13"; break;
            case 32: str = "14"; break;
            case 33: str = "15"; break;
            case 34: str = "16"; break;
            case 35: str = "23"; break;
            case 36: str = "24"; break;
            case 37: str = "25"; break;
            case 38: str = "26"; break;
            case 39: str = "34"; break;
            case 40: str = "35"; break;
            case 41: str = "36"; break;
            case 42: str = "45"; break;
            case 43: str = "46"; break;
            case 44: str = "56"; break;
            case 45: str = "11"; break;
            case 46: str = "22"; break;
            case 47: str = "33"; break;
            case 48: str = "44"; break;
            case 49: str = "55"; break;
            case 50: str = "66"; break;
        }
    }
    return str;
}
/*KLB匹配*/
const _klbnum1 = (sortId) => {
    var str;
    if (sortId >= 1 && sortId <= 80) {
        str = "正碼";
    }
    else if (sortId >= 81 && sortId <= 89) {
        str = "總和";
    }
    else if (sortId >= 90 && sortId <= 92) {
        str = "前后和";
    }
    else if (sortId >= 93 && sortId <= 95) {
        str = "單雙和";
    }
    else if (sortId >= 96 && sortId <= 100) {
        str = "五行";
    }
    return str;
}
const _klbnum2 = (sortId) => {
    sortId = parseInt(sortId);
    var str = "-1";
    if (sortId >= 1 && sortId <= 80) {
        str = sortId;
    } else {
        switch (sortId) {
            case 81: str = "單"; break;
            case 82: str = "雙"; break;
            case 83: str = "大"; break;
            case 84: str = "小"; break;
            case 85: str = "810"; break; //和
            case 86: str = "大單"; break;
            case 87: str = "大雙"; break;
            case 88: str = "小單"; break;
            case 89: str = "小雙"; break;
            case 90: str = "前(多)"; break;
            case 91: str = "后(多)"; break;
            case 92: str = "前后(和)"; break;
            case 93: str = "單(多)"; break;
            case 94: str = "雙(多)"; break;
            case 95: str = "單雙(和)"; break;
            case 96: str = "金"; break;
            case 97: str = "木"; break;
            case 98: str = "水"; break;
            case 99: str = "火"; break;
            case 100: str = "土"; break;
        }
    }
    return str;
}
/*GX匹配*/
const _gxnum1 = (sortId) => {
    var str;
    if (sortId >= 1 && sortId <= 36) {
        str = "第一球";
    }
    else if (sortId >= 37 && sortId <= 72) {
        str = "第二球";
    }
    else if (sortId >= 73 && sortId <= 108) {
        str = "第三球";
    }
    else if (sortId >= 109 && sortId <= 144) {
        str = "第四球";
    }
    else if (sortId >= 145 && sortId <= 180) {
        str = "第五球";
    }
    else if (sortId >= 181 && sortId <= 201) {
        str = "正碼";
    }
    else if (sortId >= 202 && sortId <= 207) {
        str = "總和";
    }
    else if (sortId >= 208 && sortId <= 209) {
        str = "龍虎";
    }
    return str;
}
const _gxnum2 = (sortId) => {
    var str = "-1", index;
    if (sortId >= 1 && sortId <= 21) {
        str = sortId < 10 ? "0" + sortId : sortId;
    }
    else if (sortId >= 37 && sortId <= 57) {
        index = sortId - 36;
        str = index < 10 ? "0" + index : index;
    }
    else if (sortId >= 73 && sortId <= 93) {
        index = sortId - 72;
        str = index < 10 ? "0" + index : index;
    }
    else if (sortId >= 109 && sortId <= 129) {
        index = sortId - 108;
        str = index < 10 ? "0" + index : index;
    }
    else if (sortId >= 145 && sortId <= 165) {
        index = sortId - 144;
        str = index < 10 ? "0" + index : index;
    }
    else if (sortId >= 181 && sortId <= 201) //正碼
    {
        index = sortId - 180;
        str = index < 10 ? "0" + index : index;
    }
    else {
        switch (sortId) {
            case 22:
            case 58:
            case 94:
            case 130:
            case 166:
            case 202: str = "單"; break;
            case 23:
            case 59:
            case 95:
            case 131:
            case 167:
            case 203: str = "雙"; break;
            case 24:
            case 60:
            case 96:
            case 132:
            case 168:
            case 204: str = "大"; break;
            case 25:
            case 61:
            case 97:
            case 133:
            case 169:
            case 205: str = "小"; break;
            case 26:
            case 62:
            case 98:
            case 134:
            case 170: str = "合單"; break;
            case 27:
            case 63:
            case 99:
            case 135:
            case 171: str = "合雙"; break;
            case 28:
            case 64:
            case 100:
            case 136:
            case 172:
            case 206: str = "尾大"; break;
            case 29:
            case 65:
            case 101:
            case 137:
            case 173:
            case 207: str = "尾小"; break;
            case 30:
            case 66:
            case 102:
            case 138:
            case 174: str = "福"; break;
            case 31:
            case 67:
            case 103:
            case 139:
            case 175: str = "祿"; break;
            case 32:
            case 68:
            case 104:
            case 140:
            case 176: str = "壽"; break;
            case 33:
            case 69:
            case 105:
            case 141:
            case 177: str = "喜"; break;
            case 34:
            case 70:
            case 106:
            case 142:
            case 178: str = "紅波"; break;
            case 35:
            case 71:
            case 107:
            case 143:
            case 179: str = "藍波"; break;
            case 36:
            case 72:
            case 108:
            case 144:
            case 180: str = "綠波"; break;
            case 208: str = "龍"; break;
            case 209: str = "虎"; break;
        }
    }
    return str;
}

const htmlAll = (width) => {
    var html = [];
    var _width = width || 100;
    html.push("<div style='float:right;width:" + _width + "%;'>");
    html.push("<table class='middle-table'><thead><tr><th class='txt-left' colspan='2'>&nbsp;總額:<span id='count-bt' class='green'>0</span></th></tr></thead>");
    html.push("<tbody id='count-ary' class='bc'>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='1' my-type='1' sort-tb='0'>特碼A:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='8' my-type='8' sort-tb='9'>正碼A:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='1' my-type='2' sort-tb='1'>特碼B:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='8' my-type='88' sort-tb='10'>正碼B:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='1' my-type='3' sort-tb='2'>特碼:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='16' my-type='16' sort-tb='24'>一肖:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='4' my-type='4' sort-tb='3'>色波:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='16' my-type='16' sort-tb='25'>尾數:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='5' my-type='4' sort-tb='4'>特肖:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='17' my-type='17' sort-tb='26'>正肖:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='6' my-type='6' sort-tb='5'>合肖:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='17' my-type='17' sort-tb='27'>七色波:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='27' my-type='4' sort-tb='6'>五行:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='26' my-type='17' sort-tb='28'>總肖:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='7' my-type='4' sort-tb='7'>頭數:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='18' my-type='18' sort-tb='29'>不中:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='7' my-type='4' sort-tb='8'>尾數:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='19' my-type='19' sort-tb='30'>二連肖:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='10' sort-tb='12'>正一特:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='19' my-type='19' sort-tb='31'>三連肖:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='11' sort-tb='13'>正二特:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='19' my-type='19' sort-tb='32'>四連肖:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='12' sort-tb='14'>正三特:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='19' my-type='19' sort-tb='33'>五連肖:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='13' sort-tb='15'>正四特:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='22' my-type='22' sort-tb='34'>二連尾:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='14' sort-tb='16'>正五特:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='22' my-type='22' sort-tb='35'>三連尾:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='15' sort-tb='17'>正六特:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='22' my-type='22' sort-tb='36'>四連尾:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='10' sort-tb='18'>正一:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='28' my-type='28' sort-tb='37'>二全中:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='11' sort-tb='19'>正二:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='28' my-type='29' sort-tb='38'>三全中:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='12' sort-tb='20'>正三:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='28' my-type='30' sort-tb='39'>三中二:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='13' sort-tb='21'>正四:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='28' my-type='31' sort-tb='40'>二中特:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='14' sort-tb='22'>正五:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='28' my-type='32' sort-tb='41'>特串:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='10' my-type='15' sort-tb='23'>正六:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left cursor' index='28' my-type='33' sort-tb='42'>四全中:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='w50 txt-left txt-paddin-left cursor' index='8' my-type='808' sort-tb='11'>總和:<span class='green'>0</span></td><td class='w50 txt-left txt-paddin-left'></td></tr>");
    html.push("</tbody>");
    html.push("</table>");
    html.push("</div>");
    return {
        tongji: html.join(""),
        ksph: "<div style='float:right;width:30.2%;'><div style='float:left;width:54%;'><table class='middle-table'><thead><tr><th colspan='4'>虧損額負值排列</th></tr></thead><tbody id='fz-sort'></tbody></table></div>",
        zttj: "<div style='float:left;width:99%;' id='total_tongji'><p>總投註額：<b class='green'>0</b></p><p>最高虧損：<b class='red'>0</b></p><p>最高盈利：<b>0</b></p></div>",
        ksbh: "<table border='0' cellpadding='0' cellspacing='0' style='width:100%;text-align:center;' id='foot'><tfoot><tr><td style='padding-top:5px;'><span class='text-btn' onclick='numBuHuo()'>快速補貨</span></td></tr></tfoot></table>"
    };
}

const klchtmlAll = (msg) => {
    var html = [];
    html.push("<div style='float:left;width:50%;'>");
    html.push("<table class='middle-table'><thead><tr><th class='txt-left'>&nbsp;總註額:<span id='count-bt' class='green'>0</span></th></tr></thead>");
    html.push("<tbody id='count-ary'>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='1'>第一球 總:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='2'>第二球 總:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='3'>第三球 總:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='4'>第四球 總:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='5'>第五球 總:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='6'>第六球 總:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='7'>第七球 總:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='8'>第八球 總:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='9'>正&nbsp;碼&nbsp;&nbsp; 總:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='9'>總&nbsp;和&nbsp;&nbsp; 總:<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='10'>任&nbsp;選&nbsp;二:&nbsp;&nbsp;<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='10'>選二連直:&nbsp;<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='10'>選二連組:&nbsp;<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='10'>任&nbsp;選&nbsp;三:&nbsp;&nbsp;<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='10'>選三前組:&nbsp;<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='10'>任&nbsp;選四&nbsp;:&nbsp;&nbsp;<span class='green'>0</span></td></tr>");
    html.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='10'>任&nbsp;選&nbsp;五:&nbsp;&nbsp;<span class='green'>0</span></td></tr>");
    html.push("</tbody>");
    html.push("</table>");
    html.push("</div>");

    var pkHtml = [];
    var pklen = msg.pklen || 50;
    pkHtml.push("<div style='float:left;width:" + pklen + "%;'>");
    pkHtml.push("<table class='middle-table'><thead><tr><th class='txt-left'>&nbsp;總註額:<span id='count-bt' class='green'>0</span></th></tr></thead>");
    pkHtml.push("<tbody id='count-ary'>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='1'>冠亞軍和:&nbsp;<span class='green'>0</span></td></tr>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='1'>冠亞兩面:&nbsp;<span class='green'>0</span></td></tr>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='1'>冠&nbsp;軍&nbsp;&nbsp;&nbsp;總:<span class='green'>0</span></td></tr>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='1'>亞&nbsp;軍&nbsp;&nbsp;&nbsp;總:<span class='green'>0</span></td></tr>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='2'>第三名 總:<span class='green'>0</span></td></tr>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='2'>第四名 總:<span class='green'>0</span></td></tr>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='2'>第五名 總:<span class='green'>0</span></td></tr>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='2'>第六名 總:<span class='green'>0</span></td></tr>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='3'>第七名 總:<span class='green'>0</span></td></tr>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='3'>第八名 總:<span class='green'>0</span></td></tr>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='3'>第九名 總:<span class='green'>0</span></td></tr>");
    pkHtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='3'>第十名 總:<span class='green'>0</span></td></tr>");
    pkHtml.push("</tbody>");
    pkHtml.push("</table>");
    pkHtml.push("</div>");

    var gxhtml = [];
    gxhtml.push("<div style='float:left;width:50%;'>");
    gxhtml.push("<table class='middle-table'><thead><tr><th class='txt-left'>&nbsp;總註額:<span id='count-bt' class='green'>0</span></th></tr></thead>");
    gxhtml.push("<tbody id='count-ary'>");
    gxhtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='1'>第一球 總:<span class='green'>0</span></td></tr>");
    gxhtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='2'>第二球 總:<span class='green'>0</span></td></tr>");
    gxhtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='3'>第三球 總:<span class='green'>0</span></td></tr>");
    gxhtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='4'>第四球 總:<span class='green'>0</span></td></tr>");
    gxhtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='5'>第五球 總:<span class='green'>0</span></td></tr>");

    gxhtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='6'>正&nbsp;碼&nbsp;&nbsp; 總:<span class='green'>0</span></td></tr>");
    gxhtml.push("<tr><td class='bc txt-left txt-paddin-left cursor' my-type='6'>總和&nbsp;龍虎:<span class='green'>0</span></td></tr>");

    gxhtml.push("</tbody>");
    gxhtml.push("</table>");
    gxhtml.push("</div>");


    var ylhtml = [];
    ylhtml.push("<div style='float:left;width:15%;margin-left:5px;'>");
    ylhtml.push("<table class='middle-table'><thead><tr><th colspan='2'>遺漏</th></tr></thead>");
    ylhtml.push("<tbody id='yl-count'>");
    if (msg.yilou && msg.yilou.length > 0) {
        var num, index;
        for (var i = 0; i < msg.yilou.length; i++) {
            index = i + 1;
            num = index < 10 ? "0" + index : index;
            ylhtml.push("<tr><td class='w50 bold fhs'>" + num + "</td><td class='w50' index='" + index + "'>" + msg.yilou[i] + "</td></tr>");
        }
    }
    ylhtml.push("</tbody>");
    ylhtml.push("</table>");
    ylhtml.push("</div>");

    var clhtml = [];
    var clwidth = msg.clwidth || 33;
    clhtml.push("<div style='float:right;width:" + clwidth + "%;'>");
    clhtml.push("<table class='middle-table'><thead><tr><th colspan='2'>兩面長龍排行</th></tr></thead>");
    clhtml.push("<tbody id='cl-count'>");
    if (msg.clList && msg.clList.length > 0) {
        msg.clList.sort(function (a, b) {
            var _a = a.split(":")[1], _b = b.split(":")[1];
            return parseInt(_b) - parseInt(_a);
        });
        var key;
        for (var i = 0; i < msg.clList.length; i++) {
            key = msg.clList[i].split(":");
            clhtml.push("<tr><td class='bc txt-left txt-paddin-left'>" + key[0] + "</td><td class='fff red'>" + key[1] + "期</td></tr>");
        }
    } else {
        clhtml.push("<tr><td class='fff'>暫無數據</td></tr>");
    }
    clhtml.push("</tbody>");
    clhtml.push("</table>");
    clhtml.push("</div>");

    var kshtml = [];
    var clwidth = msg.clwidth || 33;
    kshtml.push("<div style='float:right;width:" + clwidth + "%;'>");
    kshtml.push("<table class='middle-table'><thead><tr><th colspan='4'>近期開獎結果</th></tr></thead>");
    kshtml.push("<tbody id='cl-count'>");
    if (msg.clListr && msg.clListr.length > 0) {
        var key, num;
        for (var i = 0; i < msg.clListr.length; i++) {
            key = msg.clListr[i].split(":");
            num = key[1].split("|");
            kshtml.push("<tr><td class='bc sw35'>" + key[0] + "期</td><td class='fff red'><i class='KSNo_" + num[0] + "'></i><i class='KSNo_" + num[1] + "'></i><i class='KSNo_" + num[2] + "'></i></td><td class='sw30'>" + key[2] + "</td><td class='sw30'>" + key[3] + "</td></tr>");
        }
    } else {
        kshtml.push("<tr><td class='fff'>暫無數據</td></tr>");
    }
    kshtml.push("</tbody>");
    kshtml.push("</table>");
    kshtml.push("</div>");

    return {
        tongji: html.join(""),
        gxtongji: gxhtml.join(""),
        pktongji: pkHtml.join(""),
        yilou: ylhtml.join(""),
        cl: clhtml.join(""),
        ksNum: kshtml.join(""),
        ksph: "<div style='float:right;width:30.2%;'><div style='float:left;width:66%;'><table class='middle-table'><thead><tr><th colspan='4'>虧損額負值排列</th></tr></thead><tbody id='fz-sort'></tbody></table></div>",
        zttj: "<div style='float:left;width:33.3%;' id='total_tongji'><p>總投註額：<b class='green'>0</b></p><p>最高虧損：<b class='red'>0</b></p><p>最高盈利：<b>0</b></p></div>",
        ksbh: "<table border='0' cellpadding='0' cellspacing='0' style='width:100%;text-align:center;' id='foot'><tfoot><tr><td style='padding-top:5px;'><span class='text-btn' onclick='numBuHuo()'>快速補貨</span></td></tr></tfoot></table>"
    };
}

const getDwNameByType = (type) => {
    if (type < 108) {
        if (type <= 10) return (type - 1) + "XXXX";
        if (type <= 24) return "X" + (type - 15) + "XXX";
        if (type <= 38) return "XX" + (type - 29) + "XX";
        if (type <= 52) return "XXX" + (type - 43) + "X";
        if (type <= 66) return "XXXX" + (type - 57);

    }
    else if (type < 208) {//萬千XXX
        type -= 108;
        return Math.floor(type / 10).toString() + (type % 10).toString() + "XX";
    } else if (type < 308) {//萬X百XX
        type -= 208;
        return Math.floor(type / 10) + "X" + (type % 10) + "X";

    } else if (type < 408) {//萬XX十X
        type -= 308;
        return Math.floor(type / 10) + "XX" + type % 10;

    } else if (type < 508) { //萬XXX个
        type -= 408;
        return Math.floor(type / 10) + "XXX" + (type % 10);

    } else if (type < 608) {//X千百XX
        type -= 508;
        return "X" + Math.floor(type / 10).toString() + (type % 10).toString() + "X";

    } else if (type < 708) {//X千X十X
        type -= 608;
        return "X" + Math.floor(type / 10) + "X" + (type % 10);

    } else if (type < 808) {//X千XX个
        type -= 708;
        return "X" + Math.floor(type / 10) + "XX" + (type % 10);

    } else if (type < 908) {//XX百十X
        type -= 808;
        return "XX" + Math.floor(type / 10).toString() + (type % 10);

    } else if (type < 1008) {// XX百X个
        type -= 908;
        return "XX" + Math.floor(type / 10) + "X" + (type % 10);

    } else if (type < 1108) {//XXX十个
        type -= 1008;
        return "XXX" + Math.floor(type / 10).toString() + (type % 10);

    }
    else if (type < 2108) {//万千百XX
        type -= 1108;
        return Math.floor(type / 100).toString() + Math.floor(type % 100 / 10).toString() + (type % 100 % 10) + "X";
    } else if (type < 3108) {//万千X十X
        type -= 2108;
        return Math.floor(type / 100).toString() + Math.floor(type % 100 / 10) + "X" + (type % 100 % 10);
    } else if (type < 4108) {//万千XX个
        type -= 3108;
        return Math.floor(type / 100).toString() + Math.floor(type % 100 / 10) + "XX" + (type % 100 % 10);
    } else if (type < 5108) {//万X百十X
        type -= 4108;
        return Math.floor(type / 100) + "X" + Math.floor(type % 100 / 10).toString() + (type % 100 % 10);
    } else if (type < 6108) {//万X百X个
        type -= 5108;
        return Math.floor(type / 100) + "X" + Math.floor(type % 100 / 10) + "X" + (type % 100 % 10);
    } else if (type < 7108) {//万XX十个
        type -= 6108;
        return Math.floor(type / 100) + "XX" + Math.floor(type % 100 / 10).toString() + (type % 100 % 10);
    } else if (type < 8108) {//X千百十X
        type -= 7108;
        return "X" + Math.floor(type / 100) + Math.floor(type % 100 / 10).toString() + (type % 100 % 10);
    } else if (type < 9108) {//X千百X个
        type -= 8108;
        return "X" + Math.floor(type / 100).toString() + Math.floor(type % 100 / 10) + "X" + (type % 100 % 10);
    } else if (type < 10108) {//X千X十个
        type -= 9108;
        return "X" + Math.floor(type / 100) + "X" + Math.floor(type % 100 / 10) + (type % 100 % 10);
    } else if (type < 11108) {//XX百十个
        type -= 10108;
        return "XX" + Math.floor(type / 100) + Math.floor(type % 100 / 10).toString() + (type % 100 % 10);
    } else if (type < 21108) {//万千百十X
        type -= 11108;
        return Math.floor(type / 1000) + Math.floor(type % 1000 / 100).toString() + Math.floor(type % 1000 % 100 / 10).toString() + (type % 1000 % 100 % 10);
    } else if (type < 31108) {//万千百X个
        type -= 21108;
        return Math.floor(type / 1000) + Math.floor(type % 1000 / 100).toString() + Math.floor(type % 1000 % 100 / 10) + "X" + (type % 1000 % 100 % 10);

    } else if (type < 41108) {//万千X十个
        type -= 31108;
        return Math.floor(type / 1000).toString() + Math.floor(type % 1000 / 100) + "X" + Math.floor(type % 1000 % 100 / 10).toString() + (type % 1000 % 100 % 10);

    } else if (type < 51108) {//万X百十个
        type -= 41108;
        return Math.floor(type / 1000) + "X" + Math.floor(type % 1000 / 100) + Math.floor(type % 1000 % 100 / 10).toString() + (type % 1000 % 100 % 10);

    } else if (type < 61108) {//X千百十个
        type -= 51108;
        return "X" + Math.floor(type / 1000) + Math.floor(type % 1000 / 100).toString() + Math.floor(type % 1000 % 100 / 10).toString() + (type % 1000 % 100 % 10);
    }

    if (type == 61108) return "1番";
    if (type == 61109) return "2番";
    if (type == 61110) return "3番";
    if (type == 61111) return "4番";

    if (type == 61114) return "1正";
    if (type == 61115) return "2正";
    if (type == 61116) return "3正";
    if (type == 61117) return "4正";

    if (type == 61118) return "1-2角";
    if (type == 61119) return "2-3角";
    if (type == 61120) return "3-4角";
    if (type == 61121) return "1-4角";

    if (type == 61122) return "1念2";
    if (type == 61123) return "1念3";
    if (type == 61124) return "1念4";
    if (type == 61125) return "2念1";
    if (type == 61126) return "2念3";
    if (type == 61127) return "2念4";
    if (type == 61128) return "3念1";
    if (type == 61129) return "3念2";
    if (type == 61130) return "3念4";
    if (type == 61131) return "4念1";
    if (type == 61132) return "4念2";
    if (type == 61133) return "4念3";

    if (type == 61134) return "23一通";
    if (type == 61135) return "24一通";
    if (type == 61136) return "34一通";
    if (type == 61137) return "13二通";
    if (type == 61138) return "14二通";
    if (type == 61139) return "34二通";

    if (type == 61140) return "12三通";
    if (type == 61141) return "14三通";
    if (type == 61142) return "24三通";
    if (type == 61143) return "12四通";
    if (type == 61144) return "13四通";
    if (type == 61145) return "23四通";

    if (type == 61146) return "123中";
    if (type == 61147) return "124中";
    if (type == 61148) return "134中";
    if (type == 61149) return "234中";

}
const game_loading_wrap = (stop) => {
    if (S.loadingWrap) {
        if (stop) {
            $(".game_loading_wrap").css("display", "block");
            $("#gameBox").css("display", "none");
        } else {
            $(".game_loading_wrap").css("display", "none");
            $("#gameBox").css("display", "block");
        }
    }
}

const lastBetData = (json) => {
    if (json.lastBetList && json.lastBetList.length > 0) {

        $("#leftBox").find("span[id='print_mem']").html(json.lastBetList[0][0]);
        $("#leftBox").find("span[id='print_issue']").html(json.lastBetList[0][1]);
        $("#leftBox").find("span[id='print_time']").html(json.lastBetList[0][2]);
        $("#leftBox").find("span[id='print_no']").html(json.lastBetList[0][3]);

        var htmlData = "<tr><td>号码</td><td>赔率</td><td>金额</td></tr>";
        var totalMoney = 0;
        for (var n = 1; n < json.lastBetList.length; n++) {
            var arr = json.lastBetList[n].split(":");
            htmlData += "<tr><td>" + getDwNameByType(arr[0]) + "</td><td>" + arr[2] + "</td><td>" + arr[1] + "</td></tr>";
            totalMoney += parseFloat(arr[1]);
        }

        var pages = json.lastBetList[0][4];
        var curpage = json.lastBetList[0][5];

        // htmlData += "<tr><td colspan='3'><div id='last_page'></div></td></tr>";

        htmlData += "<tr><td colspan='3'>总笔：<span class='red'>" + (json.lastBetList.length - 1) + "</span>总金额：<span class='red'>" + totalMoney + "</span></td></tr>";
        htmlData += "<tr><td colspan='3'>第" + json.lastBetList[0][1] + "期，1天内有效！！！</td></tr>";
        htmlData += "<tr><td colspan='3'><input id='clear-lastbet' class='btn grayBtn' type='button' value='清除'>" +
            "<input id='print-lastbet' class='btn hotBtn disSubmit' type='button' value='打印'></td></tr>"

        $("#last_list").html(htmlData);


        $("#clear-lastbet").unbind("click").click(function () {
            lastBetData(json);
        });
    } else {
        $("#last_list").html("");
    }
}


const printLastbet = (vue) => {
    $("#print-lastbet")
        .unbind("click")
        .click(function () {
            // parent.location.href = "print?t=" + __sysinfo.autoTid;
            //window.open("print?t=" + __sysinfo.autoTid);

            if(vue.huiyunDataList.length === 0){
                G.alert({ content: "暂无打印数据", ok: function () { return true; }, type: '1' });
                return
            }

            var bdhtml = window.document.body.innerHTML;
            let table1 = $('#leftBox').find('.table1').html()
            let table2 = $('#leftBox').find('.table2').find('tbody').html()
            let table3 = $('#leftBox').find('.table3').find('tbody').html()
            let printHtml =
                            `<div class="game_box_title t_1" style="background-color: white;">
                                    <div class="history_wrap zchy">
                                        <table>
                                            ${table1}
                                        </table>
                                        <table>
                                            <tbody id="last_list">
                                                ${table2}
                                                ${table3}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>`

            window.document.body.innerHTML = $("#leftBox").html(); //把需要打印的指定内容赋给body.innerHTML
            window.document.body.innerHTML = printHtml; //把需要打印的指定内容赋给body.innerHTML
            window.print(); //调用浏览器的打印功能打印指定区域
            window.document.body.innerHTML = bdhtml; // 最后还原页面
            window.location.reload();
        });
}
const clearUserInfo = (info) => {
    $("#clear-lastbet")
        .unbind("click")
        .click(function () {
            lastBetData({
                lastBetList: [[`${info.username}`, `${info.isplayer}`, `${info.loginTime}`, `${info.credits}`, `${info.balance}`,]]
            });
        });

}
const setDefault = () => {
    document.getElementsByTagName("body")[0].className = "Yellow";
}

const logined = () => {
    let meta = window.document.getElementsByTagName("meta");
    for (let i = 0; i < meta.length; i++) {
        if (meta[i].getAttribute("name") == "viewport") {
            meta[i].setAttribute(
                "content",
                "width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no"
            );
        }
    }
}
const agreed = () => {
    let meta = window.document.getElementsByTagName("meta");
    for (let i = 0; i < meta.length; i++) {
        if (meta[i].getAttribute("name") == "viewport") {
            meta[i].setAttribute(
                "content",
                "width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no"
            );
        }
    }

    document.getElementById("app").style.height = "auto";
}
const searchBtn = () => {
    setTimeout(() => {
        if(document.getElementById("app")){
            document.getElementById("app").style.height =
                window.innerHeight + "px";
            if (window.navigator.userAgent.indexOf("Window") < 0) {
                document.getElementsByClassName("login_warp")[0].style.width =
                    "660px";
                if (window.outerWidth > 400 && window.outerWidth < 450) {
                    document.getElementsByClassName("login_warp")[0].style.margin =
                        "40px 60px 0px -30px";
                } else {
                    document.getElementsByClassName("login_warp")[0].style.margin =
                        "40px 60px 0px -60px";
                }
            }
        }

    }, 3);
}
const loginOper = () => {
    setTimeout(() => {
        if (window.navigator.userAgent.indexOf("Window") < 0) {
            $(".proBox").css({ width: "98%", margin: "0 auto" });
            $(".proPic2 .textbox1").css({
                width: "98%",
                padding: "0"
            });
            $(".proPic1, .proPic2, .proPic3").css("width", "98%");
        }
    }, 30);
}
const showChangeSky = () => {
    $(".skin_btn").click(function () {
        $("#skinBox").css("display", "inline-block");
    })
    $("#skinChange").hover(() => { }, () => {
        $("#skinBox").css("display", "none");
    })
    $("#menuText").click(() => {
        $(".menuList").css("display", "inline-block");
    })
    $(".menu").hover(() => { }, () => {
        $(".menuList").css("display", "none");
    })
}

const alertClose = () => {
    $("#myWarpr_alert").remove();
    $("#mymask").remove();
}
const alertWin = (msg) => {
    $("#myWarpr_alert").remove();
    $("body").append(_INI_.alertHtm);
    var myobj = $("#myWarpr_alert");
    var title = msg.title || "提示";
    var content = msg.content || "";
    var width = msg.width || "auto";
    var height = msg.height || "auto";
    var initialize = msg.initialize || false;
    var cancel = msg.cancel || false;
    var ok = msg.ok || false;
    var close = msg.close || false;
    var okVal = msg.okVal || "确认";
    var cancelVal = msg.cancelVal || "取消";
    var lock = true;
    var top, left;

    myobj.find(".myLayerTitle h3").html(title);
    myobj.find(".myLayerContent").html(content);
    myobj.find(".myLayerFooter").hide();
    myobj.find(".myLayerFooter a.myLayerCancel").html(cancelVal).attr("title", cancelVal).hide();
    myobj.find(".myLayerFooter a.myLayerOk").html(okVal).attr("title", okVal).hide();

    if (lock) { //遮罩层
        $("#mymask").remove();
        $("body").append("<div class='myLayerLoading' id='mymask'></div>");
        $("#mymask").show();
    }
    if (msg.obj) {
        var obj = msg.obj;
        var elmOffset = obj.offset();
        top = elmOffset.top + obj.height() + 10; //控件top坐標
        left = elmOffset.left + 10; //控件left坐標
    } else {
        myobj.find(".myLayerOn").hide();
        myobj.find(".myLayerContent").css({ "width": width, "height": height, "overflow-y": "auto" });
        var myWidth = myobj.find(".myLayerContent").width();
        var myHieht = myobj.find(".myLayerContent").height();
        top = ($(window).height() - myHieht) / 2.8;
        left = ($(window).width() - myWidth) / 2;
        $(window).resize(function () {
            myobj.find(".myLayer").css({ "left": ($(window).width() - myWidth) / 2, "top": ($(window).height() - myHieht) / 2.8 });
            $("#mymask").css("height", $(window).height());
        });
    }
    myobj.find(".myLayer").css({ "top": top, "left": left });
    window.scrollTo(0, 0);

    if (ok) {
        myobj.find(".myLayerFooter").show();
        myobj.find(".myLayerFooter a.myLayerOk").show().focus();
    }
    if (cancel) {
        myobj.find(".myLayerFooter").show();
        myobj.find(".myLayerFooter a.myLayerCancel").show();
    }
    if (initialize) {
        initialize(myobj);
    }
    myobj.find(".myLayerClose").unbind("click").click(function () {
        if (close) { close(); }
        alertClose();
    });
    myobj.find(".myLayerCancel").unbind("click").click(function () {

        if (close) { close(); }
        if (!cancel()) {
            alertClose();
        }
    });
    myobj.find(".myLayerOk").unbind("click").click(function () {
        if (ok()) { alertClose(); }
        if (close) { close(); }
    });
}
const DecimalSign = (str) => {
    return /^[0-9]+(\.[0-9]+)?$/.test(str);
}
const gameSubmit = () => {
    console.log(1221)
    var obj = $("#gameBox");
    var odds, money, n1, n2, sort, dataAry = [];
    var data_type = $("#game_box_title li.active").attr("data-type");

    var data_action = $("#game_box_title li.active a").attr("data-action");
    var type = query("type", "?" + data_action);

    var data_number = $("#NowJq").html();
    var gameIndexStr = $("#menuText").find("span").html();
    $("#gameSubmit").focus();
    //番摊
    if (type == 23) {
        obj.find("td").each(function () {
            if ($(this).attr("data-sort") && G.DecimalSign($(this).find("input[type='text']").val()) && G.DecimalSign($(this).find("span.odds").html())) {
                sort = $(this).attr("data-sort");
                n1 = $(this).attr("data-title");
                n2 = $(this).attr("data-name");
                odds = $(this).find("span.odds").html();
                money = $(this).find("input[type='text']").val();
                dataAry.push(sort + ":" + n1 + ":" + n2 + ":" + odds + ":" + money + ":" + gameIndexStr + ":" + data_number);
            }
        });
    } else {
        obj.find("li").each(function () {
            if ($(this).attr("data-sort") && DecimalSign($(this).find("span.in input[type='text']").val()) && DecimalSign($(this).find("span.p a.oddsEvent").html())) {
                sort = $(this).attr("data-sort");
                n1 = $(this).attr("data-title");
                n2 = $(this).attr("data-name");
                odds = $(this).find("span.p a.oddsEvent").html();
                money = $(this).find("span.in input[type='text']").val();
                dataAry.push(sort + ":" + n1 + ":" + n2 + ":" + odds + ":" + money + ":" + gameIndexStr + ":" + data_number);
            }
        });
    }
    if (dataAry && dataAry.length > 0) {
        dataAry.sort(function (a, b) {
            var _a = a.split(":")[0], _b = b.split(":")[0];
            return parseInt(_a) - parseInt(_b);
        });
        var k, count = [0, 0];
        var orderWrap = "";
        orderWrap += "<table class='order' style='width:100%'><thead><tr><th width='150'>注单明细</th><th width='120'>赔率</th><th width='80'>下注金额</th><th width='60'>操作</th><th width='60' class='cursor'>打印</th></tr></thead>";
        orderWrap += "<tbody>";
        for (var i = 0; i < dataAry.length; i++) {
            k = dataAry[i].split(":");
            orderWrap += "<tr data-sort='" + k[0] + "' data-ary='" + dataAry[i] + "'>";
            orderWrap += "<td width='150'>" + k[1] + "【" + k[2] + "】</td>";
            orderWrap += "<td width='120'><div class='plShow'>" + k[3] + "</div></td>";
            orderWrap += "<td width='80'><input class='input onlyNum orderLayerInput' value='" + k[4] + "' type='text'></td>";
            orderWrap += "<td width='60'><a class='deleteOrder deleteIcon' mysort='" + k[0] + "' title='删除' href='javascript:void(0)'></a></td>";
            orderWrap += "<td width='60'><input type='checkbox' name='print' /></td>";
            orderWrap += "</tr>";
            count[0]++;
            count[1] += parseFloat(k[4]);
        }
        orderWrap += "</tbody>";
        orderWrap += "<tfoot class='zjWrap'><tr><th colspan='5'>";
        orderWrap += "总注：<span id='zj'>" + count[0] + "</span> 笔&nbsp;&nbsp;&nbsp;&nbsp;合计金额：<span id='zjm' class='blue'>" + count[1] + "</span>";
        orderWrap += "</th></tr></tfoot>";
        orderWrap += "</table>";
        var content = G.overflowDiv({ id: "orderWrap", content: orderWrap });
        var data_stop = true;/*
        alertWin({
            content: content, title: "确认下单", width: 450,
            initialize: function () {
                var _myeach = function (stop) {
                    var mycount = [0, 0];
                    $("#orderWrap input[type='text']").each(function () {
                        if (G.DecimalSign($(this).val())) {
                            mycount[0]++;
                            mycount[1] += parseFloat($(this).val());
                        }
                    });
                    if (mycount[0] == 0 && stop) {
                        $("#myWarpr").remove();
                        $("#mymask").remove();
                        return false;
                    } else {
                        $("#zj").html(mycount[0]);
                        $("#zjm").html(mycount[1]);
                    }
                };

                $("#orderWrap thead th.cursor").unbind("click").click(function () {
                    if (!$(this).attr("print")) {
                        $("#orderWrap tbody tr input[name='print']").attr("checked", "checked");
                        $(this).attr("print", "1");
                    } else {
                        $("#orderWrap tbody tr input[name='print']").attr("checked", false);
                        $(this).removeAttr("print");
                    }
                });

                $("#orderWrap input[type='text']").keyup(function () {
                    //$(this).val($(this).val().replace(/[^0-9]/g, ''));
                    G.clearNoNum($(this));
                    _myeach(false);
                });
                $("#orderWrap a.deleteOrder").unbind("click").click(function () {
                    $(this).parents("tr[data-sort='" + $(this).attr("mysort") + "']").remove();
                    _myeach(true);
                });
            },
            ok: function () {
                var dataAry = [];
                var printAry = [];
                var objM;
                $("#orderWrap tbody tr").each(function () {
                    if ($(this).attr("data-sort")) {
                        objM = $(this).find("input[type='text']:enabled");
                        if (objM.val() == "") {
                            dataAry = [];
                            G.myTips({ content: "下注金额不能为空!", obj: objM, myclick: true });
                            objM.focus();
                            return false;
                        } else if (!G.DecimalSign(objM.val()) || parseFloat(objM.val()) <= 0) {
                            dataAry = [];
                            G.myTips({ content: "下注金额不能小于单注最小下注额度：1", obj: objM, myclick: true });
                            objM.focus();
                            return false;
                        } else {
                            dataAry.push($(this).attr("data-sort") + ":" + objM.val());
                            if ($(this).find("input[name='print']").attr("checked")) {
                                printAry.push($(this).attr("data-ary"));
                            }
                        }
                    }
                });
                if (dataAry.length > 0 && data_stop) {
                    data_stop = false;
                    // var gameIndex = G.query("gameIndex", "?" + msg.data_action);
                    var type = G.query("type", "?" + data_action);
                    var gameIndex = $("#menuText").attr("data-index");
                    var opNum = $("#NowJq").html();
                    dataAry.sort(function (a, b) {
                        var _a = a.split(":")[1], _b = b.split(":")[1];
                        return parseInt(_b) - parseInt(_a);
                    });
                    $("#orderWrap tbody tr input[type='text']").val("").attr("disabled", "disabled");
                    var betType = type;
                    if (betType == 2) betType = 1;
                    else if (type == 23) betType = 7;
                    else betType = 2;
                    dataSubmit({ gameIndex: gameIndex, betType: betType, number: opNum, sortAry: dataAry.join(",") }, false, null, printAry);
                    return true;
                }
                return false;
            },
            cancel: function () { }
        });
        */
    }
}
const selectDSDX = (obj, dataIndex) => {

    var dataAction = $("#numNavList li.active a").attr("data-action");
    console.log(dataAction);
    var gameIndex = 3;//query("gameIndex", "?" + dataAction);

    var dsdx;
    var title;
    if (gameIndex == 3) {
        dsdx = [[1, 3, 5, 7, 9], [0, 2, 4, 6, 8], [5, 6, 7, 8, 9], [0, 1, 2, 3, 4]];
        title = ["第一球", "第二球", "第三球", "第四球", "第五球"];
    } else {
        dsdx = [[1, 3, 5, 7, 9], [2, 4, 6, 8, 10], [6, 7, 8, 9, 10], [1, 2, 3, 4, 5]];
        title = ["冠军", "亚军", "第三名", "第四名", "第五名", "第六名", "第七名", "第八名", "第九名", "第十名"];
    }

    var sortArr = [];

    $(".dsdx").find("a[data-index='" + dataIndex + "']").each(function () {

        var index = -1;
        if ($(this).attr("class") == "kxhotbtn") {
            if ($(this).html() == "单") index = 0;
            else if ($(this).html() == "双") index = 1;
            else if ($(this).html() == "大") index = 2;
            else if ($(this).html() == "小") index = 3;

            if (index >= 0) {
                for (var n = 0; n < dsdx[index].length; n++) {
                    sortArr.push(dsdx[index][n]);
                }
            }
        }
    });
    var sortStr = "," + sortArr.join(",") + ",";

    console.log(title[dataIndex]);
    obj.find("li[data-title='" + title[dataIndex] + "']").each(function () {
        var name = $(this).attr("data-name");
        if (sortStr.indexOf("," + name + ",") != -1) {
            if (!$(this).find("input").hasClass("check")) {

                $(this).find("input").addClass("check");
                if ($(this).find("input").val() == "") $(this).find("input").val($("#tool_ys_input").val());
            }
        } else {
            $(this).find("input").removeClass("check").val("");
        }

    });
}

const createNum = (_this) => {
    setTimeout(() => {

        $("#kx_content input[name='create-number']").unbind("click").click(function () {
            var positiontype = $("#kx_content tr.position-filter input:checked").attr("positiontype");
            var positionfilter = $("#kx_content tr.position-filter input:checked").attr("positionfilter");
            var category = $("#kuaixianList li.active a").attr("data-action");

            //五位
            var dw5zi = 0;
            if (category == 4) {
                var obj = $("#kx_content input[name='dw5zi']:checked");
                if (obj) dw5zi = obj.attr("data-index");

            } else dw5zi = $("#kx_content input[name='dw5zi']").attr("checked") == "checked" ? 1 : 0;

            //日志
            var kxlog = [];
            //生成号码数字
            var createNumberArr = [];
            //是否有输入条件
            var inputCondition = false;
            //全部号码
            var allNumberArr = [];
            //定位置
            if (positiontype == 0) {

                var wan = $("#kx_content tr.fixed-input input[name='wan']").val();
                var qian = $("#kx_content tr.fixed-input input[name='qian']").val();
                var bai = $("#kx_content tr.fixed-input input[name='bai']").val();
                var shi = $("#kx_content tr.fixed-input input[name='shi']").val();
                var ge = $("#kx_content tr.fixed-input input[name='ge']").val();

                var posNumArr = [wan, qian, bai, shi, ge];
                //填写号码的位置
                var numPos = [];
                wan.length > 0 ? numPos.push(0) : "";
                qian.length > 0 ? numPos.push(1) : "";
                bai.length > 0 ? numPos.push(2) : "";
                shi.length > 0 ? numPos.push(3) : "";
                ge.length > 0 ? numPos.push(4) : "";

                if (numPos.length > 0) {
                    inputCondition = true;
                    kxlog.push("1|" + positionfilter + "|" + posNumArr.join(":"));
                }


                if (category == numPos.length) {
                    createNumberArr = dwcreatenumber(category, posNumArr, numPos);

                    //除
                    if (positionfilter == 1) {
                        var tmpPosNumArr = ["", "", "", "", ""];
                        for (var n = 0; n < numPos.length; n++) {
                            tmpPosNumArr[numPos[n]] = "0123456789";
                        }
                        allNumberArr = dwcreatenumber(category, tmpPosNumArr, numPos);
                    }
                } else if (numPos.length > 0 && numPos.length < category) {
                    var numPosArr = getQuickNumPosArr(category, dw5zi);

                    for (var i = 0; i < numPosArr.length; i++) {
                        tmpPosNumArr = posNumArr;
                        var posArr = numPosArr[i];

                        var c = false;
                        for (var n = 0; n < numPos.length; n++) {
                            if (posArr.indexOf(numPos[n]) == -1) {
                                c = true;
                                break;
                            }
                        }
                        if (c) continue;

                        var tmpPosNumArr2 = ["", "", "", "", ""];
                        for (var n = 0; n < posArr.length; n++) {
                            if (tmpPosNumArr[posArr[n]].length == 0) tmpPosNumArr[posArr[n]] = "0123456789";

                            if (positionfilter == 1) {
                                tmpPosNumArr2[posArr[n]] = "0123456789";
                            }
                        }

                        createNumberArr = createNumberArr.concat(dwcreatenumber(category, tmpPosNumArr, posArr));
                        if (positionfilter == 1) allNumberArr = allNumberArr.concat(dwcreatenumber(category, tmpPosNumArr2, posArr));
                    }
                }

            } else { //配数
                var peiNumArr = [];
                var peiNumArr2 = [];
                for (var i = 1; i <= category; i++) {
                    var psn = $("#kx_content tr.match-input input[name='pei" + i + "']").val();
                    if (psn.length > 0) {
                        inputCondition = true;
                        peiNumArr2.push(psn);
                    }
                    peiNumArr.push(psn.length == 0 ? "0123456789" : psn);
                }

                if (inputCondition) {
                    if (positionfilter == 1) allNumberArr = getNumbersByCategory(category, dw5zi);
                    createNumberArr = peishuquanzhuan(category, peiNumArr, dw5zi, false);

                    kxlog.push("2|" + positionfilter + "|" + peiNumArr2.join(":"));

                }
            }

            if (positionfilter == 1) {
                var newNumberArr = [];
                for (var n = 0; n < allNumberArr.length; n++) {
                    if (createNumberArr.indexOf(allNumberArr[n]) == -1) newNumberArr.push(allNumberArr[n]);
                }
                createNumberArr = newNumberArr;
            }

            //全转
            var quanzhaun = $("#kx_content input[name='quanzhuan']").val();
            if (quanzhaun.length > 0) {
                tmpNumArr = [];
                if (quanzhaun.length >= category) {

                    var quanzhaunArr = [];
                    for (var i = 0; i < category; i++) {
                        quanzhaunArr.push(quanzhaun);
                    }
                    tmpNumArr = peishuquanzhuan(category, quanzhaunArr, dw5zi, true);

                }
                if (createNumberArr.length == 0 && inputCondition) {
                    createNumberArr = [];
                } else if (createNumberArr.length == 0) createNumberArr = tmpNumArr;
                else {
                    var tmpNumArr2 = [];
                    for (var i = 0; i < tmpNumArr.length; i++) {
                        if (createNumberArr.indexOf(tmpNumArr[i]) != -1) {
                            tmpNumArr2.push(tmpNumArr[i]);
                        }
                    }
                    createNumberArr = tmpNumArr2;
                }
                inputCondition = true;
                kxlog.push("3|" + quanzhaun);

            }

            //上将
            var shangjiang = $("#kx_content input[name='shangjiang']").val();
            if (shangjiang.length > 0) {
                allNumberArr = getNumbersByCategory(category, dw5zi);
                var tmpNumArr = [];
                for (var n = 0; n < allNumberArr.length; n++) {
                    var number = allNumberArr[n];
                    var pos = [];
                    for (var n2 = 0; n2 < number.length; n2++) {
                        for (var n3 = 0; n3 < shangjiang.length; n3++) {
                            if (number[n2] == shangjiang[n3] && pos.indexOf(n3) == -1) {
                                pos.push(n3);
                                break;
                            }
                        }

                    }
                    pos = pos.uniquelize();

                    if (pos.length == shangjiang.length || pos.length == category) tmpNumArr.push(number);
                }

                if (!inputCondition && quanzhaun.length == 0) {
                    createNumberArr = tmpNumArr;
                } else if (createNumberArr.length > 0) {
                    if (tmpNumArr.length == 0) createNumberArr = [];
                    else createNumberArr = Array.intersect(createNumberArr, tmpNumArr);
                }

                inputCondition = true;
                kxlog.push("4|" + shangjiang);

            }


            //值范围
            if (category == 4) {
                var zhifanwei1 = $("#kx_content td.zhi-filter-range input[name='zhifanwei1']").val();
                var zhifanwei2 = $("#kx_content td.zhi-filter-range input[name='zhifanwei2']").val();
                if (zhifanwei1.length > 0 && zhifanwei2.length > 0) {
                    tmpNumArr = [];


                    if (!inputCondition && quanzhaun.length == 0 && shangjiang.length == 0) {
                        allNumberArr = getNumbersByCategory(category, dw5zi);
                        for (var i = 0; i < allNumberArr.length; i++) {
                            var number = allNumberArr[i];
                            number = number.replace(/X/g, '');
                            var he = parseInt(number[0]) + parseInt(number[1]) + parseInt(number[2]) + parseInt(number[3]);
                            if (he >= parseInt(zhifanwei1) && he <= parseInt(zhifanwei2)) tmpNumArr.push(allNumberArr[i]);
                        }
                        createNumberArr = tmpNumArr;
                    } else if (createNumberArr.length > 0) {
                        for (var i = 0; i < createNumberArr.length; i++) {
                            var number = createNumberArr[i];
                            number = number.replace(/X/g, '');
                            var he = parseInt(number[0]) + parseInt(number[1]) + parseInt(number[2]) + parseInt(number[3]);
                            if (he >= parseInt(zhifanwei1) && he <= parseInt(zhifanwei2)) tmpNumArr.push(createNumberArr[i]);
                        }
                        createNumberArr = tmpNumArr;
                    }

                    inputCondition = true;
                    kxlog.push("5|" + zhifanwei1 + "~" + zhifanwei2);

                }
            }


            //合分
            var hefentype = $("#kx_content tr.hefen-filter input:checked").attr("hefentype");

            var hefenInfo = [];
            $("#kx_content td.hefen-filter-item").each(function () {
                var hf = $(this).find("input[type='text']").val();
                if (hf == "") return true;
                var i = 0;
                var pos = [];
                $(this).find("input[type='checkbox']").each(function () {
                    if ($(this).prop("checked")) {
                        pos.push($(this).attr("name") || i);
                    }
                    i++;
                });

                if (pos.length > 0) {
                    hefenInfo.push(pos.join(":") + "-" + hf);
                }
            });
            var tmpNumArr = [];
            if (hefenInfo.length > 0) {

                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
                for (var i = 0; i < createNumberArr.length; i++) {
                    var count = 0;
                    for (var n = 0; n < hefenInfo.length; n++) {

                        var hf = hefenInfo[n].split("-")[1];
                        var hfpos = hefenInfo[n].split("-")[0].split(":");
                        var hf2 = 0;
                        for (var n2 = 0; n2 < hfpos.length; n2++) {
                            if (createNumberArr[i][hfpos[n2]] == "X") {
                                hf2 = -1;
                                break;
                            }
                            hf2 += parseInt(createNumberArr[i][hfpos[n2]]);
                        }
                        if (hf2 < 0) continue;

                        for (var n3 = 0; n3 < hf.length; n3++) {
                            if (hf2 % 10 == hf[n3]) {
                                count++;
                                break;
                            }
                        }
                    }
                    if (count == hefenInfo.length && hefentype == 0 || count != hefenInfo.length && hefentype == 1) tmpNumArr.push(createNumberArr[i]);

                }
                createNumberArr = tmpNumArr;
                inputCondition = true;
                kxlog.push("6|" + hefentype + "|" + hefenInfo.join(";"));

            }

            //不定位合分
            var budinghetype = $("#kx_content td.budinghe-filter input[type=checkbox]:checked").attr("budinghetype");
            var budinghe = $("#kx_content td.budinghe-filter input[type='text']").val();

            if ((budinghetype == 2 || budinghetype == 3) && budinghe.length > 0) {
                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);

                tmpNumArr = [];
                for (var i = 0; i < createNumberArr.length; i++) {
                    var number = createNumberArr[i];
                    number = number.replace("/X/g", "");
                    var ext = false;
                    for (var n = 0; n < number.length; n++) {
                        for (var n2 = n + 1; n2 < number.length; n2++) {
                            if (budinghetype == 2) {
                                var value = (parseInt(number[n]) + parseInt(number[n2])) % 10;
                                if (budinghe.indexOf(value) != -1) { tmpNumArr.push(createNumberArr[i]); ext = true; break; }
                            } else {
                                for (var n3 = n2 + 1; n3 < number.length; n3++) {
                                    var value = (parseInt(number[n]) + parseInt(number[n2]) + parseInt(number[n3])) % 10;
                                    if (budinghe.indexOf(value) != -1) { tmpNumArr.push(createNumberArr[i]); ext = true; break; }

                                }
                            }
                            if (ext) break;

                        }
                        if (ext) break;
                    }
                }

                createNumberArr = tmpNumArr;
                inputCondition = true;
                kxlog.push("7|" + budinghetype + "|" + budinghe);

            }

            //排除
            var paichu = $("#kx_content input[name='paichu']").val();
            if (paichu.length > 0) {

                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
                tmpNumArr = [];
                for (var i = 0; i < createNumberArr.length; i++) {
                    var number = createNumberArr[i];

                    var b = false;
                    for (var n = 0; n < paichu.length; n++) {
                        if (number.indexOf(paichu[n]) != -1) {
                            b = true;
                            break
                        }
                    }
                    if (!b) tmpNumArr.push(number);
                }
                createNumberArr = tmpNumArr;
                inputCondition = true;
                kxlog.push("8|" + paichu);

            }

            //乘号位置
            var chhaoArr = [];
            $("#kx_content input.symbol-filter-item:checked").each(function () {
                chhaoArr.push($(this).attr("name"));
            });
            if (chhaoArr.length > 0 && category != 4) {
                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
                tmpNumArr = [];
                for (var i = 0; i < createNumberArr.length; i++) {
                    var number = createNumberArr[i];
                    b = true;
                    for (var n = 0; n < chhaoArr.length; n++) {
                        if (number[chhaoArr[n]] != "X") {
                            b = false;
                            break
                        }
                    }
                    if (b) tmpNumArr.push(number);
                }
                createNumberArr = tmpNumArr;
                inputCondition = true;
                kxlog.push("9|" + chhaoArr.join(":"));

            }
            //含数复数
            var containfilter = $("#kx_content td.contain-filter input[type='checkbox']:checked").attr("containfilter");
            var han = $("#kx_content td.contain-filter input[name='han']").val();
            var fushi = $("#kx_content td.contain-filter input[name='fushi']").val();
            if (containfilter >= 0 && han.length > 0) {
                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
                tmpNumArr = [];
                for (var i = 0; i < createNumberArr.length; i++) {
                    var number = createNumberArr[i];
                    b = false;
                    for (var n = 0; n < han.length; n++) {
                        if (number.indexOf(han[n]) != -1) {
                            b = true;
                            break
                        }
                    }
                    if (containfilter == 0 && b) tmpNumArr.push(number);
                    else if (containfilter == 1 && !b) tmpNumArr.push(number);
                }
                createNumberArr = tmpNumArr;
                inputCondition = true;
                kxlog.push("10|" + containfilter + "|" + han);

            }

            if (containfilter >= 0 && fushi.length > 0) {
                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
                tmpNumArr = [];
                for (var i = 0; i < createNumberArr.length; i++) {
                    var number = createNumberArr[i];
                    b = true;
                    for (var n = 0; n < number.length; n++) {
                        if (number[n] != 'X' && fushi.indexOf(number[n]) == -1) {
                            b = false;
                            break
                        }
                    }
                    if (containfilter == 0 && b) tmpNumArr.push(number);
                    else if (containfilter == 1 && !b) tmpNumArr.push(number);
                }
                createNumberArr = tmpNumArr;
                inputCondition = true;
                kxlog.push("11|" + containfilter + "|" + fushi);

            }

            //重
            var chongname = ["two", "three", "four", "double"];
            var len = category < 4 ? category - 1 : category;
            var chongArr = [];
            for (var n = 0; n < len; n++) {
                var repeatwordsfilter = $("#kx_content  input[class='repeat-" + chongname[n] + "-words-filter']:checked").attr("repeatwordsfilter");
                if (repeatwordsfilter >= 0) {
                    chongArr.push(n + ":" + repeatwordsfilter);
                }
            }
            if (chongArr.length > 0) {
                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
                inputCondition = true;
                tmpNumArr = [];
                for (var i = 0; i < createNumberArr.length; i++) {
                    var number = createNumberArr[i];
                    var b = true;

                    for (var n = 0; n < chongArr.length; n++) {
                        var chcondition = chongArr[n];

                        var index = parseInt(chcondition.split(":")[0]);
                        var qu = parseInt(chcondition.split(":")[1]);
                        var count = chong(number);

                        //双重
                        if (index == 0 && qu == 0 && count < 2) b = false;
                        if (index == 0 && qu == 1 && count >= 2) b = false;
                        if (index == 0 && qu >= 0 && !b) break;

                        //三重
                        if (category >= 3) {

                            if (index == 1 && qu == 0 && !(count >= 3 && count <= 4)) b = false;
                            if (index == 1 && qu == 1 && (count >= 3 && count <= 4)) b = false;
                            if (index == 1 && qu >= 0 && !b) break;

                        }

                        if (category == 4) {

                            //双双重
                            if (index == 3 && qu == 0 && !(count >= 4 && count <= 5)) b = false;
                            if (index == 3 && qu == 1 && (count >= 4 && count <= 5)) b = false;
                            if (index == 3 && qu >= 0 && !b) break;

                            //四重
                            if (index == 2 && qu == 0 && !(count == 4)) b = false;
                            if (index == 2 && qu == 1 && (count == 4)) b = false;
                            if (index == 2 && qu >= 0 && !b) break;
                        }
                    }

                    if (b) tmpNumArr.push(number);
                }
                createNumberArr = tmpNumArr;
                kxlog.push("12|" + chongArr.join("|"));

            }

            //对数
            var logarithmnumberfilter = $("#kx_content input[class='logarithm-number-filter']:checked").attr("logarithmnumberfilter");
            var duishuiArr = [];
            for (var n = 1; n <= 3; n++) {
                var ds = $("#kx_content input[name='duishu" + n + "'] ").val();
                if (ds.length == 2 && (ds[0] - ds[1] == 5 || (ds[0] - ds[1] == -5))) {
                    duishuiArr.push(ds);
                } else if (ds.length > 0) {
                    G.myTips({ content: "请输入差值为5的数", obj: $("#kx_content input[name='duishu" + n + "'] "), myclick: true });
                    return;
                }
            }
            if (logarithmnumberfilter >= 0 && duishuiArr.length > 0) {
                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
                inputCondition = true;
                tmpNumArr = [];
                for (var i = 0; i < createNumberArr.length; i++) {
                    number = createNumberArr[i];
                    b = false;
                    for (var n = 0; n < duishuiArr.length; n++) {
                        if (number.indexOf(duishuiArr[n][0]) != -1 && number.indexOf(duishuiArr[n][1]) != -1) {
                            b = true;
                            break;
                        }
                    }

                    if (logarithmnumberfilter == 1) b = !b;

                    if (b) tmpNumArr.push(number);
                }
                createNumberArr = tmpNumArr;
                kxlog.push("13|" + logarithmnumberfilter + "|" + duishuiArr.join(":"));

            } else if (logarithmnumberfilter >= 0 && duishuiArr.length == 0) {
                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
                inputCondition = true;
                tmpNumArr = [];
                for (var i = 0; i < createNumberArr.length; i++) {
                    number = createNumberArr[i];
                    number = number.replace(/X/g, '');
                    b = false;
                    for (var n = 0; n < number.length - 1; n++) {
                        for (var n2 = n + 1; n2 < number.length; n2++)
                            if (number[n] - number[n2] == 5 || number[n] - number[n2] == -5) {
                                b = true;
                                break;
                            }
                    }


                    if (logarithmnumberfilter == 1) b = !b;

                    if (b) tmpNumArr.push(createNumberArr[i]);
                }
                createNumberArr = tmpNumArr;
                kxlog.push("13|" + logarithmnumberfilter + "| ");

            }


            var brotherClass = ["two", "three", "four"];
            var brotherArr = [];
            for (var n = 0; n < category - 1; n++) {
                var brotherfilter = $("#kx_content input[class='" + brotherClass[n] + "-brother-filter']:checked").attr("brotherfilter");
                if (brotherfilter >= 0) {
                    brotherArr.push(n + ":" + brotherfilter);
                }
            }
            if (brotherArr.length > 0) {
                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
                inputCondition = true;

                tmpNumArr = [];
                for (var i = 0; i < createNumberArr.length; i++) {
                    var number = createNumberArr[i];
                    var b = true;
                    for (var k = 0; k < brotherArr.length; k++) {

                        var index = brotherArr[k].split(":")[0];
                        var qu = brotherArr[k].split(":")[1];

                        if (index == 0 && qu == 0 && brother(number) < 2) b = false;
                        if (index == 0 && qu == 1 && brother(number) >= 2) b = false;

                        if (index == 1 && qu == 0 && brother(number) < 3) b = false;
                        if (index == 1 && qu == 1 && brother(number) >= 3) b = false;

                        if (index == 2 && qu == 0 && brother(number) != 4) b = false;
                        if (index == 2 && qu == 1 && brother(number) == 4) b = false;

                        if (!b) break;
                    }
                    if (b) tmpNumArr.push(number);
                }
                createNumberArr = tmpNumArr;
                kxlog.push("14|" + brotherArr.join("|"));

            }

            var oddnumberfilter = $("#kx_content input[class='odd-number-filter']:checked").attr("oddnumberfilter");
            var evennumberfilter = $("#kx_content input[class='even-number-filter']:checked").attr("evennumberfilter");
            var oddnumberArr = [];
            var evennumberArr = [];

            var depos = 0;
            $("#kx_content input[class='odd-number-item']").each(function () {
                if ($(this).prop("checked")) oddnumberArr.push($(this).attr("name") || depos);
                depos++;
            });

            if (oddnumberfilter >= 0 && oddnumberArr.length > 0) {
                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
                inputCondition = true;
                tmpNumArr = [];
                for (var i = 0; i < createNumberArr.length; i++) {
                    var number = createNumberArr[i];
                    var b = true;
                    for (var n = 0; n < oddnumberArr.length; n++) {
                        if (number[oddnumberArr[n]] == "X" || parseInt(number[oddnumberArr[n]]) % 2 == 0) {
                            b = false;
                            break;
                        }
                    }

                    if (oddnumberfilter == 1) b = !b;
                    if (b) tmpNumArr.push(number);
                }
                createNumberArr = tmpNumArr;
                kxlog.push("15|" + oddnumberfilter + "|" + oddnumberArr.join("|"));

            }

            depos = 0;
            $("#kx_content input[class='even-number-item']").each(function () {
                if ($(this).prop("checked")) evennumberArr.push($(this).attr("name") || depos);
                depos++;
            });

            if (evennumberfilter >= 0 && evennumberArr.length > 0) {
                if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
                inputCondition = true;
                tmpNumArr = [];
                for (var i = 0; i < createNumberArr.length; i++) {
                    var number = createNumberArr[i];
                    var b = true;
                    for (var n = 0; n < evennumberArr.length; n++) {
                        if (number[evennumberArr[n]] == "X" || parseInt(number[evennumberArr[n]]) % 2 != 0) {
                            b = false;
                            break;
                        }
                    }

                    if (evennumberfilter == 1) b = !b;
                    if (b) tmpNumArr.push(number);
                }
                createNumberArr = tmpNumArr;
                kxlog.push("16|" + evennumberfilter + "|" + evennumberArr.join("|"));

            }


            if (!inputCondition) {
                G.alert({ content: "请选择或填写条件生成！。", ok: function () { return true; } });
                return;
            }

            //kxnumbers
            createNumberArr = getQuickCreateNumbers(createNumberArr);
            if (createNumberArr.length == 0) {
                $("#kxnumbers").html("没有这样的号码");
            } else {
                createNumberArr = createNumberArr.sort();
                var row = parseInt(createNumberArr.length / 10);
                if (createNumberArr.length % 10 > 0) row += 1;
                var htmlData = [];
                htmlData.push("<table >");
                htmlData.push("<tbody >");


                for (var n = 0; n < row; n++) {
                    htmlData.push("<tr>");
                    for (var n2 = 0; n2 < 10; n2++) {
                        if (n * 10 + n2 < createNumberArr.length) {
                            var num = createNumberArr[n * 10 + n2];
                            htmlData.push("<td >" + num + "</td>");
                        } else {
                            htmlData.push("<td >--</td>");
                        }
                    }
                    htmlData.push("</tr>");
                }

                htmlData.push("</tbody>");
                htmlData.push("</table>");
                $("#kxnumbers").html(htmlData.join(""));
                $("#kxlog").html(category + "," + dw5zi + "," + kxlog.join(","));
                $("#zbishu").html(createNumberArr.length);
                if ($("#tool_ys_input").val().length > 0) {
                    $("#zmoney").html(parseFloat($("#tool_ys_input").val()) * createNumberArr.length)
                } else {
                    $("#zmoney").html("");
                }
            }
        });

        $("#kxSubmit").unbind("click").click(function () {
            var money = $("#tool_ys_input").val();
            if (money.length == 0 || parseFloat(money) <= 0) {
                return;
            }

            var numberArr = [];
            $("#kxnumbers").find("td").each(function () {
                var number = $(this).html();
                var type = getDWTypeByName(number);
                if (type > 0) numberArr.push(type + ":" + money);
            });

            if (numberArr.length == 0) {
                return;
            }

            if (numberArr.length > 10000) {
                G.alert({ content: "单笔最大只能下注10000注", ok: function () { return true; } });
                return;
            }

            var gameIndex = $("#menuText").attr("data-index");
            var opNum = $("#NowJq").html();
            numberArr.sort(function (a, b) {
                var _a = a.split(":")[0], _b = b.split(":")[0];
                return parseInt(_b) - parseInt(_a);
            });
            var printAry = [];

            if ($("#tool_ys_input").val().length == 0) return;

            $("#tool_ys_input").val("");
            console.log(12121)
            // dataSubmit({ gameIndex: gameIndex, betType: 4, data: $("#kxlog").html(), number: opNum, sortAry: numberArr.join(",") }, false, null, printAry);


        });
    }, 0);
}
const moveGg = () => {

    $.fn.extend({
        //---元素拖动插件
        dragging: function (data) {
            var $this = $(this);
            var xPage;
            var yPage;
            var X;//
            var Y;//
            var xRand = 0;//
            var yRand = 0;//
            var father = $this.parent();
            var defaults = {
                move: 'both',
                randomPosition: true,
                hander: 1
            }
            var opt = $.extend({}, defaults, data);
            var movePosition = opt.move;
            var random = opt.randomPosition;

            var hander = opt.hander;

            if (hander == 1) {
                hander = $this;
            } else {
                hander = $this.find(opt.hander);
            }


            //---初始化
            $this.css({ "position": "absolute" });
            hander.css({ "cursor": "move" });

            var faWidth = $(window).width();
            var faHeight = $(window).height();
            var thisWidth = $this.width() + parseInt($this.css('padding-left')) + parseInt($this.css('padding-right'));
            var thisHeight = $this.height() + parseInt($this.css('padding-top')) + parseInt($this.css('padding-bottom'));

            var mDown = false;//
            var positionX;
            var positionY;
            var moveX;
            var moveY;

            if (random) {
                $thisRandom();
            }
            function $thisRandom() { //随机函数
                $this.each(function (index) {
                    var randY = parseInt(Math.random() * (faHeight - thisHeight));///
                    var randX = parseInt(Math.random() * (faWidth - thisWidth));///
                    if (movePosition.toLowerCase() == 'x') {
                        $(this).css({
                            left: randX
                        });
                    } else if (movePosition.toLowerCase() == 'y') {
                        $(this).css({
                            top: randY
                        });
                    } else if (movePosition.toLowerCase() == 'both') {
                        $(this).css({
                            top: randY,
                            left: randX
                        });
                    }

                });
            }


            hander.mousedown(function (e) {
                father.children().css({ "zIndex": "0" });
                $this.css({ "zIndex": "1" });
                mDown = true;
                X = e.pageX;
                Y = e.pageY;
                positionX = $this.position().left;
                positionY = $this.position().top;
                return false;
            });

            $(document).mouseup(function (e) {
                mDown = false;
            });

            $(document).mousemove(function (e) {
                xPage = e.pageX;//--
                moveX = positionX + xPage - X;

                yPage = e.pageY;//--
                moveY = positionY + yPage - Y;

                function thisXMove() { //x轴移动
                    if (mDown == true) {
                        $this.css({ "left": moveX });
                    } else {
                        return;
                    }
                    if (moveX < 0) {
                        $this.css({ "left": "0" });
                    }
                    if (moveX > (faWidth - thisWidth)) {
                        $this.css({ "left": faWidth - thisWidth });
                    }
                    return moveX;
                }

                function thisYMove() { //y轴移动
                    if (mDown == true) {
                        $this.css({ "top": moveY });
                    } else {
                        return;
                    }
                    if (moveY < 0) {
                        $this.css({ "top": "0" });
                    }
                    if (moveY > (faHeight - thisHeight)) {
                        $this.css({ "top": faHeight - thisHeight });
                    }
                    return moveY;
                }

                function thisAllMove() { //全部移动
                    if (mDown == true) {
                        $this.css({ "left": moveX, "top": moveY });
                    } else {
                        return;
                    }
                    if (moveX < 0) {
                        $this.css({ "left": "0" });
                    }
                    if (moveX > (faWidth - thisWidth)) {
                        $this.css({ "left": faWidth - thisWidth });
                    }

                    if (moveY < 0) {
                        $this.css({ "top": "0" });
                    }
                    if (moveY > (faHeight - thisHeight)) {
                        $this.css({ "top": faHeight - thisHeight });
                    }
                }
                if (movePosition.toLowerCase() == "x") {
                    thisXMove();
                } else if (movePosition.toLowerCase() == "y") {
                    thisYMove();
                } else if (movePosition.toLowerCase() == 'both') {
                    thisAllMove();
                }
            });

            $("#small_button").click(function () {

                let centerGgIndex = window.sessionStorage.getItem("centerGgIndex");
                if (centerGgIndex) {
                    window.sessionStorage.setItem("centerGgIndex", "");
                    $("#right-notice-box").css({
                        "display": "none"
                    })
                }
            });
        }

    });
    $('.box-31 dl').each(function () {
        $(this).dragging({
            move: 'both',
            randomPosition: false
        });
    });
}

const defaultPosition = () => {

    var w = "44%";
    var h1 = "30vh";

    $(".box-31 dl").animate({

        top: h1,
        right: w,
    }, 200);
}
const coverTime = () => {
    let fmt = "YYYYMM", date = new Date();
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(Y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}


const changeXz = () => {
    $("#tool_ys_wrap span a").unbind("click").click(function () {
        var val = $(this).html();
        var mycheck = $("#gameBox input.check");
        $("#tool_ys_input").val(val);
        mycheck.each(function () {
            console.log(this)
            if ($(this).val() == "") {
                $(this).val(val);
            }
        });
    });
    $("#tool_ys_wrap em b").unbind("click").click(function () {
        var ary = [];
        $("#tool_ys_wrap span a").each(function (i) {
            ary[i] = $(this).html();
        });
        $("#tool_ys_wrap em strong input[type='text']").each(function (i) {
            $(this).val(ary[i]);
        });
        $("#tool_ys_wrap em strong").css("display", "block");
    });
    $("#tool_ys_wrap em strong input[type='button']").unbind("click").click(function () {
        var ary = [];
        $("#tool_ys_wrap em strong input[type='text']").each(function (i) {
            ary[i] = $(this).val();
        });
        $("#tool_ys_wrap span a").each(function (i) {
            $(this).html(ary[i]);
        });
        $("#tool_ys_wrap em strong").css("display", "none");
    });
}
const query = (name, referrer) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var _referrer = referrer || location.href;
    var r = decodeURI(_referrer).split("?")[1].match(reg);
    if (r != null)
        return unescape(r[2]);
    return null;
}
const clearNoNum = (obj) => {
    obj.val(obj.val().replace(/[^\d.]/g, "")); //清除“数字”和“.”以外的字符
    obj.val(obj.val().replace(/^\./g, "")); //验证第一个字符是数字而不是.
    obj.val(obj.val().replace(/\.{2,}/g, ".")); //只保留第一个. 清除多余的.
    obj.val(obj.val().replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')); //只能输入两个小数
    obj.val(obj.val().replace(".", "$#$").replace(/\./g, "").replace("$#$", "."));
}

const selectDW = (obj, t) => {
    /*
        var type = query("type", "?" + $("#subNavList a.selected").attr("data-action"));
        console.log(type);
        obj.find("input[type='text']").removeClass("check");

        var one = [], two = [];
        $("#fix_1").find("a[class='kxhotbtn']").each(function () {
            one.push(parseInt($(this).attr("name")))

        });
        $("#fix_2").find("a[class='kxhotbtn']").each(function () {
            two.push(parseInt($(this).attr("name")))
        });

        var dsdx = [[1, 3, 5, 7, 9], [0, 2, 4, 6, 8], [5, 6, 7, 8, 9], [0, 1, 2, 3, 4]];
        var sortArr = [];
        for (var i = 0; i < one.length; i++) {
            for (var k = 0; k < two.length; k++) {
                if (one[i] <= 9 && two[k] <= 9) {
                    sortArr.push(one[i] * 10 + two[k]);
                } else if (one[i] <= 9 && two[k] > 9) {
                    for (var j = 0; j < dsdx[two[k] - 10].length; j++) {
                        sortArr.push(one[i] * 10 + dsdx[two[k] - 10][j]);
                    }
                } else if (one[i] > 9 && two[k] <= 9) {
                    for (var j = 0; j < dsdx[one[i] - 10].length; j++) {
                        sortArr.push(dsdx[one[i] - 10][j] * 10 + two[k]);
                    }
                } else {
                    for (var j = 0; j < dsdx[one[i] - 10].length; j++) {
                        for (var p = 0; p < dsdx[two[k] - 10].length; p++) {
                            sortArr.push(dsdx[one[i] - 10][j] * 10 + dsdx[two[k] - 10][p]);
                        }
                    }
                }
            }
        }

        //合分
        var hefen = [
            [0, 19, 28, 37, 46, 55, 64, 73, 82, 91],
            [1, 10, 29, 38, 47, 56, 65, 74, 83, 92],
            [2, 11, 20, 39, 48, 57, 66, 75, 84, 93],
            [3, 12, 21, 30, 49, 58, 67, 76, 85, 94],
            [4, 22, 31, 13, 40, 59, 68, 77, 86, 95],
            [5, 14, 41, 23, 32, 50, 69, 78, 87, 96],
            [6, 15, 51, 24, 42, 33, 60, 79, 88, 97],
            [7, 16, 61, 25, 52, 34, 43, 70, 89, 98],
            [8, 17, 71, 26, 62, 35, 53, 44, 80, 99],
            [9, 18, 81, 27, 72, 36, 63, 45, 54, 90]
        ];


        $("#fn-hf").find("a[class='kxhotbtn']").each(function () {
            var name = parseInt($(this).attr("name"));
            if (name >= 0 && name <= 9) {
                for (var i = 0; i < hefen[name].length; i++) {
                    sortArr.push(hefen[name][i]);
                }
            } else {
                for (var i = 0; i < dsdx[name - 10].length; i++) {
                    for (var k = 0; k < hefen[i].length; k++) {
                        sortArr.push(hefen[dsdx[name - 10][i]][k]);
                    }

                }
            }
        });

        //输入定位
        var ipdw_1 = $("#ipdw_1").val();
        var ipdw_2 = $("#ipdw_2").val();
        for (var i = 0; i < ipdw_1.length; i++) {
            for (var k = 0; k < ipdw_2.length; k++) {
                if (parseInt(ipdw_1[i]) >= 0 && parseInt(ipdw_2[k]) >= 0) {
                    sortArr.push(parseInt(ipdw_1[i]) * 10 + parseInt(ipdw_2[k]))
                }
            }
        }

        var startTypes = [108, 208, 308, 408, 508, 608, 708, 808, 908, 1008];

        var sortArr2 = [];

        for (var i = 0; i < sortArr.length; i++) {
            sortArr2.push((sortArr[i] + startTypes[type - 9]));
            // console.log(sortArr[i]);
            // if (!obj.find("li[data-sort='"+(sortArr[i] + startTypes[type-9])+"'] input").hasClass("check")){
            //     obj.find("li[data-sort='"+(sortArr[i] + startTypes[type-9])+"'] input").addClass("check").val($("#tool_ys_input").val());
            //
            // }
        }

        var sortStr = "," + sortArr2.join(",") + ",";
        console.log(sortStr);
        obj.find("li").each(function () {
            var sort = $(this).attr("data-sort");
            if (sortStr.indexOf(("," + sort + ",")) != -1) {
                if (!$(this).find("input").hasClass("check")) {
                    $(this).find("input").addClass("check");
                    if ($(this).find("input").val() == "") $(this).find("input").val($("#tool_ys_input").val());
                }
            } else {
                $(this).find("input").removeClass("check").val("");
            }
        });
    */

}

const yzdMethod = () => {
    var gameIndex = $("#menuText").attr("data-index");
    var obj = $("#gameBox");
    obj.find("input[type='text']").keyup(function () {
        clearNoNum($(this));
    });
    obj.find("input[type='text']").focus(function () {
        if (!$(this).hasClass("check")) {
            $(this).val($("#tool_ys_input").val());
            $(this).addClass("check");
        } else {
            $(this).val("");
            $(this).removeClass("check");
        }
    });
    obj.find("li span.p a.").unbind("click").click(function () {
        var n1 = $(this).parents("li").attr("data-title");
        var n2 = $(this).parents("li").attr("data-name");
        var sort = $(this).parents("li").attr("data-sort");
        var odds = $(this).html();
        myWarp({ gameIndex: gameIndex, odds: odds, n1: n1, n2: n2, sort: sort, obj: $(this) });
    });
    //勾选項
    obj.find("li span.in a").unbind("click").click(function () {
        var myclass = $(this).attr("class");
        var mymax = parseInt($("#gameTitle li.active").attr("data-max"));
        if (myclass.indexOf("radiodsable") == -1) {
            if (myclass.indexOf("radioPoint") == -1) {
                $(this).addClass("radioPoint");
                enachRadioPoint($(this), mymax);
            } else {
                $(this).removeClass("radioPoint");
            }
        }
    });

    $("#clearBtn").unbind("click").click(function () {
        obj.find("input[type='text']").val("").removeClass("check");
        $("#gameBox li span.in a.radioSim").removeClass("radioPoint");
        obj.find("a[class='kxhotbtn']").each(function () {
            $(this).attr("class", "kxbtn");
        });
        $("#ipdw_1").val("");
        $("#ipdw_2").val("");
    });
    var data_type = parseInt(query("type", "?" + $("#game_box_title li.active a").attr("data-action")));
    $("#gameSubmit").unbind("click").click(function () {
        console.log(123123)
        if (gameIndex == 1 && (data_type == 4 || data_type == 16 || data_type == 22 || data_type == 29)) {
            gameHxSubmit(data_type);
        } else if ((gameIndex == 2 || gameIndex == 7) && data_type == 12) {
            gameHxSubmit(data_type);
        } else {
            gameSubmit();
        }
    });
    obj.find("input[type='text']").keydown(function (e) {
        var curKey = e.which;
        if (curKey == 13) {
            $("#gameSubmit").click();
            return false;
        }
    });

    obj.find("div[class='dsdx'] a").unbind("click").click(function () {
        var classAttr = $(this).attr("class");
        var check;
        if (classAttr == "kxhotbtn") {
            $(this).attr("class", "kxbtn");
            check = false;
        }
        else {
            $(this).attr("class", "kxhotbtn");
            check = true;
        }

        selectDSDX(obj, $(this).attr("data-index"));


    });

    obj.find("table[class='t_dw'] a").unbind("click").click(function () {
        var classAttr = $(this).attr("class");
        if (classAttr == "kxhotbtn") {
            $(this).attr("class", "kxbtn");
        }
        else {
            $(this).attr("class", "kxhotbtn");
        }
        selectDW(obj, this);

    });
    obj.find("table[class='t_dw'] input").keyup(function () {
        selectDW(obj, $(this));
    });

    obj.find("div[class='triangle-topleft']").unbind("click").click(function () {
        var sort = $(this).attr("data-index");
        for (var n = 0; n < 10; n++) {

            if (!obj.find("li[data-sort='" + sort + "'] input[type='text']").hasClass("check")) {
                obj.find("li[data-sort='" + sort + "'] input[type='text']").val($("#tool_ys_input").val());
                obj.find("li[data-sort='" + sort + "'] input[type='text']").addClass("check");
            } else {
                obj.find("li[data-sort='" + sort + "'] input[type='text']").val("");
                obj.find("li[data-sort='" + sort + "'] input[type='text']").removeClass("check");
            }
            sort++;
        }
    });

    obj.find("div[class='triangle-right']").unbind("click").click(function () {
        var sort = $(this).attr("data-index");
        sort = parseInt(sort);
        for (var n = 0; n < 10; n++) {

            if (!obj.find("li[data-sort='" + sort + "'] input[type='text']").hasClass("check")) {
                obj.find("li[data-sort='" + sort + "'] input[type='text']").val($("#tool_ys_input").val());
                obj.find("li[data-sort='" + sort + "'] input[type='text']").addClass("check");
            } else {
                obj.find("li[data-sort='" + sort + "'] input[type='text']").val("");
                obj.find("li[data-sort='" + sort + "'] input[type='text']").removeClass("check");
            }
            sort += 10;
        }
    });


    //快捷下注金额
    $("#tool_ys_wrap input[type='text']").focus(function () {
        $(this).val("");
    });
    $("#tool_ys_wrap input[type='text']").keyup(function () {
        clearNoNum($(this));
    });
    $("#tool_ys_wrap span a").unbind("click").click(function () {
        var val = $(this).html();
        var mycheck = $("#gameBox input.check");
        $("#tool_ys_input").val(val);
        mycheck.each(function () {
            if ($(this).val() == "") {
                $(this).val(val);
            }
        });
    });
    $("#tool_ys_wrap em b").unbind("click").click(function () {
        var ary = [];
        $("#tool_ys_wrap span a").each(function (i) {
            ary[i] = $(this).html();
        });
        $("#tool_ys_wrap em strong input[type='text']").each(function (i) {
            $(this).val(ary[i]);
        });
        $("#tool_ys_wrap em strong").css("display", "block");
    });
    $("#tool_ys_wrap em strong input[type='button']").unbind("click").click(function () {
        var ary = [];
        $("#tool_ys_wrap em strong input[type='text']").each(function (i) {
            ary[i] = $(this).val();
        });
        $("#tool_ys_wrap span a").each(function (i) {
            $(this).html(ary[i]);
        });
        $("#tool_ys_wrap em strong").css("display", "none");
    });

}

const kuaiXuanClick = (vue) => {
    console.log('kuaiXuanClick', vue)
    $("#kx_content input[name='reset-number']").click(function () {
        var category = $("#kuaixianList li.active a").attr("data-action");
        kxcontent(category,vue);
    });
    $("#kx_content input[type='text']").keyup(function () {
        $(this).val($(this).val().replace(/[^0-9]/g, ''));
    });

    $("#kx_content tr.position-filter input").unbind("change").change(function () {

        var positiontype = $(this).attr("positiontype");
        var positionfilter = $(this).attr("positionfilter");
        for (let i = 0; i < $("#kx_content tr.position-filter input").length; i++) {
            document.getElementById("kx_content").getElementsByTagName("input")[i].checked = false;
        }
        $(this)[0].checked = true;

        if (positiontype == 0) {
            $("#kx_content tr.fixed-input").attr("style", "");
            $("#kx_content tr.match-input").attr("style", "display: none");
            $("#kx_content tr.match-input input[type='text']").val('');
        } else {
            $("#kx_content tr.fixed-input").attr("style", "display: none");
            $("#kx_content tr.match-input").attr("style", "");
            $("#kx_content tr.fixed-input input[type='text']").val('');
        }

    });


    $("#kx_content tr.hefen-filter input").unbind("change").change(function () {

        let checkBox = $("#kx_content tr.hefen-filter input");
        for (let i = 0; i < checkBox.length; i++) {
            checkBox[i].checked = false;
        }
        $(this)[0].checked = true;
        /*
        $("#kx_content tr.hefen-filter input").attr("checked", false);
        $(this).attr("checked", "checked");
        */
    });

    $("#kx_content td.budinghe-filter input[type='checkbox']").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content td.budinghe-filter input[type='checkbox']").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });

    //contain-filter
    $("#kx_content td.contain-filter input[type='checkbox']").unbind("change").change(function () {
        let checkBox = $("#kx_content td.contain-filter input[type='checkbox']");
        for (let i = 0; i < checkBox.length; i++) {
            if(checkBox[i] != this){
                checkBox[i].checked = false;
            }
        }
    });

    $("#kx_content  input.repeat-two-words-filter").unbind("change").change(function () {
        let checkBox = $("#kx_content input.repeat-two-words-filter");
        for (let i = 0; i < checkBox.length; i++) {
            if(checkBox[i] != this){
                checkBox[i].checked = false;
            }
        }
    });

    $("#kx_content input.repeat-three-words-filter").unbind("change").change(function () {

        let checkBox = $("#kx_content input.repeat-three-words-filter");
        for (let i = 0; i < checkBox.length; i++) {
            if(checkBox[i] != this){
                checkBox[i].checked = false;
            }
        }
    });

    $("#kx_content input.repeat-four-words-filter").unbind("change").change(function () {
        let checkBox = $("#kx_content input.repeat-four-words-filter");
        for (let i = 0; i < checkBox.length; i++) {
            if(checkBox[i] != this){
                checkBox[i].checked = false;
            }
        }
    });

    $("#kx_content input.repeat-double-words-filter").unbind("change").change(function () {
        let checkBox = $("#kx_content input.repeat-double-words-filter");
        for (let i = 0; i < checkBox.length; i++) {
            if(checkBox[i] != this){
                checkBox[i].checked = false;
            }
        }
    });


    $("#kx_content input.two-brother-filter").unbind("change").change(function () {
        let checkBox = $("#kx_content input.two-brother-filter");
        for (let i = 0; i < checkBox.length; i++) {
            if(checkBox[i] != this){
                checkBox[i].checked = false;
            }
        }
    });

    $("#kx_content input.three-brother-filter").unbind("change").change(function () {

        let checkBox = $("#kx_content input.three-brother-filter");
        for (let i = 0; i < checkBox.length; i++) {
            if(checkBox[i] != this){
                checkBox[i].checked = false;
            }
        }
    });

    $("#kx_content input.four-brother-filter").unbind("change").change(function () {
        let checkBox = $("#kx_content input.four-brother-filter");
        for (let i = 0; i < checkBox.length; i++) {
            if(checkBox[i] != this){
                checkBox[i].checked = false;
            }
        }
    });

    $("#kx_content input.logarithm-number-filter").unbind("change").change(function () {

        let checkBox = $("#kx_content input.logarithm-number-filter");
        for (let i = 0; i < checkBox.length; i++) {
            if(checkBox[i] != this){
                checkBox[i].checked = false;
            }
        }
    });

    $("#kx_content input.odd-number-filter").unbind("change").change(function () {
        let checkBox = $("#kx_content input.odd-number-filter");
        for (let i = 0; i < checkBox.length; i++) {
            if(checkBox[i] != this){
                checkBox[i].checked = false;
            }
        }
    });

    $("#kx_content input.even-number-filter").unbind("change").change(function () {
        let checkBox = $("#kx_content input.even-number-filter");
        for (let i = 0; i < checkBox.length; i++) {
            if(checkBox[i] != this){
                checkBox[i].checked = false;
            }
        }
    });


    $("#kuaixianList a[data-action]").unbind("click").click(function () {

        var dataAction = $(this).attr("data-action");

        $("#kuaixianList li").removeClass("active");
        $(this).parent("li").addClass("active");

        kxcontent(dataAction, vue);

    });

    let inputNodeChecked = false;
    $("#wwrdPnode").on('click', $("#wwrd"), () => {
        inputNodeChecked = !inputNodeChecked;
        $("#wwrd")[0].checked = inputNodeChecked;
    })
    let zdz = document.getElementsByClassName("zdz");
    for (let i = 0; i < zdz.length; i++) {
        zdz[i].onclick = function () {
            for (let q = 0; q < zdz.length; q++) {
                zdz[q].checked = false;
            }
            zdz[i].checked = true;
        }
    }

    $("#kx_content input[name='create-number']").unbind("click").click(function () {
        var positiontype = $("#kx_content tr.position-filter input:checked").attr("positiontype");
        var positionfilter = $("#kx_content tr.position-filter input:checked").attr("positionfilter");
        var category = $("#kuaixianList li.active a").attr("data-action");

        //五位
        var dw5zi = 0;
        if (category == 4) {
            var obj = $("#kx_content input[name='dw5zi']:checked");
            if (obj) dw5zi = obj.attr("data-index");

        } else dw5zi = $("#kx_content input[name='dw5zi']").prop("checked") ? 1 : 0;

        //日志
        var kxlog = [];
        //生成号码数字
        var createNumberArr = [];
        //是否有输入条件
        var inputCondition = false;
        //全部号码
        var allNumberArr = [];
        //定位置
        if (positiontype == 0) {

            var wan = $("#kx_content tr.fixed-input input[name='wan']").val();
            var qian = $("#kx_content tr.fixed-input input[name='qian']").val();
            var bai = $("#kx_content tr.fixed-input input[name='bai']").val();
            var shi = $("#kx_content tr.fixed-input input[name='shi']").val();
            var ge = $("#kx_content tr.fixed-input input[name='ge']").val();

            var posNumArr = [wan, qian, bai, shi, ge];
            //填写号码的位置
            var numPos = [];
            wan.length > 0 ? numPos.push(0) : "";
            qian.length > 0 ? numPos.push(1) : "";
            bai.length > 0 ? numPos.push(2) : "";
            shi.length > 0 ? numPos.push(3) : "";
            ge.length > 0 ? numPos.push(4) : "";

            if (numPos.length > 0) {
                inputCondition = true;
                kxlog.push("1|" + positionfilter + "|" + posNumArr.join(":"));
            }


            if (category == numPos.length) {
                createNumberArr = dwcreatenumber(category, posNumArr, numPos);

                //除
                if (positionfilter == 1) {
                    var tmpPosNumArr = ["", "", "", "", ""];
                    for (var n = 0; n < numPos.length; n++) {
                        tmpPosNumArr[numPos[n]] = "0123456789";
                    }
                    allNumberArr = dwcreatenumber(category, tmpPosNumArr, numPos);
                }
        } else if (numPos.length > 0 && numPos.length < category) {
            var numPosArr = getQuickNumPosArr(category, dw5zi);

            for (var i = 0; i < numPosArr.length; i++) {
                tmpPosNumArr = posNumArr;
                    var posArr = numPosArr[i];

                    var c = false;
                    for (var n = 0; n < numPos.length; n++) {
                        if (posArr.indexOf(numPos[n]) == -1) {
                            c = true;
                            break;
                        }
                    }
                    if (c) continue;

                    var tmpPosNumArr2 = ["", "", "", "", ""];
                    for (var n = 0; n < posArr.length; n++) {
                        if (tmpPosNumArr[posArr[n]].length == 0) tmpPosNumArr[posArr[n]] = "0123456789";

                        if (positionfilter == 1) {
                            tmpPosNumArr2[posArr[n]] = "0123456789";
                        }
                    }

                    createNumberArr = createNumberArr.concat(dwcreatenumber(category, tmpPosNumArr, posArr));
                    if (positionfilter == 1) allNumberArr = allNumberArr.concat(dwcreatenumber(category, tmpPosNumArr2, posArr));
                }
            }

        } else { //配数
            var peiNumArr = [];
            var peiNumArr2 = [];
            for (var i = 1; i <= category; i++) {
                var psn = $("#kx_content tr.match-input input[name='pei" + i + "']").val();
                if (psn.length > 0) {
                    inputCondition = true;
                    peiNumArr2.push(psn);
                }
                peiNumArr.push(psn.length == 0 ? "0123456789" : psn);
            }

            if (inputCondition) {
                if (positionfilter == 1) allNumberArr = getNumbersByCategory(category, dw5zi);
                createNumberArr = peishuquanzhuan(category, peiNumArr, dw5zi, false);

                kxlog.push("2|" + positionfilter + "|" + peiNumArr2.join(":"));

            }
        }

        if (positionfilter == 1) {
            var newNumberArr = [];
            for (var n = 0; n < allNumberArr.length; n++) {
                if (createNumberArr.indexOf(allNumberArr[n]) == -1) newNumberArr.push(allNumberArr[n]);
            }
            createNumberArr = newNumberArr;
        }

        //全转
        var quanzhaun = $("#kx_content input[name='quanzhuan']").val();
        if (quanzhaun.length > 0) {
            tmpNumArr = [];
            if (quanzhaun.length >= category) {

                var quanzhaunArr = [];
                for (var i = 0; i < category; i++) {
                    quanzhaunArr.push(quanzhaun);
                }
                tmpNumArr = peishuquanzhuan(category, quanzhaunArr, dw5zi, true);

            }
            if (createNumberArr.length == 0 && inputCondition) {
                createNumberArr = [];
            } else if (createNumberArr.length == 0) createNumberArr = tmpNumArr;
            else {
                var tmpNumArr2 = [];
                for (var i = 0; i < tmpNumArr.length; i++) {
                    if (createNumberArr.indexOf(tmpNumArr[i]) != -1) {
                        tmpNumArr2.push(tmpNumArr[i]);
                    }
                }
                createNumberArr = tmpNumArr2;
            }
            inputCondition = true;
            kxlog.push("3|" + quanzhaun);

        }

        //上将
        var shangjiang = $("#kx_content input[name='shangjiang']").val();
        if (shangjiang.length > 0) {
            allNumberArr = getNumbersByCategory(category, dw5zi);
            var tmpNumArr = [];
            for (var n = 0; n < allNumberArr.length; n++) {
                var number = allNumberArr[n];
                var pos = [];
                for (var n2 = 0; n2 < number.length; n2++) {
                    for (var n3 = 0; n3 < shangjiang.length; n3++) {
                        if (number[n2] == shangjiang[n3] && pos.indexOf(n3) == -1) {
                            pos.push(n3);
                            break;
                        }
                    }

                }
                pos = pos.uniquelize();

                if (pos.length == shangjiang.length || pos.length == category) tmpNumArr.push(number);
            }

            if (!inputCondition && quanzhaun.length == 0) {
                createNumberArr = tmpNumArr;
            } else if (createNumberArr.length > 0) {
                if (tmpNumArr.length == 0) createNumberArr = [];
                else createNumberArr = Array.intersect(createNumberArr, tmpNumArr);
            }

            inputCondition = true;
            kxlog.push("4|" + shangjiang);

        }


        //值范围
        if (category == 4) {
            var zhifanwei1 = $("#kx_content td.zhi-filter-range input[name='zhifanwei1']").val();
            var zhifanwei2 = $("#kx_content td.zhi-filter-range input[name='zhifanwei2']").val();
            if (zhifanwei1.length > 0 && zhifanwei2.length > 0) {
                tmpNumArr = [];


                if (!inputCondition && quanzhaun.length == 0 && shangjiang.length == 0) {
                    allNumberArr = getNumbersByCategory(category, dw5zi);
                    for (var i = 0; i < allNumberArr.length; i++) {
                        var number = allNumberArr[i];
                        number = number.replace(/X/g, '');
                        var he = parseInt(number[0]) + parseInt(number[1]) + parseInt(number[2]) + parseInt(number[3]);
                        if (he >= parseInt(zhifanwei1) && he <= parseInt(zhifanwei2)) tmpNumArr.push(allNumberArr[i]);
                    }
                    createNumberArr = tmpNumArr;
                } else if (createNumberArr.length > 0) {
                    for (var i = 0; i < createNumberArr.length; i++) {
                        var number = createNumberArr[i];
                        number = number.replace(/X/g, '');
                        var he = parseInt(number[0]) + parseInt(number[1]) + parseInt(number[2]) + parseInt(number[3]);
                        if (he >= parseInt(zhifanwei1) && he <= parseInt(zhifanwei2)) tmpNumArr.push(createNumberArr[i]);
                    }
                    createNumberArr = tmpNumArr;
                }

                inputCondition = true;
                kxlog.push("5|" + zhifanwei1 + "~" + zhifanwei2);

            }
        }


        //合分
        var hefentype = $("#kx_content tr.hefen-filter input:checked").attr("hefentype");

        var hefenInfo = [];
        $("#kx_content td.hefen-filter-item").each(function () {
            var hf = $(this).find("input[type='text']").val();
            if (hf == "") return true;
            var i = 0;
            var pos = [];
            $(this).find("input[type='checkbox']").each(function () {
                if ($(this).prop("checked")) {
                    pos.push($(this).attr("name") || i);
                }
                i++;
            });

            if (pos.length > 0) {
                hefenInfo.push(pos.join(":") + "-" + hf);
            }
        });
        var tmpNumArr = [];
        if (hefenInfo.length > 0) {

            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            for (var i = 0; i < createNumberArr.length; i++) {
                var count = 0;
                for (var n = 0; n < hefenInfo.length; n++) {

                    var hf = hefenInfo[n].split("-")[1];
                    var hfpos = hefenInfo[n].split("-")[0].split(":");
                    var hf2 = 0;
                    for (var n2 = 0; n2 < hfpos.length; n2++) {
                        if (createNumberArr[i][hfpos[n2]] == "X") {
                            hf2 = -1;
                            break;
                        }
                        hf2 += parseInt(createNumberArr[i][hfpos[n2]]);
                    }
                    if (hf2 < 0) continue;

                    for (var n3 = 0; n3 < hf.length; n3++) {
                        if (hf2 % 10 == hf[n3]) {
                            count++;
                            break;
                        }
                    }
                }
                if (count == hefenInfo.length && hefentype == 0 || count != hefenInfo.length && hefentype == 1) tmpNumArr.push(createNumberArr[i]);

            }
            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("6|" + hefentype + "|" + hefenInfo.join(";"));

        }

        //不定位合分
        var budinghetype = $("#kx_content td.budinghe-filter input[type=checkbox]:checked").attr("budinghetype");
        var budinghe = $("#kx_content td.budinghe-filter input[type='text']").val();

        if ((budinghetype == 2 || budinghetype == 3) && budinghe.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);

            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                number = number.replace("/X/g", "");
                var ext = false;
                for (var n = 0; n < number.length; n++) {
                    for (var n2 = n + 1; n2 < number.length; n2++) {
                        if (budinghetype == 2) {
                            var value = (parseInt(number[n]) + parseInt(number[n2])) % 10;
                            if (budinghe.indexOf(value) != -1) { tmpNumArr.push(createNumberArr[i]); ext = true; break; }
                        } else {
                            for (var n3 = n2 + 1; n3 < number.length; n3++) {
                                var value = (parseInt(number[n]) + parseInt(number[n2]) + parseInt(number[n3])) % 10;
                                if (budinghe.indexOf(value) != -1) { tmpNumArr.push(createNumberArr[i]); ext = true; break; }

                            }
                        }
                        if (ext) break;

                    }
                    if (ext) break;
                }
            }

            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("7|" + budinghetype + "|" + budinghe);

        }

        //排除
        var paichu = $("#kx_content input[name='paichu']").val();
        if (paichu.length > 0) {

            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];

                var b = false;
                for (var n = 0; n < paichu.length; n++) {
                    if (number.indexOf(paichu[n]) != -1) {
                        b = true;
                        break
                    }
                }
                if (!b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("8|" + paichu);

        }

        //乘号位置
        var chhaoArr = [];
        $("#kx_content input.symbol-filter-item:checked").each(function () {
            chhaoArr.push($(this).attr("name"));
        });
        if (chhaoArr.length > 0 && category != 4) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                b = true;
                for (var n = 0; n < chhaoArr.length; n++) {
                    if (number[chhaoArr[n]] != "X") {
                        b = false;
                        break
                    }
                }
                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("9|" + chhaoArr.join(":"));

        }
        //含数复数
        var containfilter = $("#kx_content td.contain-filter input[type='checkbox']:checked").attr("containfilter");
        var han = $("#kx_content td.contain-filter input[name='han']").val();
        var fushi = $("#kx_content td.contain-filter input[name='fushi']").val();
        if (containfilter >= 0 && han.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                b = false;
                for (var n = 0; n < han.length; n++) {
                    if (number.indexOf(han[n]) != -1) {
                        b = true;
                        break
                    }
                }
                if (containfilter == 0 && b) tmpNumArr.push(number);
                else if (containfilter == 1 && !b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("10|" + containfilter + "|" + han);

        }

        if (containfilter >= 0 && fushi.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                b = true;
                for (var n = 0; n < number.length; n++) {
                    if (number[n] != 'X' && fushi.indexOf(number[n]) == -1) {
                        b = false;
                        break
                    }
                }
                if (containfilter == 0 && b) tmpNumArr.push(number);
                else if (containfilter == 1 && !b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("11|" + containfilter + "|" + fushi);

        }

        //重
        var chongname = ["two", "three", "four", "double"];
        var len = category < 4 ? category - 1 : category;
        var chongArr = [];
        for (var n = 0; n < len; n++) {
            var repeatwordsfilter = $("#kx_content  input[class='repeat-" + chongname[n] + "-words-filter']:checked").attr("repeatwordsfilter");
            if (repeatwordsfilter >= 0) {
                chongArr.push(n + ":" + repeatwordsfilter);
            }
        }
        if (chongArr.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                var b = true;

                for (var n = 0; n < chongArr.length; n++) {
                    var chcondition = chongArr[n];

                    var index = parseInt(chcondition.split(":")[0]);
                    var qu = parseInt(chcondition.split(":")[1]);
                    var count = chong(number);

                    //双重
                    if (index == 0 && qu == 0 && count < 2) b = false;
                    if (index == 0 && qu == 1 && count >= 2) b = false;
                    if (index == 0 && qu >= 0 && !b) break;

                    //三重
                    if (category >= 3) {

                        if (index == 1 && qu == 0 && !(count >= 3 && count <= 4)) b = false;
                        if (index == 1 && qu == 1 && (count >= 3 && count <= 4)) b = false;
                        if (index == 1 && qu >= 0 && !b) break;

                    }

                    if (category == 4) {

                        //双双重
                        if (index == 3 && qu == 0 && !(count >= 4 && count <= 5)) b = false;
                        if (index == 3 && qu == 1 && (count >= 4 && count <= 5)) b = false;
                        if (index == 3 && qu >= 0 && !b) break;

                        //四重
                        if (index == 2 && qu == 0 && !(count == 4)) b = false;
                        if (index == 2 && qu == 1 && (count == 4)) b = false;
                        if (index == 2 && qu >= 0 && !b) break;
                    }
                }

                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("12|" + chongArr.join("|"));

        }

        //对数
        var logarithmnumberfilter = $("#kx_content input[class='logarithm-number-filter']:checked").attr("logarithmnumberfilter");
        var duishuiArr = [];
        for (var n = 1; n <= 3; n++) {
            var ds = $("#kx_content input[name='duishu" + n + "'] ").val();
            if (ds.length == 2 && (ds[0] - ds[1] == 5 || (ds[0] - ds[1] == -5))) {
                duishuiArr.push(ds);
            } else if (ds.length > 0) {
                G.myTips({ content: "请输入差值为5的数", obj: $("#kx_content input[name='duishu" + n + "'] "), myclick: true });
                return;
            }
        }
        if (logarithmnumberfilter >= 0 && duishuiArr.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                number = createNumberArr[i];
                b = false;
                for (var n = 0; n < duishuiArr.length; n++) {
                    if (number.indexOf(duishuiArr[n][0]) != -1 && number.indexOf(duishuiArr[n][1]) != -1) {
                        b = true;
                        break;
                    }
                }

                if (logarithmnumberfilter == 1) b = !b;

                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("13|" + logarithmnumberfilter + "|" + duishuiArr.join(":"));

        } else if (logarithmnumberfilter >= 0 && duishuiArr.length == 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                number = createNumberArr[i];
                number = number.replace(/X/g, '');
                b = false;
                for (var n = 0; n < number.length - 1; n++) {
                    for (var n2 = n + 1; n2 < number.length; n2++)
                        if (number[n] - number[n2] == 5 || number[n] - number[n2] == -5) {
                            b = true;
                            break;
                        }
                }


                if (logarithmnumberfilter == 1) b = !b;

                if (b) tmpNumArr.push(createNumberArr[i]);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("13|" + logarithmnumberfilter + "| ");

        }


        var brotherClass = ["two", "three", "four"];
        var brotherArr = [];
        for (var n = 0; n < category - 1; n++) {
            var brotherfilter = $("#kx_content input[class='" + brotherClass[n] + "-brother-filter']:checked").attr("brotherfilter");
            if (brotherfilter >= 0) {
                brotherArr.push(n + ":" + brotherfilter);
            }
        }
        if (brotherArr.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;

            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                var b = true;
                for (var k = 0; k < brotherArr.length; k++) {

                    var index = brotherArr[k].split(":")[0];
                    var qu = brotherArr[k].split(":")[1];

                    if (index == 0 && qu == 0 && brother(number) < 2) b = false;
                    if (index == 0 && qu == 1 && brother(number) >= 2) b = false;

                    if (index == 1 && qu == 0 && brother(number) < 3) b = false;
                    if (index == 1 && qu == 1 && brother(number) >= 3) b = false;

                    if (index == 2 && qu == 0 && brother(number) != 4) b = false;
                    if (index == 2 && qu == 1 && brother(number) == 4) b = false;

                    if (!b) break;
                }
                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("14|" + brotherArr.join("|"));

        }

        var oddnumberfilter = $("#kx_content input[class='odd-number-filter']:checked").attr("oddnumberfilter");
        var evennumberfilter = $("#kx_content input[class='even-number-filter']:checked").attr("evennumberfilter");
        var oddnumberArr = [];
        var evennumberArr = [];

        var depos = 0;
        $("#kx_content input[class='odd-number-item']").each(function () {
            if ($(this).prop("checked")) oddnumberArr.push($(this).attr("name") || depos);
            depos++;
        });

        if (oddnumberfilter >= 0 && oddnumberArr.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                var b = true;
                for (var n = 0; n < oddnumberArr.length; n++) {
                    if (number[oddnumberArr[n]] == "X" || parseInt(number[oddnumberArr[n]]) % 2 == 0) {
                        b = false;
                        break;
                    }
                }

                if (oddnumberfilter == 1) b = !b;
                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("15|" + oddnumberfilter + "|" + oddnumberArr.join("|"));

        }

        depos = 0;
        $("#kx_content input[class='even-number-item']").each(function () {
            if ($(this).prop("checked")) evennumberArr.push($(this).attr("name") || depos);
            depos++;
        });

        if (evennumberfilter >= 0 && evennumberArr.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                var b = true;
                for (var n = 0; n < evennumberArr.length; n++) {
                    if (number[evennumberArr[n]] == "X" || parseInt(number[evennumberArr[n]]) % 2 != 0) {
                        b = false;
                        break;
                    }
                }

                if (evennumberfilter == 1) b = !b;
                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("16|" + evennumberfilter + "|" + evennumberArr.join("|"));

        }

        if (!inputCondition) {
            G.alert({ content: "请选择或填写条件生成!", ok: function () { return true; }, type: 1 });
            return;
        }

        //kxnumbers
        createNumberArr = getQuickCreateNumbers(createNumberArr);
        if (createNumberArr.length == 0) {
            $("#kxnumbers").html("没有这样的号码");
        } else {
            createNumberArr = createNumberArr.sort();
            var row = parseInt(createNumberArr.length / 10);
            if (createNumberArr.length % 10 > 0) row += 1;
            var htmlData = [];
            htmlData.push("<table >");
            htmlData.push("<tbody >");


            for (var n = 0; n < row; n++) {
                htmlData.push("<tr>");
                for (var n2 = 0; n2 < 10; n2++) {
                    if (n * 10 + n2 < createNumberArr.length) {
                        var num = createNumberArr[n * 10 + n2];
                        htmlData.push("<td >" + num + "</td>");
                    } else {
                        htmlData.push("<td >--</td>");
                    }
                }
                htmlData.push("</tr>");
            }

            htmlData.push("</tbody>");
            htmlData.push("</table>");
            $("#kxnumbers").html(htmlData.join(""));
            $("#kxlog").html(category + "," + dw5zi + "," + kxlog.join(","));
            $("#zbishu").html(createNumberArr.length);
            if ($("#tool_ys_input").val().length > 0) {
                $("#zmoney").html(parseFloat($("#tool_ys_input").val()) * createNumberArr.length)
            } else {
                $("#zmoney").html("");
            }
            $("#tool_ys_input").focus()

        }
    });

    $("#tool_ys_input").unbind("keydown").keydown(function (e) {
        console.log(e)
        if (e.keyCode == 13) {
            $("#kxSubmit").click()
        }
    })

    $("#kxSubmit").unbind("click").click(function () {

        var money = $("#tool_ys_input").val();
        if (money.length == 0 || parseFloat(money) <= 0) {
            return;
        }

        var numberArr = [];
        let bet_arr = []
        $("#kxnumbers").find("td").each(function () {
            var number = $(this).html();
            var type = getDWTypeByName(number);
            if (type > 0) numberArr.push(type + ":" + money);
            if(number !== '--'){
                bet_arr.push(number+":" + money)
            }
        });

        if (numberArr.length == 0) {
            return;
        }

        if (numberArr.length > 10000) {
            G.alert({ content: "单笔最大只能下注10000注", ok: function () { return true; } });
            return;
        }

        var gameIndex = $("#menuText").attr("data-index");
        var opNum = $("#NowJq").html();
        numberArr.sort(function (a, b) {
            var _a = a.split(":")[0], _b = b.split(":")[0];
            return parseInt(_b) - parseInt(_a);
        });
        var printAry = [];

        if ($("#tool_ys_input").val().length == 0) return;

        $("#tool_ys_input").val("");


        let play_code = "";
        console.log($("#kuaixianList").find('.active').find("a").html())
        if ($("#kuaixianList").find('.active').find("a").html() == "二字定") {
            play_code = "D2W";
        } else
            if($("#kuaixianList").find('.active').find("a").html() == "三字定") {
                play_code = "D3W";
            } else
                if($("#kuaixianList").find('.active').find("a").html() == "四字定") {
                play_code = "D4W";
            }

        let data = {
            access_token: window.sessionStorage.getItem("login").split("&")[0],
            uid: window.sessionStorage.getItem("login").split("&")[1],
            game_code: window.sessionStorage.getItem("code"),
            play_code,
            key: (new Date()).valueOf(),
            play_type: "kuaixuan",
            bet_money: money,
            total_money: money * bet_arr.length,
            bet_num: bet_arr.length,
            bet_str: bet_arr.join(','),
            bet_log: '游戏日志',
            bet_qihao: window.sessionStorage.getItem("qiNum")
        }

        $("#mymask").remove();
        $("#myLayerImg").remove();
        $("body").append("<div class='myLayerLoading' id='mymask'></div>");
        $("body").append("<div class='myLayerImg' id='myLayerImg'></div>");
        $("#mymask").show();
        $("#myLayerImg").show();

        //接口相应太快了，辛苦搞出来的样式都看不到，让他多等会
        setTimeout(()=>{
            getData.default.postAxiosMethod("bet", data, res => {
                $("#myLayerImg").remove();
                $("#mymask").remove();
                container()
                $('#kxnumbers').empty()
                $('#kx_content').find('input:not(input[type=button])').val("")
                let isPlayer = sessionStorage.getItem('Voice')
                if(isPlayer == 1){
                    document.getElementById('bgm').play()
                }
                setTimeout(function(){
                    vue.$event.$emit('yzdData', 4)
                }, 1000)
            })
        },300)
        // dataSubmit({ gameIndex: gameIndex, betType: 4, data: $("#kxlog").html(), number: opNum, sortAry: numberArr.join(",") }, false, null, printAry);


    });

    $("#tool_ys_input").keyup(function () {
        //$(this).val($(this).val().replace(/[^0-9]/g, ''));
        G.clearNoNum($(this));
        var bishu = $("#zbishu").html();
        if (bishu.length > 0 && $(this).val().length > 0){
            $("#zmoney").html(parseInt(bishu) * parseFloat($(this).val()));
        }else {
            $("#zmoney").html("");
        }

    });
}
const getQuickGameProfile = () => {
    var gameType = window.sessionStorage.getItem("gameType") || "five_ball";
    if (gameType == "three_ball") {
        return {
            count: 3,
            positions: [
                { label: "百", name: "bai", index: 2 },
                { label: "十", name: "shi", index: 3 },
                { label: "个", name: "ge", index: 4 }
            ],
            categories: [2, 3]
        };
    }
    if (gameType == "four_ball") {
        return {
            count: 4,
            positions: [
                { label: "千", name: "qian", index: 1 },
                { label: "百", name: "bai", index: 2 },
                { label: "十", name: "shi", index: 3 },
                { label: "个", name: "ge", index: 4 }
            ],
            categories: [2, 3, 4]
        };
    }
    return {
        count: 5,
        positions: [
            { label: "万", name: "wan", index: 0 },
            { label: "千", name: "qian", index: 1 },
            { label: "百", name: "bai", index: 2 },
            { label: "十", name: "shi", index: 3 },
            { label: "个", name: "ge", index: 4 }
        ],
        categories: [2, 3, 4]
    };
}

const getQuickCategoryName = (category) => {
    return category == 2 ? "二字定" : category == 3 ? "三字定" : "四字定";
}

const getQuickPositionIndexes = () => {
    return getQuickGameProfile().positions.map(function (item) { return item.index; });
}

const getQuickCombinations = (items, size) => {
    var result = [];
    var combine = function (start, selected) {
        if (selected.length == size) {
            result.push(selected.slice());
            return;
        }
        for (var i = start; i < items.length; i++) {
            selected.push(items[i]);
            combine(i + 1, selected);
            selected.pop();
        }
    };
    combine(0, []);
    return result;
}

const getQuickPermutations = (size) => {
    var source = [];
    for (var i = 0; i < size; i++) source.push(i);
    var result = [];
    var permute = function (items, selected) {
        if (selected.length == size) {
            result.push(selected.slice());
            return;
        }
        for (var n = 0; n < items.length; n++) {
            var nextItems = items.slice();
            var item = nextItems.splice(n, 1)[0];
            permute(nextItems, selected.concat(item));
        }
    };
    permute(source, []);
    return result;
}

const getQuickNumPosArr = (category, dw5zi) => {
    category = parseInt(category);
    var profile = getQuickGameProfile();
    if (profile.count < 5) {
        return getQuickCombinations(getQuickPositionIndexes(), category);
    }

    if (category == 2) {
        if (dw5zi == 0) return [[0, 1], [0, 2], [0, 3], [1, 2], [1, 3], [2, 3]];
        return [[0, 4], [1, 4], [2, 4], [3, 4]];
    } else if (category == 3) {
        if (dw5zi == 0) return [[0, 1, 2], [0, 1, 3], [0, 2, 3], [1, 2, 3]];
        return [[0, 1, 4], [0, 2, 4], [0, 3, 4], [1, 2, 4], [1, 3, 4], [2, 3, 4]];
    } else if (category == 4) {
        var numPosArr = [[0, 1, 2, 3], [0, 1, 2, 4], [0, 1, 3, 4], [0, 2, 3, 4], [1, 2, 3, 4]];
        var index = [4, 3, 2, 1, 0];
        return [numPosArr[index[dw5zi - 1]]];
    }
    return [];
}

const getQuickDisplayNumber = (number) => {
    number = (number || "").toString();
    var profile = getQuickGameProfile();
    if (profile.count == 3) return number.substr(2, 3);
    if (profile.count == 4) return number.substr(1, 4);
    return number[4] == 'X' ? number.substring(0, number.lastIndexOf('X')) : number;
}

const getQuickCreateNumbers = (numbers) => {
    var result = [];
    numbers.forEach(function (number) {
        var displayNumber = getQuickDisplayNumber(number);
        if (result.indexOf(displayNumber) == -1) result.push(displayNumber);
    });
    return result;
}

const kxcontent = (dataAction, vue) => {

    var profile = getQuickGameProfile();
    dataAction = parseInt(dataAction);
    if (profile.categories.indexOf(dataAction) == -1) dataAction = profile.categories[0];
    var categoryHtml = [];
    for (var categoryIndex = 0; categoryIndex < profile.categories.length; categoryIndex++) {
        var category = profile.categories[categoryIndex];
        var active = dataAction == category ? "active" : "";
        categoryHtml.push("<li class='subBtn " + active + "'><a href='javascript:void(0)' data-action='" + category + "'>" + getQuickCategoryName(category) + "</a></li>");
    }
    var rightBox =
        "<div  class='game_box_title t_1' style='width: 600px;background: white'>" +
        "<ul class='base-clear' id='kuaixianList'>" +
        categoryHtml.join("") +
        "</ul>" +
        "<div id='kx_content' class='history_wrap'>" +
        "</div>" +
        "</div>";
    $("#rightBox").html(rightBox);



    var wz = dataAction == 2 ? "二" : dataAction == 3 ? "三" : "四";

    var htmlData = ["<table>"];

    htmlData.push("<tbody>");

    htmlData.push("<tr class='position-filter' >" +
        " <td  colspan='" + Math.max(1, profile.count - 1) + "' > " +
        "<strong class='red2'>定位置</strong> <label><input type='checkbox' positiontype='0' positionfilter='1' >除</label> <label><input type='checkbox' positiontype='0' positionfilter='0'  checked='checked'>取</label> </td> " +
        "<td  colspan='" + Math.max(1, profile.count - Math.max(1, profile.count - 1)) + "' >" +
        " <strong class='red2'>配数全转</strong> <label><input positiontype='1' positionfilter='1' type='checkbox' >除</label> <label><input positiontype='1' positionfilter='0' type='checkbox' >取</label> </td> </tr>");

    htmlData.push("<tr><td colspan='" + profile.count + "'>");
    if (dataAction == 2 && profile.count == 5) htmlData.push("<div id='wwrdPnode' class='wwrdPnode'> <input name='dw5zi' id='wwrd' type='checkbox'> 五位二定 ");
    else if (dataAction == 3 && profile.count == 5) htmlData.push("<div id='wwrdPnode' class='wwrdPnode'> <input name='dw5zi' id='wwrd' type='checkbox'> 五位三定 ");
    else if (dataAction == 2 || dataAction == 3) htmlData.push("<div id='wwrdPnode' class='wwrdPnode' style='display:none'> <input name='dw5zi' id='wwrd' type='checkbox'> ");
    else {
        if (profile.count == 4) {
            htmlData.push(" <input name='dw5zi' data-index='1' class='zdz'  type='checkbox' checked style='display:none'> ");
        } else {
            htmlData.push(" <input name='dw5zi' data-index='5' class='zdz'  type='checkbox' checked> 一五四定 ");
            htmlData.push(" <input name='dw5zi' data-index='4' class='zdz' type='checkbox'> 二五四定 ");
            htmlData.push(" <input name='dw5zi' data-index='3' class='zdz' type='checkbox'> 三五四定 ");
            htmlData.push(" <input name='dw5zi' data-index='2' class='zdz' type='checkbox'> 四五四定 ");
            htmlData.push(" <input name='dw5zi' data-index='1' class='zdz' type='checkbox'> 五五四定 ");
        }

    }
    htmlData.push("</div></tr></td>");
    //定位
    htmlData.push("<tr class='fixed-input'>");
    for (var positionIndex = 0; positionIndex < profile.positions.length; positionIndex++) {
        htmlData.push("<td width='" + (100 / profile.count) + "%'>" + profile.positions[positionIndex].label + "</td>");
    }
    htmlData.push("</tr>");
    htmlData.push("<tr class='fixed-input'>");
    var positionNames = profile.positions.map(function (item) { return item.name; });
    ["wan", "qian", "bai", "shi", "ge"].forEach(function (name) {
        if (positionNames.indexOf(name) == -1) {
            htmlData.push("<input name='" + name + "' autocomplete='off' type='hidden' value=''>");
        }
    });
    for (var inputIndex = 0; inputIndex < profile.positions.length; inputIndex++) {
        htmlData.push("<td><input name='" + profile.positions[inputIndex].name + "' autocomplete='off' class='input input2'  type='text'></td>");
    }
    htmlData.push("</tr>");


    //配
    htmlData.push("<tr class='match-input' style='display: none'>");
    htmlData.push("<td colspan='" + profile.count + "'>");
    htmlData.push(" <input name='pei1' autocomplete='off' class='input input2'  type='text'> 配 <input name='pei2' autocomplete='off' class='input input2'  type='text'>");

    if (dataAction >= 3) htmlData.push(" 配 <input name='pei3' autocomplete='off' class='input input2'  type='text'>");
    if (dataAction == 4) htmlData.push(" 配 <input name='pei4' autocomplete='off' class='input input2'  type='text'>");
    htmlData.push("</td>");
    htmlData.push("</tr>");

    htmlData.push("<tr class='hefen-filter'> <td colspan='" + profile.count + "'> <strong class='red2'>合</strong>&nbsp;&nbsp; <strong class='red2'>分</strong> <label><input type='checkbox' hefentype='1'>除</label> <label><input type='checkbox' hefentype='0'  checked='checked'>取</label> </td> </tr>");
    htmlData.push("<tr>");
    for (var hefenIndex = 1; hefenIndex <= profile.count; hefenIndex++) {
        htmlData.push("<td class='hefen-filter-item'> " + hefenIndex + ". ");
        for (var checkIndex = 0; checkIndex < profile.count; checkIndex++) {
            htmlData.push("<input type='checkbox' name='" + profile.positions[checkIndex].index + "'> ");
        }
        htmlData.push("<br> <input type='text' class='input input2'  maxlength='10'> </td>");
    }
    htmlData.push("</tr>");



    var zhiRangeColspan = 0;
    var colspan = profile.count;
    if (dataAction == 4) {
        zhiRangeColspan = Math.min(3, profile.count - 1);
        colspan = profile.count - zhiRangeColspan;
    }
    //不定位合分
    htmlData.push("<tr>");
    htmlData.push("<td class='budinghe-filter' style='text-align: left;white-space: nowrap;' colspan='" + colspan + "' ><strong class='red2'>不定位合分</strong> <label><input type='checkbox' budinghetype='2' >两数合</label> ");
    if (dataAction == 3 || dataAction == 4) {
        htmlData.push("<label><input type='checkbox' budinghetype='3'  >三数合</label>");
    }
    htmlData.push(" <input type='text' class='input input2' maxlength='10'>");
    if (dataAction == 4) {
        htmlData.push("<td class='zhi-filter-range' colspan='" + zhiRangeColspan + "'>");
        htmlData.push("<strong class='red2'>值 范 围</strong> 从 ");
        htmlData.push("<input type='text' class='input input2' name='zhifanwei1'  maxlength='10'> 值 至 ");
        htmlData.push("<input type='text' class='input input2' name='zhifanwei2'  maxlength='10'>");

        htmlData.push("</td>");
    }

    htmlData.push("</tr>");

    //全转 上奖 排除 乘号位置
    htmlData.push("<tr>");
    htmlData.push("<td colspan='" + profile.count + "' style='text-align: left'>");
    htmlData.push("<strong class='red2'>全转</strong> <input type='text' class='input input2' name='quanzhuan' maxlength=\"10\">");
    htmlData.push("&nbsp;<strong class='red2'>上奖</strong> <input type='text' class='input input2' name='shangjiang' maxlength=\"10\">");
    htmlData.push("&nbsp;<strong class='red2'>排除</strong> <input type='text' class='input input2' name='paichu' maxlength=\"10\">");
    if (dataAction != 4) {
        htmlData.push("&nbsp;<strong class='red2'>乘号位置</strong>");
        for (var symbolIndex = 0; symbolIndex < profile.count; symbolIndex++) {
            htmlData.push("<input type='checkbox' class='symbol-filter-item' name='" + profile.positions[symbolIndex].index + "'>&nbsp;");
        }
    }
    htmlData.push("</td>");
    htmlData.push("</tr>");


    //含 复式
    htmlData.push("<tr>");
    htmlData.push("<td colspan='" + profile.count + "' class='contain-filter' style='text-align: left'>");
    htmlData.push("<label><input type='checkbox' containfilter='1' >&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input type='checkbox' containfilter='0' >&nbsp;取</label>");
    htmlData.push(" " + wz + "字定含 <input type='text' class='input input2' name='han' maxlength='10'>");
    htmlData.push(" " + wz + "字定复式 <input type='text' class='input input2' name='fushi' maxlength='10'>");
    htmlData.push("</td>");
    htmlData.push("</tr>");

    //双重
    htmlData.push("<tr>");
    htmlData.push("<td colspan='" + profile.count + "' style='text-align: left'>");
    htmlData.push("<label><input type='checkbox' class='repeat-two-words-filter' repeatwordsfilter='1' >&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input type='checkbox' class='repeat-two-words-filter' repeatwordsfilter='0'>&nbsp;取</label>");
    htmlData.push("(<strong class='red2'>双重</strong>)");

    if (dataAction == 4) {
        htmlData.push("&nbsp;&nbsp;<label><input type='checkbox' class='repeat-double-words-filter' repeatwordsfilter='1' >&nbsp;除</label>");
        htmlData.push("&nbsp;<label><input type='checkbox' class='repeat-double-words-filter' repeatwordsfilter='0' >&nbsp;取</label>");
        htmlData.push("(<strong class='red2'>双双重</strong>)");
    }

    if (dataAction >= 3) {
        htmlData.push("&nbsp;&nbsp;<label><input type='checkbox' class='repeat-three-words-filter' repeatwordsfilter='1'>&nbsp;除</label>");
        htmlData.push("&nbsp;<label><input type='checkbox' class='repeat-three-words-filter' repeatwordsfilter='0'>&nbsp;取</label>");
        htmlData.push("(<strong class='red2'>三重</strong>)");
    }

    if (dataAction == 4) {
        htmlData.push("&nbsp;&nbsp;<label><input type='checkbox' class='repeat-four-words-filter' repeatwordsfilter='1'>&nbsp;除</label>");
        htmlData.push("&nbsp;<label><input type='checkbox' class='repeat-four-words-filter' repeatwordsfilter='0'>&nbsp;取</label>");
        htmlData.push("(<strong class='red2'>四重</strong>)");
    }

    htmlData.push("</td>");
    htmlData.push("</tr>");

    //兄弟
    htmlData.push("<tr>");
    htmlData.push("<td colspan='" + profile.count + "' style='text-align: left'>");
    htmlData.push("<label><input class='two-brother-filter' brotherfilter='1' type='checkbox' >&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input class='two-brother-filter' brotherfilter='0' type='checkbox' >&nbsp;取</label>");
    htmlData.push("(<strong class='red2'>二兄弟</strong>)");

    if (dataAction >= 3) {
        htmlData.push("&nbsp;&nbsp;<label><input class='three-brother-filter' brotherfilter='1' type='checkbox' >&nbsp;除</label>");
        htmlData.push("&nbsp;<label><input class='three-brother-filter' brotherfilter='0' type='checkbox' >&nbsp;取</label>");
        htmlData.push("(<strong class='red2'>三兄弟</strong>)");
    }

    if (dataAction == 4) {
        htmlData.push("&nbsp;&nbsp;<label><input class='four-brother-filter' brotherfilter='1' type='checkbox' >&nbsp;除</label>");
        htmlData.push("&nbsp;<label><input class='four-brother-filter' brotherfilter='0' type='checkbox' >&nbsp;取</label>");
        htmlData.push("(<strong class='red2'>四兄弟</strong>)");
    }

    htmlData.push("</td>");
    htmlData.push("</tr>");

    //对数
    htmlData.push("<tr>");
    htmlData.push("<td colspan='" + profile.count + "' style='text-align: left'>");
    htmlData.push("<label><input class='logarithm-number-filter' logarithmnumberfilter='1' type='checkbox' >&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input class='logarithm-number-filter' logarithmnumberfilter='0' type='checkbox' >&nbsp;取</label>");
    htmlData.push("(<strong class='red2'>对数</strong>)");
    htmlData.push("&nbsp;<input type='text' class='input input2' name='duishu1'  maxlength='2'>");
    htmlData.push("&nbsp;<input type='text' class='input input2' name='duishu2'  maxlength='2'>");
    htmlData.push("&nbsp;<input type='text' class='input input2' name='duishu3'  maxlength='2'>");
    htmlData.push("</td>");
    htmlData.push("</tr>");

    //单双
    htmlData.push("<tr>");
    htmlData.push("<td colspan='" + profile.count + "' style='text-align: left'>");
    htmlData.push("<label><input type='checkbox' class='odd-number-filter' oddnumberfilter='1'>&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input type='checkbox' class='odd-number-filter' oddnumberfilter='0'>&nbsp;取</label>");
    htmlData.push("(<strong class='red2'>单</strong>)");
    for (var oddIndex = 0; oddIndex < profile.count; oddIndex++) {
        htmlData.push("&nbsp;<input type='checkbox' class='odd-number-item' name='" + profile.positions[oddIndex].index + "'>");
    }

    htmlData.push(" &nbsp;&nbsp;&nbsp;&nbsp;<label><input class='even-number-filter' evennumberfilter='1' type='checkbox' >&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input type='checkbox' class='even-number-filter' evennumberfilter='0'>&nbsp;取</label>");
    htmlData.push("(<strong class='red2'>双</strong>)");
    for (var evenIndex = 0; evenIndex < profile.count; evenIndex++) {
        htmlData.push("&nbsp;<input type='checkbox' class='even-number-item' name='" + profile.positions[evenIndex].index + "'>");
    }

    htmlData.push("</td>");
    htmlData.push("</tr>");

    htmlData.push("<tr><td colspan='" + profile.count + "'>");
    htmlData.push("<input name='create-number' class='btn hotBtn disSubmit' type='button' value='生成'>")
    htmlData.push("&nbsp;&nbsp;<input name='reset-number' id='resBtnKx' class='btn grayBtn' type='button' value='重置'>");
    // htmlData.push("&nbsp;&nbsp;<span id='kxlog' category='"+dataAction+"' style='color: #004eff'>投注日志</span>");
    htmlData.push("</td></tr>");

    htmlData.push("</tbody>");

    htmlData.push("</table>");



    $("#kx_content").html(htmlData.join(""));


    kuaiXuanClick(vue);


}
const getQuickNumberList = () => {
    var gameNumber = window.sessionStorage.getItem("gameNumber");
    if (!gameNumber) return [];
    try {
        var list = JSON.parse(gameNumber);
        return Array.isArray(list) ? list : [];
    } catch (e) {
        return [];
    }
}

const isQuickNumberMatch = (value, rule) => {
    value = (value || "").toString();
    rule = (rule || "").toString();
    if (value.length != rule.length) return false;
    if (value.replace(/[0-9]/g, "口") == rule) return true;
    for (var i = 0; i < rule.length; i++) {
        if (rule[i] == "口") {
            if (!/[0-9]/.test(value[i])) return false;
        } else if (value[i] != rule[i]) {
            return false;
        }
    }
    return true;
}

const isQuickNumberPrefix = (value, rule) => {
    value = (value || "").toString();
    rule = (rule || "").toString();
    if (value.length > rule.length) return false;
    if (value.replace(/[0-9]/g, "口") == rule.substr(0, value.length)) return true;
    for (var i = 0; i < value.length; i++) {
        if (rule[i] == "口") {
            if (!/[0-9]/.test(value[i])) return false;
        } else if (value[i] != rule[i]) {
            return false;
        }
    }
    return true;
}

const hasQuickNumberMatch = (value) => {
    return getQuickNumberList().some(function (rule) {
        return isQuickNumberMatch(value, rule);
    });
}

const hasQuickNumberPrefix = (value) => {
    return getQuickNumberList().some(function (rule) {
        return isQuickNumberPrefix(value, rule);
    });
}

const getQuickNumberMaxLength = () => {
    var list = getQuickNumberList();
    var maxLength = 0;
    list.forEach(function (rule) {
        rule = (rule || "").toString();
        if (rule.length > maxLength) maxLength = rule.length;
    });
    return maxLength;
}

const kd = () => {
    $("#tool_hm_input").unbind('keyup').keyup(function () {
        $(this).val($(this).val().replace(/[xｘＸ]/g, 'X'));
        var num = $(this).val();
        if (num == "") {
            $("#oddsmoney").html("");
            return;
        }

        if (hasQuickNumberMatch(num)) {
            $("#tool_ys_input").focus();
            let data = {};
            data.access_token = window.sessionStorage.getItem("login").split("&")[0];
            data.uid = window.sessionStorage.getItem("login").split("&")[1];
            data.game_code = window.sessionStorage.getItem("code");
            data.bet_str = num;
            getData.default.postAxiosMethod("kuaidaodds", data, res => {
                $("#oddsmoney").html(`<span>&nbsp;赔率：</span><span id="spanPeilv" style='color: #0b8fff;font-weight: bold'>${res.data.data.odds}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>可下：</span><span id="spankxje" style='color: red;font-weight: bold'>${res.data.data.maxCount}</span>`);
            });
        } else {
            /* $("#oddsmoney").html("");
            var maxLength = getQuickNumberMaxLength();
            if (maxLength > 0 && num.length >= maxLength && !hasQuickNumberPrefix(num)) {
                G.myTips({content:"输入号码有误",obj:$(this)});
                $(this).val("");
            } */
        }
    });
}

const GameMiddle = (msg) => {

    $("#mainIframe").find("div[class='gameLeft']").attr("style", "");
    $("#mainIframe").find("div[class='game_wrap']").attr("style", "");
    $("#mainIframe").find("div[class='game_item_warp']").attr("style", "");
    $("#gameBoxTool").attr("style", "");

    var gameIndex = msg.gameIndex;
    var type = msg.type;
    if (type == 19) {
        fastbet(msg);
        return;
    }/*
    var oddsList = msg.data.oddsList;
    var bianseList = msg.data.bianseList;
    var num, sort, str, sortIndex, disabled = "", data_type = [];
    */
    var _dx = function (index) { switch (index) { case 1: return "一"; case 2: return "二"; case 3: return "三"; case 4: return "四"; case 5: return "五"; case 6: return "六"; case 7: return "七"; case 8: return "八"; } };
    var htmlData = [];
    var pad = "";
    if (gameIndex == 3 && type >= 9 && type <= 18) {
        var selects = [];
        for (var i = 9; i <= 18; i++) {

            if (i == type) selects.push("selected");
            else selects.push("");
        }

        htmlData.push("<div id='subNavList' class='game_box_tool2 base-clear'>");
        htmlData.push("&nbsp;&nbsp;<a href='javascript:void(0)' class='" + selects[0] + "' data-action='gamedata&amp;gameIndex=3&amp;type=9' >口口XX</a> | ");
        htmlData.push("<a href='javascript:void(0)' class='" + selects[1] + "' data-action='gamedata&amp;gameIndex=3&amp;type=10' >口X口X</a> | ");
        htmlData.push("<a href='javascript:void(0)' class='" + selects[2] + "' data-action='gamedata&amp;gameIndex=3&amp;type=11' >口XX口</a> | ");
        htmlData.push("<a href='javascript:void(0)' class='" + selects[4] + "' data-action='gamedata&amp;gameIndex=3&amp;type=13' >X口口X</a> | ");
        htmlData.push("<a href='javascript:void(0)' class='" + selects[5] + "' data-action='gamedata&amp;gameIndex=3&amp;type=14' >X口X口</a> | ");
        htmlData.push("<a href='javascript:void(0)' class='" + selects[7] + "' data-action='gamedata&amp;gameIndex=3&amp;type=16' >XX口口</a> | ");
        htmlData.push("<a href='javascript:void(0)' class='" + selects[3] + "' data-action='gamedata&amp;gameIndex=3&amp;type=12' >口XXX口</a> | ");
        htmlData.push("<a href='javascript:void(0)' class='" + selects[6] + "' data-action='gamedata&amp;gameIndex=3&amp;type=15' >X口XX口</a> | ");
        htmlData.push("<a href='javascript:void(0)' class='" + selects[8] + "' data-action='gamedata&amp;gameIndex=3&amp;type=17' >XX口X口</a> | ");
        htmlData.push("<a href='javascript:void(0)' class='" + selects[9] + "' data-action='gamedata&amp;gameIndex=3&amp;type=18' >XXX口口</a>");
        htmlData.push("</div>");
        pad = "style='padding-top: 30px;padding-left: 1px'";
    }

    htmlData.push("<div class='game_ball_wrap game_item_wrap base-clear' " + pad + ">");



    if (gameIndex == 3 || gameIndex == 15) { //SSC
        if (type == 2) {
            for (var i = 0; i < 5; i++) {
                if (i > 0)
                    sortIndex = i * 14;
                else
                    sortIndex = 0;
                htmlData.push("<div class='game_box col_1 gameBox base-clear'>");
                htmlData.push("<div class='game_con'>");
                htmlData.push("<fieldset>");
                htmlData.push("<legend>第" + _dx((i + 1)) + "球</legend>");
                htmlData.push("<ul>");
                for (var n = 1; n <= 10; n++) {
                    sort = n + sortIndex;
                    disabled = G.DecimalSign(true) ? "" : "disabled='disabled'";
                    var bianse = 1 == "1" ? "style='color:blue;'" : "";
                    htmlData.push("<li data-sort='" + sort + "' data-title='" + _sscnum1(sort) + "' data-name='" + _sscnum2(sort) + "'>");
                    htmlData.push("<span class='name'><i class='SSCNo_" + (n - 1) + "'></i></span>");
                    htmlData.push("<span class='p'><a class='oddsEvent' " + bianse + " title='点击下注' href='javascript:;'>" + oddsList[sort] + "</a></span>");
                    htmlData.push("<span class='in'><input class='input onlyNum orderInput' type='text' " + disabled + " maxlength='7'></span>");
                    htmlData.push("</li>");
                }

                htmlData.push("</ul>");
                htmlData.push("<div class='dsdx' style='width: 168px;text-align: center;display: inline-block;margin-top: 5px'>");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' href=\"javascript:void(0)\">单</a>");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' style='margin-left: 5px' href=\"javascript:void(0)\">双</a> ");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' style='margin-left: 5px' href=\"javascript:void(0)\">大</a>");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' style='margin-left: 5px' href=\"javascript:void(0)\">小</a> ");
                htmlData.push("</div>");
                htmlData.push("</fieldset>");
                htmlData.push("</div>");
                htmlData.push("</div>");
            }
        } else if (type >= 9) {

            var titiles = [["万", "千"], ["万", "百"], ["万", "十"], ["万", "个"], ["千", "百"], ["千", "十"], ["千", "个"], ["百", "十"], ["百", "个"], ["十", "个"]];

            var start = 108 + (type - 9) * 100;

            for (var i = 0; i <= 9; i++) {
                sort = i * 10 + start;

                htmlData.push("<div class='game_box col_1 base-clear'>");
                htmlData.push("<div data-index='" + sort + "' class='triangle-topleft'></div>");
                if (i == 0) {
                    htmlData.push("<div style='float: left;margin-left: -8px'>");
                    htmlData.push("<div style='height: 32px;position: relative;text-align: center'><div data-index='" + sort + "' class='triangle-right'></div></div>");
                    htmlData.push("<div style='height: 31px;position: relative;text-align: center'><div data-index='" + (sort + 1) + "' class='triangle-right'></div></div>");
                    htmlData.push("<div style='height: 31px;position: relative;text-align: center'><div data-index='" + (sort + 2) + "' class='triangle-right'></div></div>");
                    htmlData.push("<div style='height: 31px;position: relative;text-align: center'><div data-index='" + (sort + 3) + "' class='triangle-right'></div></div>");
                    htmlData.push("<div style='height: 31px;position: relative;text-align: center'><div data-index='" + (sort + 4) + "' class='triangle-right'></div></div>");
                    htmlData.push("<div style='height: 31px;position: relative;text-align: center'><div data-index='" + (sort + 5) + "' class='triangle-right'></div></div>");
                    htmlData.push("<div style='height: 31px;position: relative;text-align: center'><div data-index='" + (sort + 6) + "' class='triangle-right'></div></div>");
                    htmlData.push("<div style='height: 31px;position: relative;text-align: center'><div data-index='" + (sort + 7) + "' class='triangle-right'></div></div>");
                    htmlData.push("<div style='height: 31px;position: relative;text-align: center'><div data-index='" + (sort + 8) + "' class='triangle-right'></div></div>");
                    htmlData.push("<div style='height: 31px;position: relative;text-align: center'><div data-index='" + (sort + 9) + "' class='triangle-right'></div></div>");

                    htmlData.push("</div>");
                }

                htmlData.push("<div class='game_con' style='width: 174px'>");
                htmlData.push("<fieldset>");
                // htmlData.push("<legend>二字定</legend>");
                htmlData.push("<ul>");


                for (var k = 0; k <= 9; k++) {
                    var sort2 = sort + k;

                    var bianse = 1 == "1" ? "style='color:blue;'" : "";
                    disabled = G.DecimalSign(true) ? "" : "disabled='disabled'";
                    htmlData.push("<li data-sort='" + sort2 + "' data-title='" + _sscnum1(sort2) + "' data-name='" + getDwNameByType(sort2) + "'>");
                    htmlData.push("<span class='name bf_12' style='width: 33px'>" + getDwNameByType(sort2) + "</span>");
                    htmlData.push("<span class='p'><a class='oddsEvent' " + bianse + " title='点击下注'>" + (Math.random() * 100).toFixed(1) + "</a></span>");
                    htmlData.push("<span class='in'><input class='input onlyNum orderInput' type='text' " + disabled + " maxlength='7'></span>");
                    htmlData.push("</li>");
                }

                htmlData.push("</ul>");
                htmlData.push("</fieldset>");
                htmlData.push("</div>");
                htmlData.push("</div>");
            }

            htmlData.push("<table class=\"t_dw\" id=\"bd_fix\"> " +
                "<tbody>" +
                "<tr> " +
                "<td width=\"100%\"> " +
                "<table class=\"t_dw\"> " +
                "<tbody>" +
                "<tr> " +
                "<td rowspan=\"2\" style='text-align: center' width=\"50\">定位置</td> " +
                "<td class='fn-fix' id='fix_1' style='padding-left: 5px'> " + titiles[type - 9][0] + " " +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"0\">0</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"1\">1</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"2\">2</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"3\">3</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"4\">4</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"5\">5</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"6\">6</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"7\">7</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"8\">8</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"9\">9</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"10\">单</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"11\">双</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"12\">大</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"13\">小</a> " +
                "</td> " +
                "<td rowspan=\"2\" style='text-align: center' width=\"40\">合分</td> " +
                "<td rowspan=\"2\" class=\"fn-hf\" id='fn-hf'> " +
                "<div style='margin-left: 5px'> " +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"0\">0</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"1\">1</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"2\">2</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"3\">3</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"4\">4</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"10\">单</a>" +
                "</div> " +
                "<div style='margin-left: 5px'> " +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"5\">5</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"6\">6</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"7\">7</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"8\">8</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"9\">9</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"11\">双</a>" +
                "</div> " +
                "</td> " +
                "<td><span style='margin-left: 5px'>" + titiles[type - 9][0] + "位</span> " +
                "<input id='ipdw_1' type=\"number\"  index=\"1\" >" +
                "</td> " +
                "</tr> " +
                "<tr> " +
                "<td class='fn-fix' id='fix_2' style='padding-left: 5px'> " + titiles[type - 9][1] + " " +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"0\">0</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"1\">1</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"2\">2</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"3\">3</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"4\">4</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"5\">5</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"6\">6</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"7\">7</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"8\">8</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"9\">9</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"10\">单</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"11\">双</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"12\">大</a>" +
                "<a class=\"kxbtn\" style='margin-left: 2px' name=\"13\">小</a> " +
                "</td> " +
                "<td><span style='margin-left: 5px'>" + titiles[type - 9][1] + "位</span> " +
                "<input id='ipdw_2' type=\"number\" index=\"2\" >" +
                "</td>" +
                " </tr> " +
                "</tbody>" +
                "</table>" +
                " </td>" +
                " </tr>  </tbody></table>");


        }
    }
    else if (gameIndex == 4 || gameIndex == 8) { //PK10
        var _dpk = function (index) { switch (index) { case 1: return "冠军"; case 2: return "亚军"; case 3: return "第三名"; case 4: return "第四名"; case 5: return "第五名"; case 6: return "第六名"; case 7: return "第七名"; case 8: return "第八名"; case 9: return "第九名"; case 10: return "第十名"; } };
        if (type == 2) {
            for (var i = 0; i < 10; i++) {
                if (i > 0)
                    sortIndex = i * 16;
                else
                    sortIndex = 0;
                htmlData.push("<div class='game_box col_1 gameBox base-clear'>");
                htmlData.push("<div class='game_con'>");
                htmlData.push("<fieldset>");
                htmlData.push("<legend>" + _dpk((i + 1)) + "</legend>");
                htmlData.push("<ul>");
                for (var n = 22; n <= 31; n++) {
                    sort = n + sortIndex;
                    disabled = G.DecimalSign(oddsList[sort]) ? "" : "disabled='disabled'";
                    htmlData.push("<li data-sort='" + sort + "' data-title='" + _pknum1(sort) + "' data-name='" + _pknum2(sort) + "'>");
                    htmlData.push("<span class='name'><i class='PKNo_" + (n - 21) + "'></i></span>");
                    htmlData.push("<span class='p'><a class='oddsEvent' title='点击下注' href='javascript:;'>" + oddsList[sort] + "</a></span>");
                    htmlData.push("<span class='in'><input class='input onlyNum orderInput' type='text' " + disabled + " maxlength='7'></span>");
                    htmlData.push("</li>");
                }
                htmlData.push("</ul>");
                htmlData.push("</fieldset>");
                htmlData.push("</div>");
                htmlData.push("</div>");
            }
        } else if (type == 3) {
            htmlData.push("<div class='game_box col_5 gameBox base-clear'>");
            htmlData.push("<div class='game_con'>");
            htmlData.push("<fieldset>");
            htmlData.push("<legend>冠、亞軍和</legend>");
            htmlData.push("<ul>");
            for (var n = 1; n <= 17; n++) {
                sort = n;
                disabled = G.DecimalSign(oddsList[sort]) ? "" : "disabled='disabled'";
                htmlData.push("<li data-sort='" + sort + "' data-title='" + _pknum1(sort) + "' data-name='" + _pknum2(sort) + "'>");
                htmlData.push("<span class='name bf_14'>" + _pknum2(sort) + "</span>");
                htmlData.push("<span class='p'><a class='oddsEvent' title='点击下注' href='javascript:;'>" + oddsList[sort] + "</a></span>");
                htmlData.push("<span class='in'><input class='input onlyNum orderInput' type='text' " + disabled + " maxlength='7'></span>");
                htmlData.push("</li>");
            }
            htmlData.push("</ul>");
            htmlData.push("</fieldset>");
            htmlData.push("</div>");
            htmlData.push("</div>");

            htmlData.push("<div class='game_box base-clear'>");
            htmlData.push("<div class='game_con'>");
            htmlData.push("<fieldset>");
            htmlData.push("<legend>單雙、大小</legend>");
            htmlData.push("<ul>");
            for (var n = 18; n <= 21; n++) {
                sort = n;
                disabled = G.DecimalSign(oddsList[sort]) ? "" : "disabled='disabled'";
                htmlData.push("<li data-sort='" + sort + "' data-title='" + _pknum1(sort) + "' data-name='" + _pknum2(sort) + "'>");
                htmlData.push("<span class='name'>" + _pknum1(sort) + _pknum2(sort) + "</span>");
                htmlData.push("<span class='p'><a class='oddsEvent' title='点击下注' href='javascript:;'>" + oddsList[sort] + "</a></span>");
                htmlData.push("<span class='in'><input class='input onlyNum orderInput' type='text' " + disabled + " maxlength='7'></span>");
                htmlData.push("</li>");
            }
            htmlData.push("</ul>");
            htmlData.push("</fieldset>");
            htmlData.push("</div>");
            htmlData.push("</div>");


        } else if (type == 4) {

            for (var i = 0; i < 5; i++) {
                if (i > 0)
                    sortIndex = i * 16;
                else
                    sortIndex = 0;
                htmlData.push("<div class='game_box col_1 gameBox base-clear'>");
                htmlData.push("<div class='game_con'>");
                htmlData.push("<fieldset>");
                htmlData.push("<legend>" + _dpk((i + 1)) + "</legend>");
                htmlData.push("<ul>");
                for (var n = 22; n <= 31; n++) {
                    sort = n + sortIndex;
                    disabled = G.DecimalSign(oddsList[sort]) ? "" : "disabled='disabled'";
                    htmlData.push("<li data-sort='" + sort + "' data-title='" + _pknum1(sort) + "' data-name='" + _pknum2(sort) + "'>");
                    htmlData.push("<span class='name'><i class='PKNo_" + (n - 21) + "'></i></span>");
                    htmlData.push("<span class='p'><a class='oddsEvent' title='点击下注' href='javascript:;'>" + oddsList[sort] + "</a></span>");
                    htmlData.push("<span class='in'><input class='input onlyNum orderInput' type='text' " + disabled + " maxlength='7'></span>");
                    htmlData.push("</li>");
                }
                for (var n = 0; n < 2; n++) {
                    disabled = G.DecimalSign(oddsList[sort + 5 + n]) ? "" : "disabled='disabled'";
                    htmlData.push("<li data-sort='" + (sort + 5 + n) + "' data-title='" + _pknum1(sort + 5 + n) + "' data-name='" + _pknum2(sort + 5 + n) + "'>");
                    htmlData.push("<span class='name'>" + _pknum2(sort + 5 + n) + "</span>");
                    htmlData.push("<span class='p'><a class='oddsEvent' title='点击下注' href='javascript:;'>" + oddsList[sort + 5 + n] + "</a></span>");
                    htmlData.push("<span class='in'><input class='input onlyNum orderInput' type='text' " + disabled + " maxlength='7'></span>");
                    htmlData.push("</li>");
                }


                htmlData.push("</ul>");
                htmlData.push("<div class='dsdx' style='width: 168px;text-align: center;display: inline-block;margin-top: 5px'>");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' href=\"javascript:void(0)\">单</a>");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' style='margin-left: 5px' href=\"javascript:void(0)\">双</a> ");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' style='margin-left: 5px' href=\"javascript:void(0)\">大</a>");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' style='margin-left: 5px' href=\"javascript:void(0)\">小</a> ");
                htmlData.push("</div>");
                htmlData.push("</fieldset>");
                htmlData.push("</div>");
                htmlData.push("</div>");
            }
        } else if (type == 5) {
            for (var i = 5; i < 10; i++) {
                if (i > 0)
                    sortIndex = i * 16;
                else
                    sortIndex = 0;
                htmlData.push("<div class='game_box col_1 gameBox base-clear'>");
                htmlData.push("<div class='game_con'>");
                htmlData.push("<fieldset>");
                htmlData.push("<legend>" + _dpk((i + 1)) + "</legend>");
                htmlData.push("<ul>");
                for (var n = 22; n <= 31; n++) {
                    sort = n + sortIndex;
                    disabled = G.DecimalSign(oddsList[sort]) ? "" : "disabled='disabled'";
                    htmlData.push("<li data-sort='" + sort + "' data-title='" + _pknum1(sort) + "' data-name='" + _pknum2(sort) + "'>");
                    htmlData.push("<span class='name'><i class='PKNo_" + (n - 21) + "'></i></span>");
                    htmlData.push("<span class='p'><a class='oddsEvent' title='点击下注' href='javascript:;'>" + oddsList[sort] + "</a></span>");
                    htmlData.push("<span class='in'><input class='input onlyNum orderInput' type='text' " + disabled + " maxlength='7'></span>");
                    htmlData.push("</li>");
                }
                htmlData.push("</ul>");
                htmlData.push("<div class='dsdx' style='width: 168px;text-align: center;display: inline-block;margin-top: 5px'>");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' href=\"javascript:void(0)\">单</a>");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' style='margin-left: 5px' href=\"javascript:void(0)\">双</a> ");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' style='margin-left: 5px' href=\"javascript:void(0)\">大</a>");
                htmlData.push("<a data-index='" + i + "' class='kxbtn' style='margin-left: 5px' href=\"javascript:void(0)\">小</a> ");
                htmlData.push("</div>");
                htmlData.push("</fieldset>");
                htmlData.push("</div>");
                htmlData.push("</div>");
            }
        }
    }


    htmlData.push("</div>"); //game_ball_wrap end
    game_loading_wrap(false);
    $("#gameBox").html(htmlData.join(""));

    var gameBoxTool = "<div class=\"tool_left\">" +
        "<div id=\"tool_ys_wrap\" class=\"t_left\">" +
        "<label for=\"tool_ys_input\">快捷下注金额：</label><input id=\"tool_ys_input\" class=\"input onlyNum\" maxlength='5' type=\"text\"><i id=\"close\" style=\"display: none;\">x</i>\n" +
        "<span><a href=\"javascript:void(0)\">50</a> <a href=\"javascript:void(0)\">100</a> <a href=\"javascript:void(0)\">200</a> <a href=\"javascript:void(0)\">500</a> <a href=\"javascript:void(0)\">1000</a></span>\n" +
        "<em><b>+</b>" +
        "<strong>\n" +
        "<input class=\"input onlyNum\" type=\"text\">" +
        "<input class=\"input onlyNum\" type=\"text\">" +
        "<input class=\"input onlyNum\" type=\"text\">" +
        "<input class=\"input onlyNum\" type=\"text\">" +
        "<input class=\"input onlyNum\" type=\"text\">" +
        "<div class=\"base-clear\"></div>" +
        "<input class=\"btn\" type=\"button\" value=\"确定\">" +
        "</strong>" +
        "</em>" +
        "</div>" +
        "</div>" +
        "<div class=\"t_right\">" +
        "<input id=\"clearBtn\" class=\"btn grayBtn\" type=\"button\" value=\"重填\">" +
        "<input id=\"gameSubmit\" class=\"btn hotBtn disSubmit\" type=\"button\" value=\"提交\">" +
        "</div>";

    $("#gameBoxTool").html(gameBoxTool);

    bindGameFun(); //注冊相關函數，單筆下注，多筆下注，重置，提交下注
    gameBoxTitleClick();
    gameTitleClick();

    $("#subNavList a[data-action]").unbind("click").click(function () {
        S.loadingWrap = true;
        $("#result2").remove();
        var data_action = $(this).attr("data-action");
        middleBind({ data_action: data_action });
    });

}
const gameBoxTitleClick = () => {
    $("#game_box_title a[data-action]").unbind("click").click(function () {
        S.loadingWrap = true;
        $("#result2").remove();
        var data_action = $(this).attr("data-action");
        middleBind({ data_action: data_action });
    });
}
const gameTitleClick = () => {
    $("#gameTitle li").unbind("click").click(function () {
        if (!S.stop) {
            return false;
        }
        $("#gameBox li span.in a.radioSim").removeClass("radioPoint");
        $("#gameTitle li").removeClass("active");
        $(this).addClass("active");
        if ($(this).attr("data-mysort")) {
            var sort, myodds;
            var data_dow = $(this).attr("data-dow");
            var mystr = $(this).find("h3").html();
            var data_mysort = parseInt($(this).attr("data-mysort"));
            var gameIndex = $("#menuText").attr("data-index");
            if (gameIndex == 1) {
                if (data_mysort == 154 || data_mysort >= 676 && data_mysort <= 679) {
                    myodds = $(this).find("h4").html();
                    if (!G.DecimalSign(myodds)) {
                        myodds = "-";
                        $("#gameBox li span.in a.radioSim").addClass("radiodsable");
                    } else {
                        $("#gameBox li span.in a.radioSim").removeClass("radiodsable");
                    }
                    $("#gameBox li span.p a.red").html(myodds);
                }
            } else if (gameIndex == 2) {
                if (data_mysort == 323 || data_mysort == 324 || data_mysort == 325 || data_mysort == 326 || data_mysort == 327 || data_mysort == 328 || data_mysort == 329) {
                    myodds = $(this).find("h4").html();
                    if (!G.DecimalSign(myodds)) {
                        $("#gameBox li span.in a.radioSim").addClass("radiodsable");
                    } else {
                        $("#gameBox li span.in a.radioSim").removeClass("radiodsable");
                    }
                    $("#gameBox legend").html(mystr);
                }
            } else if (gameIndex == 13) {
                if (data_mysort == -1) {
                    $("#gameBox li.auto").addClass("hiden");
                    $("#gameBox li." + data_dow).removeClass("hiden");
                    $("#clearBtn").click();
                }
            }
        }
        var data_action = $(this).attr("data-action"); //參數判斷是否重新加載數據
        if (data_action) {
            S.loadingWrap = true;
            middleBind({ data_action: data_action });
        }
    });
}
const bindGameFun = () => {
    var gameIndex = $("#menuText").attr("data-index");
    var obj = $("#gameBox");
    obj.find("input[type='text']").keyup(function () {
        //$(this).val($(this).val().replace(/^\d+(\.\d+)?$/g, ''));
        G.clearNoNum($(this));
    });
    obj.find("input[type='text']").focus(function () {
        if (!$(this).hasClass("check")) {
            $(this).val($("#tool_ys_input").val());
            $(this).addClass("check");
        } else {
            $(this).val("");
            $(this).removeClass("check");
        }
    });
    obj.find("li span.p a.oddsEvent").unbind("click").click(function () {
        var n1 = $(this).parents("li").attr("data-title");
        var n2 = $(this).parents("li").attr("data-name");
        var sort = $(this).parents("li").attr("data-sort");
        var odds = $(this).html();
        myWarp({ gameIndex: gameIndex, odds: odds, n1: n1, n2: n2, sort: sort, obj: $(this) });
    });
    //勾选項
    obj.find("li span.in a").unbind("click").click(function () {
        var myclass = $(this).attr("class");
        var mymax = parseInt($("#gameTitle li.active").attr("data-max"));
        if (myclass.indexOf("radiodsable") == -1) {
            if (myclass.indexOf("radioPoint") == -1) {
                $(this).addClass("radioPoint");
                enachRadioPoint($(this), mymax);
            } else {
                $(this).removeClass("radioPoint");
            }
        }
    });

    $("#clearBtn").unbind("click").click(function () {
        obj.find("input[type='text']").val("").removeClass("check");
        $("#gameBox li span.in a.radioSim").removeClass("radioPoint");
        obj.find("a[class='kxhotbtn']").each(function () {
            $(this).attr("class", "kxbtn");
        });
        $("#ipdw_1").val("");
        $("#ipdw_2").val("");
    });
    var data_type = parseInt(G.query("type", "?" + $("#game_box_title li.active a").attr("data-action")));
    $("#gameSubmit").unbind("click").click(function () {
        alert(1231)
        if (gameIndex == 1 && (data_type == 4 || data_type == 16 || data_type == 22 || data_type == 29)) {
            gameHxSubmit(data_type);
        } else if ((gameIndex == 2 || gameIndex == 7) && data_type == 12) {
            gameHxSubmit(data_type);
        } else {
            gameSubmit();
        }
    });
    obj.find("input[type='text']").keydown(function (e) {
        var curKey = e.which;
        if (curKey == 13) {
            $("#gameSubmit").click();
            return false;
        }
    });

    obj.find("div[class='dsdx'] a").unbind("click").click(function () {
        var classAttr = $(this).attr("class");
        var check;
        if (classAttr == "kxhotbtn") {
            $(this).attr("class", "kxbtn");
            check = false;
        }
        else {
            $(this).attr("class", "kxhotbtn");
            check = true;
        }

        selectDSDX(obj, $(this).attr("data-index"));


    });

    obj.find("table[class='t_dw'] a").unbind("click").click(function () {
        var classAttr = $(this).attr("class");
        if (classAttr == "kxhotbtn") {
            $(this).attr("class", "kxbtn");
        }
        else {
            $(this).attr("class", "kxhotbtn");
        }
        selectDW(obj, this);

    });
    obj.find("table[class='t_dw'] input").keyup(function () {
        selectDW(obj, $(this));
    });

    obj.find("div[class='triangle-topleft']").unbind("click").click(function () {
        var sort = $(this).attr("data-index");
        for (var n = 0; n < 10; n++) {

            if (!obj.find("li[data-sort='" + sort + "'] input[type='text']").hasClass("check")) {
                obj.find("li[data-sort='" + sort + "'] input[type='text']").val($("#tool_ys_input").val());
                obj.find("li[data-sort='" + sort + "'] input[type='text']").addClass("check");
            } else {
                obj.find("li[data-sort='" + sort + "'] input[type='text']").val("");
                obj.find("li[data-sort='" + sort + "'] input[type='text']").removeClass("check");
            }
            sort++;
        }
    });

    obj.find("div[class='triangle-right']").unbind("click").click(function () {
        var sort = $(this).attr("data-index");
        sort = parseInt(sort);
        for (var n = 0; n < 10; n++) {

            if (!obj.find("li[data-sort='" + sort + "'] input[type='text']").hasClass("check")) {
                obj.find("li[data-sort='" + sort + "'] input[type='text']").val($("#tool_ys_input").val());
                obj.find("li[data-sort='" + sort + "'] input[type='text']").addClass("check");
            } else {
                obj.find("li[data-sort='" + sort + "'] input[type='text']").val("");
                obj.find("li[data-sort='" + sort + "'] input[type='text']").removeClass("check");
            }
            sort += 10;
        }
    });


    //快捷下注金额
    $("#tool_ys_wrap input[type='text']").focus(function () {
        $(this).val("");
    });
    $("#tool_ys_wrap input[type='text']").keyup(function () {
        G.clearNoNum($(this));
        //$(this).val($(this).val().replace(/[^0-9]/g, ''));
        /*if ($(this).attr("id") == "tool_ys_input") {
        $("#gameBox input.check").val($(this).val()); //改变下注金额盘
        }*/
    });
    $("#tool_ys_wrap span a").unbind("click").click(function () {
        var val = $(this).html();
        var mycheck = $("#gameBox input.check");
        $("#tool_ys_input").val(val);
        mycheck.each(function () {
            if ($(this).val() == "") {
                $(this).val(val);
            }
        });
    });
    $("#tool_ys_wrap em b").unbind("click").click(function () {
        var ary = [];
        $("#tool_ys_wrap span a").each(function (i) {
            ary[i] = $(this).html();
        });
        $("#tool_ys_wrap em strong input[type='text']").each(function (i) {
            $(this).val(ary[i]);
        });
        $("#tool_ys_wrap em strong").css("display", "block");
    });
    $("#tool_ys_wrap em strong input[type='button']").unbind("click").click(function () {
        var ary = [];
        $("#tool_ys_wrap em strong input[type='text']").each(function (i) {
            ary[i] = $(this).val();
        });
        $("#tool_ys_wrap span a").each(function (i) {
            $(this).html(ary[i]);
        });
        $("#tool_ys_wrap em strong").css("display", "none");
    });
}

const middleBind = (msg) => {
    if (msg.data_action && S.stop) {
        S.stop = false;
        if (S.request) { //中断AJAX连接
            S.request.abort();
        }
        if (S.intervalTime) { //关闭setInterval
            clearInterval(S.intervalTime);
        }
        if (S.intervalOpenTime) {
            clearInterval(S.intervalOpenTime);
        }

        //加载模块
        var actionAry = msg.data_action.split("&");
        if ((G.isAction({ key: "Result", ary: actionAry }) || G.isAction({ key: "UserInfo", ary: actionAry })
            || G.isAction({ key: "BetDetails", ary: actionAry }) || G.isAction({ key: "IssueHistory", ary: actionAry })
        ) && !G.query("gameIndex", "?" + msg.data_action)) {
            msg.data_action = msg.data_action + "&gameIndex=" + $("#menuText").attr("data-index");
        }

        if (!G.query("gameIndex", "?" + msg.data_action)) msg.data_action = msg.data_action + "&gameIndex=" + $("#menuText").attr("data-index");

        if (G.isAction({ key: "BetDetails", ary: actionAry }) || G.isAction({ key: "IssueHistory", ary: actionAry }) || G.query("type", "?" + msg.data_action) <= 19) {
            $("#rightBox").html("");
        }

        try {
            eval(actionAry[0] + '({data_action: msg.data_action})');

        } catch (e) { }
        S.intervalTime = setTimeout(function () { S.stop = true; }, 700);
    }
    var data_action = "member" + msg.data_action;
    var gameIndex = G.query("gameIndex", "?" + msg.data_action);
    var type = G.query("type", "?" + msg.data_action);
    GameMiddle({ gameIndex: gameIndex, type: type });
}

const submitData = (bet) => {
    let str = "";
    for (let i = 0; i < bet.length; i++) {
        if (i !== bet.length - 1) {
            str += bet[i].split(":")[0] + ",";
        } else {
            str += bet[i].split(":")[0];
        }
    }


    let data = {};
    data.access_token = window.sessionStorage.getItem("login").split("&")[0];
    data.uid = window.sessionStorage.getItem("login").split("&")[1];
    data.game_code = window.sessionStorage.getItem("code");
    if ($(".subBtn.active").find("a").html() == "一字定") {
        data.play_code = "D1W";
    } else {
        data.play_code = "D2W";
    }
    data.key = (new Date()).valueOf();
    data.play_type = "zhixuan";
    data.bet_money = bet[0].split(":")[1];
    data.total_money = bet[0].split(":")[1] * bet.length;
    data.bet_num = bet.length;
    data.bet_str = str;
    data.bet_log = "游戏日志";
    data.bet_qihao = window.sessionStorage.getItem("qiNum");
    getData.default.postAxiosMethod("bet", data, res => {
        container()
        let isPlayer = sessionStorage.getItem('Voice')
        if(isPlayer == 1){
            document.getElementById('bgm').play()
        }
    });
    $("#tool_ys_input").val("");
    $("#tool_hm_input").val("");
    $("#spanPeilv").html("");
    $("#spankxje").html("");
    $("#mymask").remove();
    $(".input.onlyNum.orderInput").each((index, item) => {
        item.className = "input onlyNum orderInput";
        item.value = "";
    })
    $("#myWarpr_alert").css('display', 'none');
}
const kdjstj = (scu) => {

    let data = {};
    data.access_token = window.sessionStorage.getItem("login").split("&")[0];
    data.uid = window.sessionStorage.getItem("login").split("&")[1];
    data.game_code = window.sessionStorage.getItem("code");
    data.play_code = "";
    data.key = (new Date()).valueOf();
    data.play_type = "kuaida";
    data.bet_money = $("#tool_ys_input").val();
    data.total_money = $("#tool_ys_input").val();
    data.bet_num = "1";
    data.bet_str = $("#tool_hm_input").val()+":"+$("#tool_ys_input").val();
    data.bet_log = "游戏日志";
    data.bet_qihao = window.sessionStorage.getItem("qiNum");
    getData.default.postAxiosMethod("bet", data, res => {
        scu(res.data.data);
        container()
        let isPlayer = sessionStorage.getItem('Voice')
        if(isPlayer == 1){
            document.getElementById('bgm').play()
        }
    });
    $("#tool_ys_input").val("");
    $("#tool_hm_input").val("");
    $("#spanPeilv").html("");
    $("#spankxje").html("");

}

function normalizeDWTypeName(name) {
    name = (name || "").toString().toUpperCase();
    var profile = getQuickGameProfile();
    if (profile.count == 3 && name.length == 3) return "XX" + name;
    if (profile.count == 4 && name.length == 4) return "X" + name;
    if (name.length == 4) return name + "X";
    return name;
}

function getDWTypeByName( name){
    name = normalizeDWTypeName(name);
    //一字定
    if (name.match("\\dXXXX")){
        return parseInt(name[0]) + 1;
    } else if (name.match("X\\dXXX")){
        return parseInt(name[1])  + 15;
    }else if (name.match("XX\\dXX")){
        return parseInt(name[2]) + 29;
    }else if (name.match("XXX\\dX")){
        return parseInt(name[3]) + 43;
    }else if (name.match("XXXX\\d")){
        return parseInt(name[4]) + 57;
    }
    //二字定
    else if (name.match("\\d{2}XXX")){
        return 108 + parseInt(name[0]) * 10 + parseInt(name[1]);
    }else if (name.match("\\dX\\dXX")){
        return 208 + parseInt(name[0]) * 10 + parseInt(name[2]);
    }else if (name.match("\\dXX\\dX")){
        return 308 + parseInt(name[0]) * 10 +parseInt(name[3]);
    }else if (name.match("\\dXXX\\d")){
        return 408 + parseInt(name[0]) * 10 + parseInt(name[4]);
    }else if (name.match("X\\d{2}XX")){
        return 508 + parseInt(name[1]) * 10 + parseInt(name[2]);
    }else if (name.match("X\\dX\\dX")){
        return 608 + parseInt(name[1]) * 10 + parseInt(name[3]);
    }else if (name.match("X\\dXX\\d")){
        return 708 + parseInt(name[1]) * 10 + parseInt(name[4]);
    }else if (name.match("XX\\d{2}X")){
        return 808 + parseInt(name[2]) * 10 + parseInt(name[3]);
    }else if (name.match("XX\\dX\\d")){
        return 908 + parseInt(name[2]) * 10 + parseInt(name[4]);
    }else if (name.match("XXX\\d\\d")){
        return 1008 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }

    //三字定
    else if (name.match("\\d{3}XX")){
        return 1108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[2]);
    }else if (name.match("\\d{2}X\\dX")){
        return 2108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[3]);
    }else if (name.match("\\d{2}XX\\d")){
        return 3108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[4]);
    }else if (name.match("\\dX\\d{2}X")){
        return 4108 + parseInt(name[0]) * 100 + parseInt(name[2]) * 10 + parseInt(name[3]);
    }else if (name.match("\\dX\\dX\\d")){
        return 5108 + parseInt(name[0]) * 100 + parseInt(name[2]) *10 + parseInt(name[4]);
    }else if (name.match("\\dXX\\d{2}")){
        return 6108 + parseInt(name[0]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }else if (name.match("X\\d{3}X")){
        return 7108 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[3]);
    }else if (name.match("X\\d{2}X\\d")){
        return 8108 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[4]);
    }else if (name.match("X\\dX\\d{2}")){
        return 9108 + parseInt(name[1]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }else if (name.match("XX\\d{3}")){
        return 10108 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }

    else if (name.match("\\d{4}X")){
        return 11108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[2]) *  10 + parseInt(name[3]);
    }else if (name.match("\\d{3}X\\d")){
        return 21108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[4]);
    }else if (name.match("\\d{2}X\\d{2}")){
        return 31108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }else if (name.match("\\dX\\d{3}")){
        return 41108 + parseInt(name[0]) * 1000 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }else if (name.match("X\\d{4}")){
        return 51108 + parseInt(name[1]) * 1000 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }


    return 0;

}

function container(printAry) {
    var myDiv = "<div id='tip_container' class='container tip_container' style='width: 120px; margin-left:-55px; margin-top:55px;display:block'><div id='tip' class='success mtip'><i class='micon'></i><span id='tsc'>下注成功！</span><i id='mclose' class='mclose'></i></div></div>";
    $("#tip_container").remove();
    $("body").append(myDiv);
    setTimeout(function () {
        $("#tip_container").remove();
        if (printAry && printAry.length > 0) {
            var ary = [], key;
            for (var i = 0; i < printAry.length; i++) {
                key = printAry[i].split(":");
                ary.push(encodeURI("【" + key[5] + "】<br />【第" + key[6] + "期】<br />" + key[1] + "【" + key[2] + "】 @ <strong class=\"red\"> " + key[3] + "</strong><br />下注金额：<strong class=\"blue\">" + key[4] + "</strong>"));
            }
            myPrint(null, ary.join("êêê"));
        }
    }, 500);
    $(".rightBox div.left li").removeClass("active");//.removeAttr("style");
    $(".rightBox div.right ul").removeClass("active");
    $(".rightBox div.left li[name='putResult']").addClass("active");
    $(".rightBox div.right #putResult").addClass("active");
}
module.exports = {
    G,
    printLastbet,
    clearUserInfo,
    showChangeSky,
    setDefault,
    agreed,
    searchBtn,
    loginOper,
    logined,
    createNum,
    defaultPosition,
    moveGg,
    changeXz,
    coverTime,
    yzdMethod,
    gameSubmit,
    soundSwitch,
    DataTime,
    kxcontent,
    kd,
    submitData,
    kdjstj
}
